import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Progress, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, TabContent, TabPane } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import "moment/locale/id";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { api } from "../../../config";
import ModalImage from "react-modal-image";
import { QRCodeSVG } from "qrcode.react";
import CurrencyInput from "react-currency-input-field";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { getAgent, resetAgentState } from "../../../store/agent/action";
import { getCivilBudget, resetCivilBudgetState } from "../../../store/civilBudget/action";
import { getBank } from "../../../store/bank/action";
import { getBankBranch } from "../../../store/bankBranch/action";
import { resetCustomerState, getCustomer as onGetCustomers, addNewCustomer as onAddNewCustomer, updateCustomer as onUpdateCustomer, deleteCustomer as onDeleteCustomer, getCustomerLoading } from "../../../store/customer/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetSalesPromoState, getSalesPromo } from "../../../store/salesPromo/action";
import { resetApplicantDocumentState, getApplicantDocument } from "../../../store/applicantDocument/action";
import { resetCivilProgressionState, getCivilProgression } from "../../../store/civilProgression/action";
import { getIdentityType } from "../../../store/identityType/action";
import { resetTransactionTaxState, getTransactionTax } from "../../../store/transactionTax/action";
import { resetSalesTypeState, getSalesType } from "../../../store/salesType/action";
import { resetSalesState, getSales as onGetSales, addNewSales as onAddNewSales, updateSales as onUpdateSales, deleteSales as onDeleteSales, getSalesLoading, resetSalesCreateState } from "../../../store/sales/action";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getMarital, resetMaritalState } from "../../../store/marital/action";
import { resetApplicantState, getApplicant, addNewApplicant as onAddNewApplicant, updateApplicant as onUpdateApplicant, getApplicantLoading, getApplicantOne } from "../../../store/applicant/action";

import pkn1 from "../../../assets/imagepkn.png";
import pkn2 from "../../../assets/imagepkn2.png";

import logoBtn from "../../../assets/images/btn.png";
import logoTtdHAS from "../../../assets/images/logoTtdHAS.png";
import logoTtdCMS from "../../../assets/images/logoTtdCMS.png";
import logoDark from "../../../assets/images/logo-dark.png";
import logo from "../../../assets/images/logo-sm.png";
import logoHas from "../../../assets/images/LOGO HAS.png";
import logoCms from "../../../assets/images/LOGO CMS.png";
import logoWAP from "../../../assets/images/LOGO WAP.png";
import logoNSP from "../../../assets/images/LOGO NSP.png";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import { ButtonPrint, PrintDoc } from "../Management/PrintDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import { ButtonPrintReceipt, PrintDocReceipt } from "../Management/PrintDocReceipt";
import { ButtonPrintSPR, PrintDocSPR } from "../Management/PrintDocSPR";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { ButtonPrintSPD, PrintDocSPD } from "../Management/PrintDocSPD";
import { ButtonPrintSLP, PrintDocSLP } from "../Management/PrintDocSLP";
import { getAccTrans } from "../../../store/accTrans/action";
import { PrintDocVerivikasi } from "../Management/PrintDocVerifikasi";
import { ButtonPrintWawancara, PrintDocWawancara } from "../Management/PrintDocWawancara";
import { ButtonPrintBAST, PrintDocBAST } from "../Management/PrintDocBAST";
import { ButtonPrintPrasarana, PrintDocPrasarana } from "../Management/PrintDocPrasarana";
import { ButtonPrintPenyerahanData, PrintDocPenyerahanData } from "../Management/PrintDocPenyerahanData";
import { ButtonPrintKuasaDebet, PrintDocKuasaDebet } from "../Management/PrintDocKuasaDebet";
import { ButtonPrintSBUM, PrintDocSBUM } from "../Management/PrintDocSBUM";
import { ButtonPrintStandingIntruction, PrintDocStandingIntruction } from "../Management/PrintDocStandingIntruction";
import { ButtonPrintKekuranganUangMuka, PrintDocKekuranganUangMuka } from "../Management/PrintDocKekuranganUangMuka";
import { ButtonPrintKelompokSasaran, PrintDocKelompokSasaran } from "../Management/PrintDocKelompokSasaran";
import { ButtonPrintPernyataanVerifikasi, PrintDocPernyataanVerifikasi } from "../Management/PrintDocPernyataanVerifikasi";
import { ButtonPrintDaftarKPRSubsidi, PrintDocDaftarKPRSubsidi } from "../Management/PrintDocDaftarKPRSubsidi";
import { ButtonPrintFLPP, PrintDocFLPP } from "../Management/PrintDocFLPP";
import { ButtonPrintPeryataanDevelover, PrintDocPeryataanDevelover } from "../Management/PrintDocPeryataanDeveloper";
import { ButtonPrintBatasanHargaJualRumah, PrintDocBatasanHargaJualRumah } from "../Management/PrintDocBatasanHargaJualRumah";
import { ButtonPrintPermohonanKPRSubsidi, PrintDocPermohonanKPRSubsidi } from "../Management/PrintDocPermohonanKPRSubsidi";
import { ButtonPrintPenyerahanSPTPPH, PrintDocPenyerahanSPTPPH } from "../Management/PrintDocPenyerahanSPTPPH";
import { ButtonPrintBASTRunahUmumTapak, PrintDocBASTRunahUmumTapak } from "../Management/PrintDocBASTRunahUmumTapak";
import { ButtonPrintBASTSarusunUmum, PrintDocBASTSarusunUmum } from "../Management/PrintDocBASTSarusunUmum";
import { ButtonPrintPernyataanVerifikasi2, PrintDocPernyataanVerifikasi2 } from "../Management/PrintDocPernyataanVerifikasi2";
import { ButtonPrintPermohonanKPRSubsidi2, PrintDocPermohonanKPRSubsidi2 } from "../Management/PrintDocPermohonanKPRSubsidi2";
import { ButtonPrintSuratKuasa, PrintDocSuratKuasa } from "../Management/PrintDocSuratKuasa";
import { ButtonPrintSuratKuasaBPHTB, PrintDocSuratKuasaBPHTB } from "../Management/PrintDocSuratKuasaBPHTB";
import { ButtonPrintStikerPlatKPR, PrintDocStikerPlatKPR } from "../Management/PrintDocStikerPlatKPR";
import { ButtonPrintSBUM2, PrintDocSBUM2 } from "../Management/PrintDocSBUM2";
import { ButtonPrintKekuranganUangMuka2, PrintDocKekuranganUangMuka2 } from "../Management/PrintDocKekuranganUangMuka2";

const Sales = (props) => {
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalDate, setModalDate] = useState(false);
  const [modalCustomer, setModalCustomer] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [detailType, setDetailType] = useState(null);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [modalMediaApplicationDoc, setModalMediaApplicationDoc] = useState(false);
  const [modalApplicationDoc, setModalApplicationDoc] = useState(false);
  const [checkDocumentList, setCheckDocumentList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [indexPage, setIndexPage] = useState(0);
  const [modalReceipt, setModalReceipt] = useState(false);
  const [categoryActive, setCategoryActive] = useState(3);
  const [itemName, setItemName] = useState("Print");
  const dispatch = useDispatch();

  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    isApplicantCreated,
    applicants,
    applicantAdded,
    applicantDocuments,
    applicantDocumentLoading,
    identityTypes,
    identityTypeLoading,
    maritals,
    maritalLoading,
    agents,
    agentLoading,
    saless,
    salesAdded,
    isSalesCreated,
    isSalesSuccess,
    loading,
    error,
    customers,
    customerLoading,
    isCustomerCreated,
    isCustomerSuccess,
    customerGroups,
    banks,
    bankLoading,
    bankBranches,
    bankBranchLoading,
    customerGroupsLoading,
    customerAdded,
    branches,
    branchLoading,
    transactionTaxs,
    transactionTaxLoading,
    productVarians,
    productVarianLoading,
    salesTypes,
    salesTypeLoading,
    salesPromos,
    salesPromoLoading,
    civilProgressions,
    civilBudgets,
    applicantOne,
    loadingApplicant,
    accTranss,
    loadingAccTranss,
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    applicantOne: state.Applicant.applicantOne,
    loadingApplicant: state.Applicant.loading,
    applicantDocuments: state.ApplicantDocument.applicantDocuments,
    applicantDocumentLoading: state.ApplicantDocument.loading,
    salesAdded: state.Sales.salesAdded,
    saless: state.Sales.saless,
    loading: state.Sales.loading,
    isSalesCreated: state.Sales.isSalesCreated,
    isSalesSuccess: state.Sales.isSalesSuccess,
    agents: state.Agent.agents,
    agentLoading: state.Agent.loading,
    customers: state.Customer.customers,
    customerAdded: state.Customer.customerAdded,
    isCustomerCreated: state.Customer.isCustomerCreated,
    isCustomerSuccess: state.Customer.isCustomerSuccess,
    customerLoading: state.Customer.loading,
    customerGroups: state.CustomerGroup.customerGroups,
    customerGroupsLoading: state.CustomerGroup.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    transactionTaxs: state.TransactionTax.transactionTaxs,
    transactionTaxLoading: state.TransactionTax.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.Sales.error,
    maritalLoading: state.Marital.loading,
    maritals: state.Marital.maritals,
    identityTypes: state.IdentityType.identityTypes,
    identityTypeLoading: state.IdentityType.loading,
    banks: state.Bank.banks,
    bankLoading: state.Bank.loading,
    bankBranches: state.BankBranch.bankBranches,
    bankBranchLoading: state.BankBranch.loading,
    salesTypes: state.SalesType.salesTypes,
    salesTypeLoading: state.SalesType.loading,
    salesPromos: state.SalesPromo.salesPromos,
    salesPromoLoading: state.SalesPromo.loading,
    isApplicantCreated: state.Applicant.isApplicantCreated,
    applicantAdded: state.Applicant.applicantAdded,
    applicants: state.Applicant.applicants,
    civilProgressions: state.CivilProgression.civilProgressions,
    civilBudgets: state.CivilBudget.civilBudgets,
    accTranss: state.AccTrans.accTranss,
    loadingAccTranss: state.AccTrans.loading,
  }));

  const [salesList, setSalesList] = useState([]);
  const [salesOriginalList, setSalesOriginalList] = useState([]);
  const [salesDoc, setSalesDoc] = useState([]);
  const [sales, setSales] = useState(null);
  const [info, setInfo] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [customerContactItem, setCustomerContactItem] = useState([]);
  const [customerGroupList, setCustomerGroupList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [finalDate, setFinalDate] = useState();
  const [searchType, setSearchType] = useState("");
  const [customer, setCustomer] = useState([]);
  const [maritalList, setMaritalList] = useState([]);
  const [salesTypeList, setSalesTypeList] = useState([]);
  const [salesPromoList, setSalesPromoList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [bankBranchList, setBankBranchList] = useState([]);
  const [identityTypeList, setIdentityTypeList] = useState([]);

  const [applicationDoc, setApplicationDoc] = useState(null);
  const [applicationDocImg, setApplicationDocImg] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [isEditApllicationDoc, setIsEditApllicationDoc] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [approveModalMulti, setApproveModalMulti] = useState(false);
  const [approveFinalModalMulti, setApproveFinalModalMulti] = useState(false);
  const [approveBankModalMulti, setApproveBankModalMulti] = useState(false);
  const [currentProgress, setCurrentProgress] = useState(false);

  const [modalMedia, setModalMedia] = useState(false);
  const [modalMediaCustomer, setModalMediaCustomer] = useState(false);
  const [salesImg, setSalesImg] = useState([]);
  const [salesImgCustomer, setSalesImgCustomer] = useState([]);

  const [receiptAmount, setReceiptAmount] = useState(0);
  const [receiptDate, setReceiptDate] = useState(0);
  const [receiptCode, setReceiptCode] = useState(0);
  const [branchCode, setBranchCode] = useState(0);
  const [receiptName, setReceiptName] = useState(0);
  const [receiptNote, setReceiptNote] = useState(0);

  const [actionType, setActionType] = useState(null);
  const statusBankData = [
    {
      options: [
        { label: "Approved", value: "1" },
        { label: "Reject Banding", value: "2" },
        { label: "Reject", value: "3" },
      ],
    },
  ];

  const statusApplicantData = [
    {
      options: [
        { label: "MANAGEMENT STOCK", value: "MANAGEMENT STOCK" },
        { label: "ANALIS", value: "ANALIS" },
        { label: "PEMBERKASAN", value: "PEMBERKASAN" },
        { label: "BANK", value: "BANK" },
        { label: "SALES", value: "SALES" },
        { label: "KONSUMEN", value: "KONSUMEN" },
        { label: "DIMUSNAHKAN", value: "DIMUSNAHKAN" },
      ],
    },
  ];

  const pekerjaanData = [
    {
      options: [
        { label: "WIRASWASTA", value: "WIRASWASTA" },
        { label: "KARYAWAN SWASTA", value: "KARYAWAN SWASTA" },
        { label: "APARATUR SIPIL NEGARA", value: "APARATUR SIPIL NEGARA" },
        { label: "LAIN-LAIN", value: "LAIN-LAIN" },
      ],
    },
  ];

  const formatDatePrint = (date, withDay = false) => {
    if (withDay) {
      return moment(date).locale("id").format("dddd, DD MMMM YYYY").toUpperCase();
    } else {
      return moment(date).locale("id").format("DD MMMM YYYY").toUpperCase();
    }
  };

  const longTime = (date) => {
    const durasi = moment.duration(moment().diff(moment(date)));
    const tahun = durasi.years();
    const bulan = durasi.months();
    const hari = durasi.days();

    let hasil = "";
    if (tahun > 0) {
      hasil += `${tahun} tahun`;
    }
    if (bulan > 0) {
      if (hasil) hasil += " ";
      hasil += `${bulan} bulan`;
    }
    if (hari > 0) {
      if (hasil) hasil += " ";
      hasil += `${hari} hari`;
    }
    if (tahun === 1 && bulan === 0 && hari === 0) {
      hasil = "1 tahun yang lalu";
    }
    if (tahun === 0 && bulan === 1 && hari === 0) {
      hasil = "1 bulan yang lalu";
    }
    if (tahun === 0 && bulan === 0 && hari === 1) {
      hasil = "1 hari yang lalu";
    }
    if (!hasil) {
      hasil = "-";
    }

    return `${hasil}`;
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredSales = applicants;
      if (type !== "all") {
        filteredSales = applicants.filter((sales) => sales.sales_status && sales.sales_status.name === type);
      }
      setSalesList(filteredSales);
      setSalesOriginalList(filteredSales);
    }
  };

  const toggleProgress = (type) => {
    setCurrentProgress(type);
    let filteredSales = applicants;
    if (type !== "all") {
      filteredSales = applicants.filter((sales) => sales.statusDealId === type && sales.typeId !== 4 && sales.typeId !== 3 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5));
    }
    setSalesList(filteredSales);
  };

  const toggleType = (type) => {
    let filteredSales = applicants;
    if (type !== "all") {
      filteredSales = applicants.filter((sales) => sales.typeId === 3 || sales.typeId === 4);
    }
    setSalesList(filteredSales);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (branchSelected && companySelected) {
      dispatch(getBank());
      dispatch(getBankBranch());
      dispatch(getMarital({ companyId: companySelected?.value }));
      dispatch(getApplicantDocument({ companyId: companySelected?.value }));
      dispatch(getIdentityType());
      handleGetAgent(companySelected?.value);
      handleGetCustomer(companySelected?.value);
      handleGetTransactionTax(companySelected?.value);
      handleGetSalesType(companySelected?.value);
      handleGetSalesPromo(companySelected?.value);

      handleGetApplicant(companySelected?.value, branchSelected?.value);
    }
  }, [branchSelected, companySelected]);

  const handleGetApplicant = (companyId, branchId) => {
    dispatch(resetSalesState());
    dispatch(getApplicant({ companyId: companyId, branchId: branchId }));
  };

  const handleGetSalesType = (id) => {
    dispatch(resetSalesTypeState());
    dispatch(getSalesType({ companyId: id, status: 2 }));
  };

  const handleGetSalesPromo = (id) => {
    dispatch(resetSalesPromoState());
    dispatch(getSalesPromo({ companyId: id, status: 2 }));
  };

  const handleGetProductVariant = (companyId, branchId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, branchId: branchId, type: 1, status: 2, available: true }));
  };

  const handleGetAgent = (companyId) => {
    dispatch(resetAgentState());
    dispatch(getAgent({ companyId: companyId, type: "book" }));
  };

  const handleGetCustomer = (companyId) => {
    dispatch(resetCustomerState());
    dispatch(onGetCustomers({ companyId: companyId }));
  };

  const handleGetCivilBudget = (companyId, branchId) => {
    dispatch(getCivilBudget({ companyId: companyId, branchId: branchId, type: "PROGRESS BANGUNAN" }));
  };

  const handleGetTransactionTax = (companyId) => {
    dispatch(resetTransactionTaxState());
    dispatch(getTransactionTax({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(applicants)) {
      let filteredSales = applicants;
      if (activeTypeTab !== "all") {
        filteredSales = applicants.filter((sales) => sales.sales_status && sales.sales_status.name === activeTypeTab);
      }

      setSalesList(filteredSales.map((el) => ({ ...el, isChecked: false })));
      setSalesOriginalList(filteredSales);
      setInfo(applicants[applicants.length - 1]);
    }
  }, [applicants]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_type",
        label: "Jenis Penjualan",
        isSelected: true,
        data: [],
      },
      {
        id: "status",
        label: "Status Penjualan",
        isSelected: true,
        data: [],
      },
      {
        id: "progres",
        label: "Progres Penjualan",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_customer",
        label: "Debitur",
        isSelected: true,
        data: [],
      },
      {
        id: "nik",
        label: "NIK",
        isSelected: true,
        data: [],
      },
      {
        id: "phone",
        label: "No Telp Debitur",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_agent",
        label: "Marketing",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_detail",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "hoek",
        label: "Hoek",
        isSelected: true,
        data: [],
      },
      {
        id: "process_amount",
        label: "Biaya Proses",
        isSelected: true,
        data: [],
      },
      {
        id: "book_amount",
        label: "Biaya Booking",
        isSelected: true,
        data: [],
      },
      {
        id: "disc_amount",
        label: "Potongan Diskon",
        isSelected: true,
        data: [],
      },
      {
        id: "payment",
        label: "Terbayar",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Tagihan",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_pm",
        label: "VIA",
        isSelected: true,
        data: [],
      },
      {
        id: "bookat",
        label: "Tanggal Booking",
        isSelected: categoryActive === 3 ? true : false,
        data: [],
      },
      {
        id: "officeat",
        label: "Tanggal Kantor",
        isSelected: categoryActive === 4 ? true : false,
        data: [],
      },
      {
        id: "bankat",
        label: "Tanggal Bank",
        isSelected: categoryActive === 5 ? true : false,
        data: [],
      },
      {
        id: "sp3at",
        label: "Tanggal SP3K",
        isSelected: categoryActive === 6 || categoryActive === 7 ? true : false,
        data: [],
      },
      {
        id: "completedat",
        label: "Tanggal Akad",
        isSelected: categoryActive === 8 ? true : false,
        data: [],
      },
      {
        id: "sls_bb",
        label: "Bank",
        isSelected: false,
        data: [],
      },
      {
        id: "bank_no",
        label: "No Rekening",
        isSelected: false,
        data: [],
      },
      {
        id: "credit_amount",
        label: "ACC KPR",
        isSelected: false,
        data: [],
      },
      {
        id: "handling_amount",
        label: "Administrasi",
        isSelected: false,
        data: [],
      },
      {
        id: "payment_customer_no",
        label: "No Pembayaran Konsumen",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_promo",
        label: "Diskon & Promo",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_bank_status",
        label: "Status Bank",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_client",
        label: "Grup Usaha",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_company",
        label: "Perusahaan",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_branch",
        label: "Cabang",
        isSelected: false,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: false,
        data: [],
      },
      {
        id: "description_bank",
        label: "Keterangan Bank",
        isSelected: false,
        data: [],
      },
      {
        id: "birth_place",
        label: "Tempat Lahir",
        isSelected: false,
        data: [],
      },
      {
        id: "birthat",
        label: "Tanggal Lahir",
        isSelected: false,
        data: [],
      },
      {
        id: "address",
        label: "Alamat Debitur",
        isSelected: false,
        data: [],
      },
      {
        id: "ages",
        label: "Usia",
        isSelected: false,
        data: [],
      },
      {
        id: "name_spouse",
        label: "Pasangan Debitur",
        isSelected: false,
        data: [],
      },
      {
        id: "birth_place_spouse",
        label: "Tempat Lahir Pasangan",
        isSelected: false,
        data: [],
      },
      {
        id: "birthat_spouse",
        label: "Tanggal Lahir Pasangan",
        isSelected: false,
        data: [],
      },
      {
        id: "identity_spouse",
        label: "NIK Pasangan",
        isSelected: false,
        data: [],
      },
      {
        id: "job_spouse",
        label: "Pekerjaan Pasangan",
        isSelected: false,
        data: [],
      },
      {
        id: "job_business_name",
        label: "Nama Perusahaan / PT",
        isSelected: false,
        data: [],
      },
      {
        id: "job_business_address",
        label: "Alamat Perusahaan / PT",
        isSelected: false,
        data: [],
      },
    ];

    if (salesList.length > 0) {
      salesList.forEach((sales) => {
        if (sales.isChecked) {
          let first = true;
          let doc = dataDoc.find((d) => d.id === "transaction_no");
          if (doc) doc.data.push(sales.transaction_no);

          doc = dataDoc.find((d) => d.id === "sales_type");
          if (doc) doc.data.push(sales?.sales_type?.name);

          doc = dataDoc.find((d) => d.id === "sales_customer");
          if (doc) doc.data.push(sales?.sales_customer?.name);

          doc = dataDoc.find((d) => d.id === "nik");
          if (doc) doc.data.push(sales?.sls_appl?.identity);

          doc = dataDoc.find((d) => d.id === "phone");
          if (doc) doc.data.push(sales?.sls_appl?.phone);

          doc = dataDoc.find((d) => d.id === "sales_agent");
          if (doc) doc.data.push(sales?.sales_agent?.name);

          doc = dataDoc.find((d) => d.id === "sales_detail");
          if (doc) doc.data.push(sales.sales_detail && sales.sales_detail.length > 0 ? `${sales?.sales_detail[0]?.sales_detail_product?.product_block?.name} - ${sales?.sales_detail[0]?.sales_detail_product?.name}` : ``);

          doc = dataDoc.find((d) => d.id === "hoek");
          if (doc) doc.data.push(sales.sales_detail && sales.sales_detail.length > 0 && sales?.sales_detail[0]?.land_excess ? parseFloat(sales?.sales_detail[0]?.land_excess) : 0);

          doc = dataDoc.find((d) => d.id === "book_amount");
          if (doc) doc.data.push(parseFloat(sales.book_amount || 0));

          doc = dataDoc.find((d) => d.id === "disc_amount");
          if (doc) doc.data.push(parseFloat(sales.disc_amount || 0));

          doc = dataDoc.find((d) => d.id === "process_amount");
          if (doc) doc.data.push(sales.process_amount ? parseFloat(sales.process_amount || 0) : "");

          doc = dataDoc.find((d) => d.id === "sales_pm");
          if (doc) doc.data.push(sales?.sales_pm?.name);

          doc = dataDoc.find((d) => d.id === "bookat");
          if (doc) doc.data.push(sales.transactionat ? handleValidDate(sales.transactionat) : "");

          doc = dataDoc.find((d) => d.id === "officeat");
          if (doc) doc.data.push(sales.docat ? handleValidDate(sales.docat) : "");

          doc = dataDoc.find((d) => d.id === "bankat");
          if (doc) doc.data.push(sales.bankat ? handleValidDate(sales.bankat) : "");

          doc = dataDoc.find((d) => d.id === "sp3at");
          if (doc) doc.data.push(sales.sp3at ? handleValidDate(sales.sp3at) : "");

          doc = dataDoc.find((d) => d.id === "completedat");
          if (doc) doc.data.push(sales.completedat ? handleValidDate(sales.completedat) : "");

          doc = dataDoc.find((d) => d.id === "sls_bb");
          if (doc) doc.data.push(sales?.sls_bb?.name);

          doc = dataDoc.find((d) => d.id === "bank_no");
          if (doc) doc.data.push(sales?.sls_appl?.bank_no);

          doc = dataDoc.find((d) => d.id === "credit_amount");
          if (doc) doc.data.push(parseFloat(sales?.credit_amount || 0));

          doc = dataDoc.find((d) => d.id === "handling_amount");
          if (doc) doc.data.push(parseFloat(sales?.handling_amount || 0));

          doc = dataDoc.find((d) => d.id === "payment_customer_no");
          if (doc) doc.data.push(sales?.payment_customer_no);

          doc = dataDoc.find((d) => d.id === "sales_promo");
          if (doc) doc.data.push(sales?.sales_promo?.name);

          doc = dataDoc.find((d) => d.id === "sales_deal_status");
          if (doc) doc.data.push(sales.typeId !== 3 && sales.typeId !== 4 ? sales?.sales_deal_status?.name : "CASH");

          doc = dataDoc.find((d) => d.id === "sales_bank_status");
          if (doc) doc.data.push(sales?.sales_bank_status?.name);

          doc = dataDoc.find((d) => d.id === "sales_client");
          if (doc) doc.data.push(sales?.sales_client?.name);

          doc = dataDoc.find((d) => d.id === "sales_company");
          if (doc) doc.data.push(sales?.sales_company?.name);

          doc = dataDoc.find((d) => d.id === "sales_branch");
          if (doc) doc.data.push(sales?.sales_branch?.name);

          doc = dataDoc.find((d) => d.id === "description");
          if (doc) doc.data.push(sales?.description);

          doc = dataDoc.find((d) => d.id === "description_bank");
          if (doc) doc.data.push(sales?.description_bank);

          doc = dataDoc.find((d) => d.id === "address");
          if (doc) doc.data.push(sales?.sls_appl?.address);

          doc = dataDoc.find((d) => d.id === "name_spouse");
          if (doc) doc.data.push(sales?.sls_appl?.name_spouse);

          doc = dataDoc.find((d) => d.id === "birth_place");
          if (doc) doc.data.push(sales?.sls_appl?.birth_place);

          doc = dataDoc.find((d) => d.id === "birthat");
          if (doc) doc.data.push(sales?.sls_appl?.birthat ? handleValidDate(sales?.sls_appl?.birthat) : "");

          doc = dataDoc.find((d) => d.id === "ages");
          if (doc) doc.data.push(sales?.sls_appl?.birthat ? moment().diff(moment(sales?.sls_appl?.birthat, "YYYY/MM/DD"), "years") : "");

          doc = dataDoc.find((d) => d.id === "birth_place_spouse");
          if (doc) doc.data.push(sales?.sls_appl?.birth_place_spouse);

          doc = dataDoc.find((d) => d.id === "birthat_spouse");
          if (doc) doc.data.push(sales?.sls_appl?.birthat_spouse ? handleValidDate(sales?.sls_appl?.birthat_spouse) : "");

          doc = dataDoc.find((d) => d.id === "identity_spouse");
          if (doc) doc.data.push(sales?.sls_appl?.identity_spouse);

          doc = dataDoc.find((d) => d.id === "job_spouse");
          if (doc) doc.data.push(sales?.sls_appl?.job_spouse);

          doc = dataDoc.find((d) => d.id === "status");
          if (doc) doc.data.push(sales?.sales_status?.name);

          doc = dataDoc.find((d) => d.id === "progres");
          if (doc) doc.data.push(sales?.sales_deal_status?.name);

          doc = dataDoc.find((d) => d.id === "job_business_name");
          if (doc) doc.data.push(sales?.sls_appl?.job_business_name);

          doc = dataDoc.find((d) => d.id === "job_business_address");
          if (doc) doc.data.push(sales?.sls_appl?.job_business_address);

        }
      });
    }

    setSalesDoc(dataDoc);
  }, [salesList]);

  useEffect(() => {
    if (!isEmpty(maritals)) {
      var data = [];
      var opt = [];
      maritals.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setMaritalList(data);
    }
  }, [maritals]);

  useEffect(() => {
    if (!isEmpty(salesTypes)) {
      var data = [];
      var opt = [];
      salesTypes.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setSalesTypeList(data);
    }
  }, [salesTypes]);

  useEffect(() => {
    if (!isEmpty(salesPromos)) {
      var data = [];
      var opt = [];
      salesPromos.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setSalesPromoList(data);
    }
  }, [salesPromos]);

  useEffect(() => {
    if (!isEmpty(identityTypes)) {
      var data = [];
      var opt = [];
      identityTypes.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setIdentityTypeList(data);
    }
  }, [identityTypes]);

  useEffect(() => {
    if (!isEmpty(banks)) {
      var data = [];
      var opt = [];
      banks.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankList(data);
    }
  }, [banks]);

  useEffect(() => {
    if (!isEmpty(bankBranches)) {
      var data = [];
      var opt = [];
      bankBranches.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankBranchList(data);
    }
  }, [bankBranches]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var opt = [];
      productVarians.forEach((item, key) => {
        const varian = item.pvar_product ? item.pvar_product : "";
        const category = varian.product_category ? varian.product_category.name : "";
        const block = varian.product_block ? varian.product_block.name : "";
        const name = category + " " + block + "-" + varian.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        const priceBook = Math.round(varian?.price_book, 0);
        const land_excess = item.land_excess;
        const land_price = item.land_price;
        const price_handling = item.price_handling;
        var obj = { label: name, name: name, barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId, priceBook: priceBook, land_excess: land_excess, land_price: land_price, price_handling: price_handling };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      productVarianData.push(option);
      setProductList(productVarianData);
    }
  }, [productVarians]);

  useEffect(() => {
    var data = [];
    var opt = [];
    agents.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      const status = item.agent_status && item.agent_status.name;
      var obj = { label: name + " - " + status, value: id, item: item };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);
    setAgentList(data);
  }, [agents]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, sbum: parseFloat(item.sbum) };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(customers)) {
      var customerData = [];
      var opt = [];
      customers.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      customerData.push(option);
    }

    setCustomerList(customerData);
  }, [customers]);

  const handleDeleteSales = () => {
    if (info) {
      dispatch(onDeleteSales(info));
      setDeleteModal(false);
    }
  };

  const handleDeleteFileApplicationDoc = (file) => {
    if (isEdit) {
      const newState = applicationDocImg.map((obj) => {
        if (obj.id === file.id) {
          return { id: file.id, filename: file.filename, originalname: file.originalname, mimetype: file.mimetype, isDeleted: true };
        }
        return obj;
      });
      setApplicationDocImg(newState);
    } else {
      const index = applicationDocImg.findIndex((fl) => fl.filename === file.filename);
      setApplicationDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const toggleApplicationDoc = useCallback(() => {
    if (modalApplicationDoc) {
      dispatch(resetApplicantState());
      setModalApplicationDoc(false);
      setIsEditApllicationDoc(false);
      setIsEdit(false);
      validationApplicationDoc.resetForm();
    } else {
      setModalApplicationDoc(true);
    }
  }, [modalApplicationDoc]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSales(null);
      setApplicationDocImg([]);
      setApplicationDoc([]);
      setCheckDocumentList([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDate = useCallback(() => {
    if (modalDate) {
      setModalDate(false);
      setSales(null);
      validationDate.resetForm();
    } else {
      setModalDate(true);
    }
  }, [modalDate]);

  const toggleCustomer = useCallback(() => {
    if (modalCustomer) {
      setModalCustomer(false);
      setCustomer(null);
      setCustomerContactItem([]);
      setSalesImgCustomer([]);
    } else {
      setModalCustomer(true);
    }
  }, [modalCustomer]);

  const toggleReceipt = useCallback(() => {
    if (modalReceipt) {
      setModalReceipt(false);
    } else {
      setModalReceipt(true);
    }
  }, [modalReceipt]);

  useEffect(() => {
    if (isCustomerCreated) {
      validation.setFieldValue("customer", {
        label: customerAdded.name,
        value: customerAdded.id,
      });
    }
  }, [isCustomerCreated, customerAdded]);

  useEffect(() => {
    if (isApplicantCreated || applicantAdded) {
      setIsEdit(true);
      const idx = salesList.findIndex((sl) => sl.id === info.id);
      if (idx !== -1) salesList[idx].sls_appl = applicantAdded;
      let m = applicantAdded.checked_document ? applicantAdded.checked_document.split(",") : [];
      setCheckDocumentList(m);
    }
  }, [isApplicantCreated, applicantAdded]);

  useEffect(() => {
    if (isSalesCreated) {
      setSalesData(salesAdded);
      setIsEdit(true);
      validation.setFieldValue("paymentMethodId", "");
      validation.setFieldValue("cash_amount", 0);
      validation.setFieldValue("statusId", salesAdded.statusId);
      validation.setFieldValue("statusDealId", salesAdded.statusDealId);
    }
  }, [isSalesCreated, salesAdded]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleMediaCustomer = useCallback(() => {
    if (modalMediaCustomer) {
      setModalMediaCustomer(false);
    } else {
      setModalMediaCustomer(true);
    }
  }, [modalMediaCustomer]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(
    (type = null) => {
      if (modalDetail) {
        setDetailType(type);
        setModalDetail(false);
        setSales(null);
      } else {
        setDetailType(type);
        setModalDetail(true);
      }
    },
    [modalDetail],
  );

  const handleCivilProgression = (id) => {
    dispatch(resetCivilProgressionState());
    dispatch(getCivilProgression({ branchId: id, simple: true }));
  };

  const toggleMediaApplicationDoc = useCallback(() => {
    if (modalMediaApplicationDoc) {
      setModalMediaApplicationDoc(false);
    } else {
      setModalMediaApplicationDoc(true);
    }
  }, [modalMediaApplicationDoc]);

  function handleCustomerContactAdd() {
    let fc = [];
    if (customerContactItem && customerContactItem.length) {
      customerContactItem.forEach((element) => {
        fc.push(element);
      });
    }

    fc.push({
      name: "",
      email: "",
      phone: "",
    });
    setCustomerContactItem(fc);
  }
  const handleSelectFileApplicationDoc = (file) => {
    setApplicationDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMediaApplicationDoc();
  };

  const handleClickApplicantDoc = (applicantId, actionType = null) => {
    setActionType(actionType);
    dispatch(getApplicantOne(applicantId));
  };

  const handleClickTransDoc = (salesId, actionType = null) => {
    setActionType(actionType);
    dispatch(getAccTrans({ salesId: salesId }));
  };

  useEffect(() => {
    if (info) {
      const dataInfoWithTrans = {
        ...info,
        sales_trans: accTranss,
      };

      setInfo(dataInfoWithTrans);
      switch (actionType) {
        case "detail":
          handleSalesClick(dataInfoWithTrans, actionType);
          break;
        default:
          break;
      }
    }
  }, [accTranss]);

  useEffect(() => {
    if (applicantOne && info) {
      const dataInfoWithApplicant = {
        ...info,
        sls_appl: applicantOne.data,
      };

      setInfo(dataInfoWithApplicant);

      if (actionType === "applicantDoc") {
        setApplicantDocData(dataInfoWithApplicant, true);
        return;
      }
      if (actionType === "surat_kuasa_bphtb") {
        setInfo(dataInfoWithApplicant);
        setSales((val) => ({
          ...(val || {}),
          ...dataInfoWithApplicant,
        }));
        setDetailType("surat_kuasa_bphtb");
        setModalDetail(true);
        return;
      }
      if (actionType) {
        handleSalesClick(dataInfoWithApplicant, actionType);
      }
    }
  }, [applicantOne]);

  function setApplicantDocData(sales, toggle) {
    setIsEditApllicationDoc(true);
    let data = sales.sls_appl;
    let files = [];
    if (data) {
      if (data.applicant_file && data.applicant_file.length > 0) {
        data.applicant_file.forEach((element) => {
          files.push({
            filename: element.filename,
            originalname: element.originalname,
          });
        });
      }
      setApplicationDocImg(files);

      let m = data.checked_document ? data.checked_document.split(",") : [];
      setCheckDocumentList(m);
      setApplicationDoc({
        id: data.id,
        statusId: 1,
        companyId: sales.companyId,
        clientId: sales.clientId,
        salesId: sales.id,
        agentId: sales.agentId,
        customerId: sales.customerId,
        branchId: sales.branchId,
        status: data.status && {
          label: data?.status,
          value: data?.status,
        },
        maritalStatus: data.applicant_marital_status && {
          label: data.applicant_marital_status ? data.applicant_marital_status.name : "",
          value: data.applicant_marital_status ? data.applicant_marital_status.id : "",
        },
        applicationAt: data.applicationAt ?? "",
        birthat: data.birthat ?? "",
        birth_place: data.birth_place ?? "",
        birthat_spouse: data.birthat_spouse ?? "",
        birth_place_spouse: data.birth_place_spouse ?? "",
        name: data.name,
        email: data.email,
        phone: data.phone,
        children_number: data.children_number,
        name_spouse: data.name_spouse,
        phone_spouse: data.phone_spouse,
        job_spouse: data.job_spouse,
        city: data.city,
        address: data.address,
        address_spouse: data.address_spouse,
        identity: data.identity,
        tax_no: data.tax_no,
        bank_no: data.bank_no,
        identity_spouse: data.identity_spouse,
        knownCrApplication: data.knownCrApplication,
        emergency_contact_name: data.emergency_contact_name,
        emergency_contact_phone: data.emergency_contact_phone,
        emergency_contact_relation: data.emergency_contact_relation,
        emergency_contact_address: data.emergency_contact_address,
        emergencyKnownCrApplication: data.emergencyKnownCrApplication,
        job_informan_name: data.job_informan_name,
        job_informan_position: data.job_informan_position,
        job_informan_phone: data.job_informan_phone,
        job_business: data.job_business,
        job_desc: data.job_desc && {
          label: data?.job_desc,
          value: data?.job_desc,
        },
        job_business_city: data.job_business_city,
        job_business_name: data.job_business_name,
        job_business_phone: data.job_business_phone,
        job_business_mail: data.job_business_mail,
        job_business_address: data.job_business_address,
        job_business_employee: data.job_business_employee,
        job_business_date: data.job_business_date,
        city_spouse: data.city_spouse,
        bttt: data.bttt,
        bttt_other: data.bttt_other,
        bttt_spouse: data.bttt_spouse,
        job_position: data.job_position,
        job_date: data.job_date,
        job_status: data.job_status,
        job_business_hour: data.job_business_hour,
        job_pay_rate: data.job_pay_rate,
        job_pay_rate_net: data.job_pay_rate_net,
        job_payroll_method: data.job_payroll_method,
        job_payroll_date: data.job_payroll_date,
        job_payroll_bank: data.job_payroll_bank,
        job_retirement_age: data.job_retirement_age,
        applicant_file: files,
        motherName: data.mother_name,
      });
    }
    if (toggle) toggleApplicationDoc();
  }

  const handleSalesClick = useCallback(
    (arg, type) => {
      setSalesData(arg);
      switch (type) {
        case "verifikasi":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "receipt":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "spr":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "spd_bangunan":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "spd_elektronik":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "slp_pk":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "slp_pk_notaris":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "spd_pbg":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "spd_pbt":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "form_wawancara":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "bast":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "surat_prasarana":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "surat_pernyataan_data":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "surat_kuasa_debet":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "sbum":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "standing_instruction":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "surat_kekurangan_uang_muka":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "kelompok_sasaran":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "pernyataan_verivikasi":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "daftar_kpr_subsidi":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "flpp_ta":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "pernyataan_developer":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "batasan_harga_jual_rumah":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "permohonan_kpr_subsidi":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "penyerahan_spt_pph":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "bast_rumah_umum_tapak":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "bast_sarusun_umum":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "pernyataan_verivikasi_2":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "permohonan_kpr_subsidi2":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "surat_kuasa":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "surat_kuasa_bphtb":
          setSales((val) => ({
            ...(val || {}),
            ...arg,
          }));
          toggleDetail(type);
          break;
        case "stiker_plat_kpr":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "sbum2":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "surat_kekurangan_uang_muka2":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;
        case "detail":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;

        default:
          setIsEdit(true);
          toggle();
          break;
      }
    },
    [toggle, userType, info],
  );

  const handleSalesDateClick = useCallback(
    (arg, type) => {
      setInfo(arg);
      setIsEdit(true);
      toggleDate();
    },
    [toggleDate, userType],
  );

  function setSalesData(data) {
    setIsEdit(true);
    handleGetProductVariant(data.companyId, data.branchId);
    let salesDetail = [];
    if (data.sales_detail) {
      data.sales_detail.forEach((element) => {
        salesDetail.push({
          detailId: element.id,
          itemId: element.productVarianId,
          item: {
            label: `${element.name} - ${element.barcode}`,
            value: element.productVarianId,
            name: element.name,
            sku: element.sku,
            barcode: element.barcode,
            amount: Math.round(element.amount, 0),
            brandId: element.brandId,
            productId: element.productId,
            land_excess: element.land_excess,
            land_price: element.land_price,
            price_handling: element.price_handling,
          },
          amount: Math.round(element.amount, 0),
          quantity: Math.round(element.quantity, 0),
          total: Math.round(element.amount_total, 0),
          name: element.name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: element.brandId,
          land_excess: element.land_excess,
          land_price: element.land_price,
          price_handling: element.price_handling,
          price_dp: element.price_dp,
          credit_amount: element.credit_amount,
          credit_decreased: element.credit_decreased,
          status: { label: element.statusId === 1 ? "Draft" : "Approved", value: element.statusId },
          statusId: element.statusId,
        });
      });
    }
    let files = [];
    if (data.sales_file && data.sales_file.length > 0) {
      data.sales_file.forEach((element) => {
        files.push({
          filename: element.filename,
          originalname: element.originalname,
        });
      });
    }

    setSalesImg(files);
    setApplicantDocData(data);
    setSales({
      id: data.id,
      companyId: data.companyId,
      typeId: data.typeId,
      clientId: data.clientId,
      description: data.description,
      transactionat: data.transactionat,
      code: data.code === null ? "-" : data.code,
      company: data.sales_company && data.sales_company.name && { label: data.sales_company.name, value: data.sales_company.id },
      agent:
        data?.sales_agent === null
          ? ""
          : {
            label: data?.sales_agent?.name,
            value: data?.sales_agent?.id,
          },
      branch:
        data?.sales_branch == null
          ? ""
          : {
            label: data?.sales_branch?.name,
            value: data?.sales_branch?.id,
            sbum: parseFloat(data.sales_branch?.sbum),
          },
      client:
        data?.sales_client === null
          ? ""
          : {
            label: data?.sales_client?.name,
            value: data?.sales_client?.id,
          },
      sales_type:
        data?.sales_type === null
          ? ""
          : {
            label: data?.sales_type?.name,
            value: data?.sales_type?.id,
          },
      sls_bb:
        data?.sls_bb === null
          ? ""
          : {
            label: data?.sls_bb?.name,
            value: data?.sls_bb?.id,
          },
      // paymentMethod: data.sales_pm === null ? "" : {
      //   label: data.sales_pm.name,
      //   value: data.sales_pm.id,
      // },
      // paymentTerm: data.sales_payment_term === null ? "" : {
      //   label: data.sales_payment_term.name,
      //   value: data.sales_payment_term.id,
      // },
      customer:
        data?.sales_customer === null
          ? ""
          : {
            label: data?.sales_customer?.name,
            value: data?.sales_customer?.id,
          },
      sales_trans: data?.sales_trans,
      sales_channel: data?.sales_channel && { label: data?.sales_channel?.name, value: data?.sales_channel?.id },
      status: data?.sales_status && { label: data?.sales_status?.name, value: data?.sales_status?.id },
      status_deal: data?.sales_deal_status && { label: data?.sales_deal_status.name, value: data?.sales_deal_status?.id },
      status_bank: data?.sales_bank_status && { label: data?.sales_bank_status.name, value: data?.sales_bank_status?.id },
      taxAmount: data?.tax_amount === null ? 0 : data?.tax_amount,
      totalAmount: data?.total_amount === null ? 0 : data?.total_amount,
      tax_amount: data?.tax_amount === null ? 0 : parseFloat(data?.tax_amount),
      total_amount: data?.total_amount === null ? 0 : parseFloat(data?.total_amount),
      sub_amount: data?.sub_amount === null ? 0 : parseFloat(data?.sub_amount),
      book_amount: data?.book_amount === null ? 0 : parseFloat(data?.book_amount),
      process_amount: data?.process_amount === null ? 0 : parseFloat(data?.process_amount),
      handling_amount: data?.handling_amount === null ? 0 : parseFloat(data?.handling_amount),
      shipment_amount: data?.shipment_amount === null ? 0 : parseFloat(data?.shipment_amount),
      credit_amount: data.credit_amount === null ? 0 : parseFloat(data?.credit_amount),
      statusId: data?.statusId,
      statusDealId: data?.statusDealId,
      tenor: data?.tenor,
      bankat: data?.bankat,
      completedat: data?.completedat,
      approvedat: data?.approvedat,
      description_bank: data?.description_bank,
      sales_detail: data?.sales_detail,
      item: salesDetail,
    });
  }

  const checkedAll = () => {
    const allChecked = salesList.every((item) => item.isChecked && item.typeId !== 4 && item.typeId !== 3);
    const updatedData = salesList.map((item) => ({
      ...item,
      isChecked: !allChecked,
    }));

    setSalesList(updatedData);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={salesList.every((item) => item.isChecked)} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 pe-0 me-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = salesList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setSalesList(updatedData);
                }}
              />
              <ButtonGroup className="m-0">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("createSales") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      setInfo(data);
                      setSales(data);
                      handleClickApplicantDoc(data.applicantId, "applicantDoc");
                    }}
                  >
                    {loadingApplicant && info.id === data.id && actionType === "applicantDoc" ? (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    ) : (
                      <i className="ri-newspaper-line fs-15"></i>
                    )}
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateSales") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      setInfo(data);
                      // handleSalesClick(data);
                      handleClickApplicantDoc(data.applicantId, "edit");
                    }}
                  >
                    {loadingApplicant && info.id === data.id && actionType === "edit" ? (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    ) : (
                      <i className="ri-edit-2-line fs-15"></i>
                    )}
                  </Button>
                  {loadingApplicant && info.id === data.id && actionType !== "applicantDoc" && actionType !== "edit" ? (
                    <Button color="light" className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateSales") !== -1 ? "btn-sm" : "btn-sm d-none"}>
                      {loadingApplicant && info.id === data.id ? (
                        <Spinner size="sm" className="flex-shrink-0" role="status">
                          Loading...
                        </Spinner>
                      ) : (
                        <i className="ri-edit-2-line fs-15"></i>
                      )}
                    </Button>
                  ) : (
                    <DropdownToggle tag="button" className={userType === "admin" || userType === "client" ? "btn btn-sm btn-light" : userRole && userRole.split(",").indexOf("updateSales") !== -1 ? "btn btn-sm btn-light" : "btn btn-sm btn-light d-none"} split></DropdownToggle>
                  )}

                  <DropdownMenu>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        // handleSalesClick(data, "spr");
                        handleClickApplicantDoc(data.applicantId, "spr");
                      }}
                    >
                      PRINT SPR
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "verifikasi");
                        // handleSalesClick(data, "verifikasi");
                      }}
                    >
                      PRINT FORM VERIFIKASI
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "spd_bangunan");
                        // handleSalesClick(data, "spd_bangunan");
                      }}
                    >
                      PRINT SPD BANGUNAN
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "spd_elektronik");
                        // handleSalesClick(data, "spd_elektronik");
                      }}
                    >
                      PRINT SPD ELEKTRONIK
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "spd_pbg");
                        // handleSalesClick(data, "spd_pbg");
                      }}
                    >
                      PRINT SPD PBG
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "spd_pbt");
                        // handleSalesClick(data, "spd_pbt");
                      }}
                    >
                      PRINT SPD PBT
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "slp_pk");
                        // handleSalesClick(data, "slp_pk");
                      }}
                    >
                      PRINT SLF BANK
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "slp_pk_notaris");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SLF NOTARIS
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        toggleHistory();
                      }}
                    >
                      RIWAYAT DATA
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        handleSalesDateClick(data);
                      }}
                    >
                      KOREKSI DATA
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "form_wawancara");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT FORM WAWANCARA
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "bast");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT BAST
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "surat_prasarana");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT PRASARANA
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "surat_pernyataan_data");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT PERNYATAAN PENYERAHAN DATA
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "surat_kuasa_debet");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT KUASA PENDEBETAN DANA
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "sbum");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SBUM
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "standing_instruction");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT STANDING INSTRUCTION
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "surat_kekurangan_uang_muka");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT PENGAKUAN KEKURANGAN BAYAR UANG MUKA
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "kelompok_sasaran");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT PERSYARATAN KELOMPOK SASARAN
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "pernyataan_verivikasi");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT PERNYATAAN VERIFIKASI
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "daftar_kpr_subsidi");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT DAFTAR DOKUMEN KPR BERSUBSIDI BTN
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "flpp_ta");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT FLPP TA 2025
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "pernyataan_developer");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT PERNYATAAN DEVELOPER
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "batasan_harga_jual_rumah");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT BATASAN HARGA JUAL RUMAH
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "permohonan_kpr_subsidi");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT PERNYATAAN PEMOHON KPR BERSUBSIDI BTN
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "penyerahan_spt_pph");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT PERNYATAAN PENYERAHAN SPT PPH
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "bast_rumah_umum_tapak");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT BAST RUMAH UMUM TAPAK
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "bast_sarusun_umum");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT BAST SARUSUN UMUM
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "pernyataan_verivikasi_2");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT PERNYATAAN VERIFIKASI
                    </DropdownItem>

                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "permohonan_kpr_subsidi2");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT PERNYATAAN PEMOHON KPR BERSUBSIDI BTN
                    </DropdownItem>

                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "surat_kuasa");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT KUASA
                    </DropdownItem>

                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "stiker_plat_kpr");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT STIKER PLAT
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "sbum2");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SBUM
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        handleClickApplicantDoc(data.applicantId, "surat_kekurangan_uang_muka2");
                        // handleSalesClick(data, "slp_pk_notaris");
                      }}
                    >
                      PRINT SURAT PENGAKUAN KEKURANGAN BAYAR UANG MUKA
                    </DropdownItem>

                    {(data.statusId < 6 || userType === "admin" || userType === "client" || (userRole && userRole.split(",").indexOf("deleteSales") !== -1)) && (
                      <>
                        <DropdownItem divider />
                        <DropdownItem
                          onClick={() => {
                            data.actionTitle = `Anda akan membatalkan pesanan penjualan ${data.sales_customer.name} #${data.code}`;
                            setInfo(data);
                            setDeleteModal(true);
                          }}
                        >
                          HAPUS DATA
                        </DropdownItem>
                      </>
                    )}
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {data.statusId === 1 && (
                <button
                  className="btn btn-sm btn-soft-success fs-12"
                  onClick={() => {
                    data.actionTitle = `Anda akan melakukan Approval Booking untuk data ${data.sales_customer.name} #${data.code}`;
                    data.statusSalesId = 2;
                    setSales(data);
                    toggleApprove();
                  }}
                >
                  ACC BOOKING
                </button>
              )}
              {(data.statusId === 2 || data.statusId === 3) && data.statusDealId === 4 && (
                <button
                  className="btn btn-sm btn-soft-info fs-12"
                  onClick={() => {
                    data.actionTitle = `Anda akan menandai berkas : ${data.sales_customer.name} #${data.code} Sudah di Verifikasi`;
                    data.statusSalesId = 3;
                    data.statusDealApproveId = 5;
                    setSales(data);
                    toggleApprove();
                  }}
                >
                  ACC BERKAS
                </button>
              )}
              {data.statusDealId === 7 && (
                <button
                  className="btn btn-sm btn-soft-success fs-12"
                  onClick={() => {
                    data.actionTitle = `Anda akan menandai berkas : ${data.sales_customer.name} #${data.code} Sudah melakukan proses AKAD`;
                    data.statusDealApproveId = 8;
                    setSales(data);
                    toggleApprove();
                  }}
                >
                  CONFIRM AKAD
                </button>
              )}
              {data.statusId === 6 && (
                <button
                  className="btn btn-sm btn-soft-success fs-12"
                  onClick={() => {
                    data.actionTitle = `Anda akan melakukan aktivasi data penjualan yang sudah dibatalkan: ${data.sales_customer.name} #${data.code}`;
                    data.statusSalesId = 2;
                    data.statusDealApproveId = 3;
                    setSales(data);
                    toggleApprove();
                  }}
                >
                  AKTIVASI
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "No Transaksi",
        accessor: "transaction_no",
        filterable: true,
        Cell: (cell) => {
          let data = cell.row.original;
          let statDeal;
          let statDealId = data?.applicant_sales?.sales_deal_status && data?.applicant_sales?.sales_deal_status.id;

          switch (statDealId) {
            case 3:
              statDeal =
                data?.applicant_sales?.typeId === 3 || data?.applicant_sales?.typeId === 4 ? (
                  <span className="badge text-uppercase" style={{ background: "#CFECF7", color: "#20A7DB" }}>
                    CASH
                  </span>
                ) : (
                  <span className="badge text-uppercase" style={{ background: "#ffe7ff", color: "#ea33f7" }}>
                    {data?.applicant_sales?.sales_deal_status.name}
                  </span>
                );
              break;
            case 4:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#ede3c5", color: "#806b29" }}>
                  {data?.applicant_sales?.sales_deal_status.name}
                </span>
              );
              break;
            case 5:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#EAFAEA", color: "#65B741" }}>
                  {data?.applicant_sales?.sales_deal_status.name}
                </span>
              );
              break;
            case 6:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#FFFBCA", color: "#F09319" }}>
                  {data?.applicant_sales?.sales_deal_status.name}
                </span>
              );
              break;
            case 7:
              statDeal = <span className="badge text-uppercase badge-soft-info">{data?.applicant_sales?.sales_deal_status.name}</span>;
              break;
            case 8:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#E8F9FF", color: "#2cc2c4" }}>
                  {data?.applicant_sales?.sales_deal_status.name}
                </span>
              );
              break;
            default:
              statDeal = "";
              break;
          }
          return (
            <div
              onClick={() => {
                setInfo(data);
                handleClickTransDoc(data.id, "detail");
              }}
              className="cursor-pointer"
            >
              <div className="mb-1">
                <span className="fw-semibold">
                  {data?.applicant_sales?.transaction_no}{" "}
                  {loadingAccTranss && info.id === data.id && (
                    <Spinner size="sm" className="flex-shrink-0" role="status">
                      Loading...
                    </Spinner>
                  )}
                </span>
              </div>
              <div className="hstack gap-2">
                {statDeal}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        id: "identity",
        Header: "No KTP",
        accessor: "identity",
        filterable: true,
      },
      {
        id: "phone",
        Header: "No Telpon",
        accessor: "phone",
        filterable: true,
      },
    ],
    [salesList, handleSalesClick, userRole, userType, categoryActive, accTranss, loadingApplicant, loadingAccTranss],
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: salesList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Marketing", "Status", "Proyek", "Booking", "ProyekKode", "Promo"],
        pageIndex: indexPage,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      type: searchType.value ?? "",
      startat: startat,
      endat: endat,
      branchId: branchSelected.value ?? "",
      cashin: true,
    };
    dispatch(onGetSales(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setSearchType("");
    setSearchValue("");
    handleGetApplicant(branchSelected?.companyId, branchSelected?.value);
  }

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      //dispatch(onDeleteSales(element.value));
      //console.log(element);
    });
    checkall.checked = false;
  };

  const approveMultiple = () => {
    if (salesList.length > 0) {
      salesList.forEach((sales) => {
        if (sales.isChecked && sales.statusDealId === 7) {
          sales.statusDealApproveId = 8;
          sales.setApprove = true;
          dispatch(onUpdateSales(sales));
        }
      });
    }
  };

  const approveFinalMultiple = () => {
    if (!finalDate || finalDate === "") toast.error("Isi Tanggal Rencana Akad Sebelum Melanjutkan", { position: "bottom-left", autoClose: 5000 });
    else if (salesList.length > 0) {
      salesList.forEach((sales) => {
        if (sales.isChecked && sales.statusDealId === 6) {
          sales.statusDealApproveId = 7;
          sales.setApprove = true;
          sales.completedat = finalDate;
          dispatch(onUpdateSales(sales));
        }
      });
    }
  };

  const approveBankMultiple = () => {
    if (salesList.length > 0) {
      salesList.forEach((sales) => {
        if (sales.isChecked && (sales.statusId === 2 || sales.statusId === 3) && sales.statusDealId === 4) {
          sales.statusSalesId = 3;
          sales.statusDealApproveId = 5;
          sales.setApprove = true;
          dispatch(onUpdateSales(sales));
        }
      });
    }
  };

  function handleSalesDetailAdd() {
    let arrSalesDetail = [];
    validation.values.item.forEach((element) => {
      arrSalesDetail.push(element);
    });

    arrSalesDetail.push({
      itemId: null,
      item: {
        label: null,
        value: null,
        name: "Select Product",
        sku: null,
        barcode: null,
        amount: null,
        brandId: null,
        productId: null,
        land_excess: 0,
        land_price: 0,
        price_handling: 0,
      },
      amount: 0,
      quantity: 0,
      total: 0,
      name: "Select Product",
      sku: null,
      barcode: null,
      brandId: null,
      land_excess: 0,
      land_price: 0,
      price_handling: 0,
      price_dp: 0,
      credit_amount: 0,
      credit_decreased: 0,
      statusId: 1,
      status: { label: "Draft", value: 1 },
    });
    validation.setFieldValue("item", arrSalesDetail);
  }

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = salesImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setSalesImg(newState);
    } else {
      const index = salesImg.findIndex((fl) => fl.filename === file.filename);
      setSalesImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleDeleteFileCustomer = (file) => {
    if (isEdit) {
      const newState = salesImgCustomer.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, originalname: file.originalname, mimetype: file.mimetype, isDeleted: true };
        }
        return obj;
      });
      setSalesImgCustomer(newState);
    } else {
      const index = salesImgCustomer.findIndex((fl) => fl.filename === file.filename);
      setSalesImgCustomer((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFile = (file) => {
    setSalesImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const handleSelectFileCustomer = (file) => {
    setSalesImgCustomer((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMediaCustomer();
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (sales) {
        sales.setApprove = true;
        sales.approval_note = values.approval_note;
        dispatch(onUpdateSales(sales));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (sales && sales.id) || 0,
      statusId: (sales && sales.statusId) || 1,
      statusDealId: (sales && sales.statusDealId) || 3,
      sls_bb: (sales && sales.sls_bb) ?? "",
      sales_type: (sales && sales.sales_type) ?? "",
      sales_promo: (sales && sales.sales_promo) ?? "",
      company: (sales && sales.company) || companySelected,
      client: (sales && sales.client) || clientSelected,
      branch: (sales && sales.branch) ?? "",
      shipmentCarrier: (sales && sales.shipmentCarrier) || 0,
      shipmentMethod: (sales && sales.shipmentMethod) || 0,
      paymentMethod: (sales && sales.paymentMethod) ?? "",
      //paymentTerm: (sales && sales.paymentTerm) || 0,
      code: (sales && sales.code) ?? "",
      transactionat: (sales && sales.transactionat) ?? "",
      agent: (sales && sales.agent) ?? "",
      description: (sales && sales.description) ?? "",
      customer: (sales && sales.customer) ?? "",
      status: (sales && sales.status) ?? "",
      status_deal: (sales && sales.status_deal) ?? "",
      status_bank: (sales && sales.status_bank) ?? "",
      sales_channel: (sales && sales.sales_channel) ?? "",
      tax: (sales && sales.tax) || 0,
      tax_amount: (sales && sales.tax_amount) || 0,
      shipmentAmount: (sales && sales.shipmentAmount) || 0,
      total_amount: (sales && sales.total_amount) || 0,
      sub_amount: (sales && sales.sub_amount) || 0,
      book_amount: (sales && sales.book_amount) || 0,
      process_amount: (sales && sales.process_amount) || 0,
      handling_amount: (sales && sales.handling_amount) || 0,
      shipment_amount: (sales && sales.shipment_amount) || 0,
      credit_amount: (sales && sales.credit_amount) || 0,
      tenor: (sales && sales.tenor) || 0,
      cash_amount: sales && sales.cash_amount ? sales.cash_amount : 0,
      cashat: (sales && sales.cashat) ?? "",
      bankat: (sales && sales.bankat) ?? "",
      completedat: (sales && sales.completedat) ?? "",
      description_bank: (sales && sales.description_bank) ?? "",
      item: (sales && sales.item) || [],
    },
    validationSchema: Yup.object({
      branch: Yup.object().required("Silahkan pilih proyek").nullable(true),
      company: Yup.object().required("Silahkan pilih perusahaan").nullable(true),
      client: Yup.object().required("Silahkan pilih grup perusahaan").nullable(true),
      agent: Yup.object().required("Silahkan pilih marketing").nullable(true),
      customer: Yup.object().required("Silahkan pilih konsumen").nullable(true),
      sales_type: Yup.object().required("Silahkan pilih jenis penjualan").nullable(true),
    }),
    onSubmit: (values) => {
      if (values.paymentMethod && values.paymentMethod.value && values.cash_amount < 1) {
        toast.error("Silahkan isi JUMLAH pembayaran untuk menyimpan data Transaksi Pembayaran", { position: "bottom-left", autoClose: 5000 });
      } else {
        if (isEdit) {
          let editSubmit = {
            id: values.id,
            statusId: values.statusId,
            statusDealId: values.statusDealId,
            statusBankId: values.status_bank.value,
            tenor: values.tenor,
            bankat: values.bankat,
            completedat: values.completedat,
            description_bank: values.description_bank,
            agentId: values.agent.value,
            branchId: values.branch.value,
            shipmentCarrierId: values.shipmentCarrier.value,
            shipmentMethodId: values.shipmentMethod.value,
            shipment_amount: values.shipmentAmount,
            paymentMethodId: values.paymentMethod.value,
            //paymentTermId: values.paymentTerm.value,
            taxId: values.tax.value,
            transactionat: values.transactionat,
            typeId: values.sales_type.value,
            promoId: values.sales_promo.value,
            bankBranchId: values.sls_bb.value,
            description: values.description,
            clientId: values.client.value,
            customerId: values.customer.value,
            companyId: values.company.value,
            channelId: values.sales_channel.value,
            tax_amount: values.tax_amount,
            shipment_amount_amount: values.shipment_amount,
            sub_amount: values.sub_amount,
            book_amount: values.book_amount,
            process_amount: values.process_amount,
            handling_amount: values.handling_amount,
            total_amount: values.total_amount,
            credit_amount: values.credit_amount,
            cashat: values.cashat,
            cash_amount: values.cash_amount,
            sales_detail: JSON.stringify(validation.values.item),
            files: salesImg.length > 0 ? salesImg : [],
          };
          dispatch(onUpdateSales(editSubmit));
        } else {
          if (values.cash_amount < 1 || !values.paymentMethod.value) {
            toast.error("Silahkan isi Jenis dan Jumlah pembayaran tanda jadi untuk menyimpan data penjualan", { position: "bottom-left", autoClose: 5000 });
          } else {
            let addSubmit = {
              statusId: 1,
              statusDealId: 3,
              statusBankId: values.status_bank.value,
              tenor: values.tenor,
              bankat: values.bankat,
              completedat: values.completedat,
              description_bank: values.description_bank,
              agentId: values.agent.value,
              branchId: values.branch.value,
              shipmentCarrierId: values.shipmentCarrier.value,
              shipmentMethodId: values.shipmentMethod.value,
              shipment_amount: values.shipmentAmount,
              paymentMethodId: values.paymentMethod.value,
              //paymentTermId: values.paymentTerm.value,
              taxId: values.tax.value,
              transactionat: values.transactionat,
              typeId: values.sales_type.value,
              promoId: values.sales_promo.value,
              bankBranchId: values.sls_bb.value,
              description: values.description,
              clientId: values.client.value,
              customerId: values.customer.value,
              companyId: values.company.value,
              channelId: values.sales_channel.value,
              tax_amount: values.tax_amount,
              shipment_amount_amount: values.shipment_amount,
              sub_amount: values.sub_amount,
              book_amount: values.cash_amount,
              process_amount: values.process_amount,
              handling_amount: values.handling_amount,
              total_amount: values.total_amount,
              credit_amount: values.credit_amount,
              cashat: values.cashat,
              cash_amount: values.cash_amount,
              sales_detail: JSON.stringify(validation.values.item),
              files: salesImg.length > 0 ? salesImg : [],
            };
            dispatch(onAddNewSales(addSubmit));
          }
        }
      }
      validation.resetForm();
      toggle();
    },
  });

  const onClickDeleteDetailItem = (index) => {
    validation.values.item.splice(index, 1);
  };

  const validationDate = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (info && info.id) || 0,
      transactionat: (info && info.transactionat) ?? "",
      docat: (info && info.docat) ?? "",
      sales_promo:
        info && info.sales_promo
          ? {
            label: info.sales_promo.name,
            value: info.sales_promo.id,
          }
          : "",
      sp3at: (info && info.sp3at) ?? "",
      bankat: (info && info.bankat) ?? "",
      completedat: (info && info.completedat) ?? "",
      process_amount: (info && info.process_amount) ?? "",
      disc_amount: (info && info.disc_amount) || 0,
      book_amount: (info && info.book_amount) || 0,
      handling_amount: (info && info.handling_amount) || 0,
      sub_amount: (info && info.sub_amount) || 0,
      total_amount: (info && info.total_amount) || 0,
      credit_amount: (info && info.credit_amount) || 0,
    },
    validationSchema: Yup.object({
      transactionat: Yup.string().required("Silahkan Input Tanggal Transaksi").nullable(true),
    }),
    onSubmit: (values) => {
      let editSubmit = {
        id: values.id,
        promoId: values.sales_promo.value,
        isDateUpdate: true,
        transactionat: values.transactionat,
        docat: values.docat,
        sp3at: values.sp3at,
        bankat: values.bankat,
        completedat: values.completedat,
        process_amount: values.process_amount,
        disc_amount: values.disc_amount,
        book_amount: values.book_amount,
        handling_amount: values.handling_amount,
        sub_amount: values.sub_amount,
        total_amount: values.total_amount,
        credit_amount: values.credit_amount,
      };
      dispatch(onUpdateSales(editSubmit));
      validationDate.resetForm();
      toggleDate();
    },
  });

  const validationCustomer = useFormik({
    enableReinitialize: true,
    initialValues: {
      company: (customer && customer.company) || companySelected,
      client: (customer && customer.client) || clientSelected,
      customerGroup: (customer && customer.customerGroup) ?? "",
      name: (customer && customer.name) ?? "",
      agent: (customer && customer.agent) ?? "",
      email: (customer && customer.email) ?? "",
      password: (customer && customer.password) ?? "",
      phone: (customer && customer.phone) ?? "",
      birthat: (customer && customer.birthat) ?? "",
      insurance_number: (customer && customer.insurance_number) ?? "",
      tax_number: (customer && customer.tax_number) ?? "",
      number: (customer && customer.number) ?? "",
      website: (customer && customer.website) ?? "",
      description: (customer && customer.description) ?? "",
      address: (customer && customer.address) ?? "",
      customer_status: customer && customer.customer_status,
      village: customer && customer.village,
      identity: (customer && customer.identity) ?? "",
      identity_type: (customer && customer.identityType) ?? "",
      bank: (customer && customer.bank) ?? "",
      idBank: (customer && customer.idBank) || 0,
      zip: (customer && customer.zip) ?? "",
      street: (customer && customer.street) ?? "",
      image: (customer && customer.image) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Input Customer Name").nullable(true),
      phone: Yup.string().required("Please Input Phone Number").nullable(true),
      // client: Yup.object().required("Silahkan Input grup perusahaan").nullable(true),
      // company: Yup.object().required("Silahkan pilih Company").nullable(true),
      // agent: Yup.object().required("Silahkan pilih Agent").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getCustomerLoading());
      if (isEdit) {
        let editDataSubmit = {
          id: customer.id,
          groupId: values.customerGroup.value,
          clientId: values.client.value,
          companyId: values.company.value,
          agentId: values.agent.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          insurance_number: values.insurance_number,
          tax_number: values.tax_number,
          website: values.website,
          identityId: values.identity_type.value,
          identity: values.identity,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          description: values.description,
          zip: values.zip,
          village: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[0].value : customer.village,
          district: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 4].value : customer.district,
          city: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 3].value : customer.city,
          province: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 2].value : customer.province,
          country: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 1].value : customer.country,
          street: values.street,
          customer_contact: JSON.stringify(customerContactItem),
          image: values.image,
          files: salesImgCustomer.length > 0 ? salesImgCustomer : [],
        };
        dispatch(onUpdateCustomer(editDataSubmit));
      } else {
        var addDataSubmit = {
          clientId: values.client.value,
          companyId: values.company.value,
          groupId: values.customerGroup.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          insurance_number: values.insurance_number,
          tax_number: values.tax_number,
          website: values.website,
          identityId: values.identity_type.value,
          identity: values.identity,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          agentId: values.agent.value,
          description: values.description,
          zip: values.zip,
          village: values.address.value && values.address.value.terms[0].value,
          district: values.address.value && values.address.value.terms[values.address.value.terms.length - 4].value,
          city: values.address.value && values.address.value.terms[values.address.value.terms.length - 3].value,
          province: values.address.value && values.address.value.terms[values.address.value.terms.length - 2].value,
          country: values.address.value && values.address.value.terms[values.address.value.terms.length - 1].value,
          street: values.street,
          customer_contact: JSON.stringify(customerContactItem),
          image: values.image,
          files: salesImgCustomer.length > 0 ? salesImgCustomer : [],
        };
        dispatch(onAddNewCustomer(addDataSubmit));
      }
      validationCustomer.resetForm();
      toggleCustomer();
    },
  });

  const validationApplicationDoc = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (applicationDoc && applicationDoc.id) ?? "",
      maritalStatus: (applicationDoc && applicationDoc.maritalStatus) ?? "",
      name: (applicationDoc && applicationDoc.name) ?? "",
      bttt: (applicationDoc && applicationDoc.bttt) ?? "",
      bttt_other: (applicationDoc && applicationDoc.bttt_other) ?? "",
      bttt_spouse: (applicationDoc && applicationDoc.bttt_spouse) ?? "",
      city: (applicationDoc && applicationDoc.city) ?? "",
      city_spouse: (applicationDoc && applicationDoc.city_spouse) ?? "",
      address: (applicationDoc && applicationDoc.address) ?? "",
      address_spouse: (applicationDoc && applicationDoc.address_spouse) ?? "",
      identity: (applicationDoc && applicationDoc.identity) ?? "",
      birthat: (applicationDoc && applicationDoc.birthat) ?? "",
      birth_place: (applicationDoc && applicationDoc.birth_place) ?? "",
      birthat_spouse: (applicationDoc && applicationDoc.birthat_spouse) ?? "",
      birth_place_spouse: (applicationDoc && applicationDoc.birth_place_spouse) ?? "",
      tax_no: (applicationDoc && applicationDoc.tax_no) ?? "",
      bank_no: (applicationDoc && applicationDoc.bank_no) ?? "",
      identity_spouse: (applicationDoc && applicationDoc.identity_spouse) ?? "",
      email: (applicationDoc && applicationDoc.email) ?? "",
      phone: (applicationDoc && applicationDoc.phone) ?? "",
      children_number: (applicationDoc && applicationDoc.children_number) ?? "",
      name_spouse: (applicationDoc && applicationDoc.name_spouse) ?? "",
      phone_spouse: (applicationDoc && applicationDoc.phone_spouse) ?? "",
      job_spouse: (applicationDoc && applicationDoc.job_spouse) ?? "",
      knownCrApplication: (applicationDoc && applicationDoc.knownCrApplication) || false,
      emergency_contact_name: (applicationDoc && applicationDoc.emergency_contact_name) ?? "",
      emergency_contact_address: (applicationDoc && applicationDoc.emergency_contact_address) ?? "",
      emergency_contact_phone: (applicationDoc && applicationDoc.emergency_contact_phone) ?? "",
      emergency_contact_relation: (applicationDoc && applicationDoc.emergency_contact_relation) ?? "",
      emergencyKnownCrApplication: (applicationDoc && applicationDoc.emergencyKnownCrApplication) || false,
      job_informan_name: (applicationDoc && applicationDoc.job_informan_name) ?? "",
      job_informan_position: (applicationDoc && applicationDoc.job_informan_position) ?? "",
      job_business: (applicationDoc && applicationDoc.job_business) ?? "",
      job_desc: (applicationDoc && applicationDoc.job_desc) ?? "",
      job_business_name: (applicationDoc && applicationDoc.job_business_name) ?? "",
      job_business_phone: (applicationDoc && applicationDoc.job_business_phone) ?? "",
      job_business_mail: (applicationDoc && applicationDoc.job_business_mail) ?? "",
      job_business_city: (applicationDoc && applicationDoc.job_business_city) ?? "",
      job_business_address: (applicationDoc && applicationDoc.job_business_address) ?? "",
      job_informan_phone: (applicationDoc && applicationDoc.job_informan_phone) ?? "",
      job_business_employee: (applicationDoc && applicationDoc.job_business_employee) ?? "",
      job_business_date: (applicationDoc && applicationDoc.job_business_date) ?? "",
      job_position: (applicationDoc && applicationDoc.job_position) ?? "",
      job_date: (applicationDoc && applicationDoc.job_date) ?? "",
      job_status: (applicationDoc && applicationDoc.job_status) ?? "",
      job_business_hour: (applicationDoc && applicationDoc.job_business_hour) ?? "",
      job_pay_rate: (applicationDoc && applicationDoc.job_pay_rate) ?? "",
      job_pay_rate_net: (applicationDoc && applicationDoc.job_pay_rate_net) ?? "",
      job_payroll_method: (applicationDoc && applicationDoc.job_payroll_method) ?? "",
      job_payroll_date: (applicationDoc && applicationDoc.job_payroll_date) ?? "",
      job_payroll_bank: (applicationDoc && applicationDoc.job_payroll_bank) ?? "",
      job_retirement_age: (applicationDoc && applicationDoc.job_retirement_age) ?? "",
      status: (applicationDoc && applicationDoc.status) ?? "",
      client: (applicationDoc && applicationDoc.client) || clientSelected,
      company: (applicationDoc && applicationDoc.company) || companySelected,
      customer: (applicationDoc && applicationDoc.customer) ?? "",
      applicationAt: (applicationDoc && applicationDoc.applicationAt) ?? "",
      salesId: applicationDoc && applicationDoc.salesId,
      motherName: (applicationDoc && applicationDoc.motherName) ?? "",
    },
    onSubmit: (values) => {
      let ele = document.querySelectorAll(".checked-method-all");
      let arrData = "";
      ele.forEach((ele) => {
        if (ele.checked === true) {
          arrData += ele.value + ",";
        }
      });
      let data = {
        salesId: applicationDoc && applicationDoc.salesId ? applicationDoc.salesId : null,
        maritalStatusId: values.maritalStatus.value,
        city: values.city,
        address: values.address,
        address_spouse: values.address_spouse,
        identity: values.identity,
        tax_no: values.tax_no,
        bank_no: values.bank_no,
        identity_spouse: values.identity_spouse,
        name: values.name,
        email: values.email,
        phone: values.phone,
        children_number: values.children_number,
        name_spouse: values.name_spouse,
        phone_spouse: values.phone_spouse,
        job_spouse: values.job_spouse,
        birthat: values.birthat,
        birth_place: values.birth_place,
        birthat_spouse: values.birthat_spouse,
        birth_place_spouse: values.birth_place_spouse,
        knownCrApplication: values.knownCrApplication,
        emergency_contact_name: values.emergency_contact_name,
        emergency_contact_phone: values.emergency_contact_phone,
        emergency_contact_relation: values.emergency_contact_relation,
        emergency_contact_address: values.emergency_contact_address,
        emergencyKnownCrApplication: values.emergencyKnownCrApplication,
        job_informan_name: values.job_informan_name,
        job_informan_position: values.job_informan_position,
        job_informan_phone: values.job_informan_phone,
        job_business: values.job_business,
        job_desc: values.job_desc.value,
        job_business_city: values.job_business_city,
        job_business_name: values.job_business_name,
        job_business_phone: values.job_business_phone,
        job_business_mail: values.job_business_mail,
        job_business_address: values.job_business_address,
        job_business_employee: values.job_business_employee,
        job_business_date: values.job_business_date,
        city_spouse: values.city_spouse,
        bttt: values.bttt,
        bttt_other: values.bttt_other,
        bttt_spouse: values.bttt_spouse,
        job_position: values.job_position,
        job_date: values.job_date,
        job_status: values.job_status,
        job_business_hour: values.job_business_hour,
        job_pay_rate: values.job_pay_rate,
        job_pay_rate_net: values.job_pay_rate_net,
        job_payroll_method: values.job_payroll_method,
        job_payroll_date: values.job_payroll_date,
        job_payroll_bank: values.job_payroll_bank,
        job_retirement_age: values.job_retirement_age,
        applicationAt: values.applicationAt,
        status: values.status.value,
        files: applicationDocImg.length > 0 ? applicationDocImg : [],
        clientId: validation.values.client.value ? validation.values.client.value : applicationDoc.clientId,
        companyId: validation.values.company.value ? validation.values.company.value : applicationDoc.companyId,
        customerId: validation.values.customer.value ? validation.values.customer.value : applicationDoc.customerId,
        branchId: validation.values.branch.value ? validation.values.branch.value : applicationDoc.branchId,
        agentId: validation.values.agent.value ? validation.values.agent.value : applicationDoc.agentId,
        checked_document: arrData.slice(0, -1),
        mother_name: values.motherName,
      };

      if (isEditApllicationDoc) {
        data.id = applicationDoc.id;
        dispatch(onUpdateApplicant(data));
      } else {
        dispatch(onAddNewApplicant(data));
      }
      toggleApplicationDoc();
    },
  });

  const getDetailTitle = (detailType) => {
    const map = {
      verifikasi: "View Verifikasi",
      spr: "View SPR",
      slp_pk: "View SLF",
      form_wawancara: "View Form Wawancara",
      bast: "BAST",
      surat_prasarana: "Surat Prasarana",
      surat_pernyataan_data: "Surat Pernyataan Data",
      surat_kuasa_debet: "Surat Kuasa Debet",
      sbum: "SBUM",
      standing_instruction: "Standing Instruction",
      surat_kekurangan_uang_muka: "Surat Kekurangan Uang Muka",
      kelompok_sasaran: "Kelompok Sasaran",
      pernyataan_verivikasi: "Pernyataan Verivikasi",
      daftar_kpr_subsidi: "Daftar KPR Subsidi",
      flpp_ta: "FLPP TA",
      pernyataan_developer: "Pernyataan Developer",
      batasan_harga_jual_rumah: "Batasan Harga Jual Rumah",
      permohonan_kpr_subsidi: "Permohonan KPR Bersubsidi",
      penyerahan_spt_pph: "Penyerahan SPT PPH",
      bast_rumah_umum_tapak: "BAST Rumah Umum Tapak",
      bast_sarusun_umum: "BAST Sarusun Umum",
      pernyataan_verivikasi_2: "Pernyataan Verivikasi",

      permohonan_kpr_subsidi2: "Permohonan KPR Bersubsidi",
      surat_kuasa: "Surat Kuasa",
      stiker_plat_kpr: "Stiker Plat",
      sbum2: "SBUM",
      surat_kekurangan_uang_muka2: "Surat Kekurangan Uang Muka",
    };

    const spdTypes = ["spd_bangunan", "spd_elektronik", "spd_pbg", "spd_pbt"];

    if (spdTypes.includes(detailType)) {
      return "View SPD";
    }

    return map[detailType] || "Berkas Penjualan";
  };

  document.title = "PEMBERKASAN | PESONA KAHURIPAN";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={salesList} />
      <DeleteModal show={deleteModal} title={info ? info.actionTitle : null} onDeleteClick={handleDeleteSales} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <DeleteModal
        show={approveModalMulti}
        title="Anda akan menandai akad untuk semua data terpilih!"
        btn="Ya, Lanjutkan"
        isApproval={true}
        onDeleteClick={() => {
          approveMultiple();
          setApproveModalMulti(false);
        }}
        onCloseClick={() => setApproveModalMulti(false)}
      />

      <DeleteModal
        show={approveFinalModalMulti}
        title="Anda akan menandai SP3K Final untuk semua data terpilih!"
        btn="Ya, Lanjutkan"
        isApproval={true}
        onDeleteClick={() => {
          approveFinalMultiple();
          setApproveFinalModalMulti(false);
        }}
        onCloseClick={() => setApproveFinalModalMulti(false)}
      />

      <DeleteModal
        show={approveBankModalMulti}
        title="Anda akan menandai berkas sudah dikirim ke bank untuk semua data terpilih!"
        btn="Ya, Lanjutkan"
        isApproval={true}
        onDeleteClick={() => {
          approveBankMultiple();
          setApproveBankModalMulti(false);
        }}
        onCloseClick={() => setApproveBankModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Penjualan" pageTitle="Pemberkasan" loading={loading || loadingApplicant || loadingAccTranss}>
          <div className="flex-shrink-0">
            {/* <button
                  type="button"
                  className={userType === "admin" || userType === "client" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createSales") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
                  id="create-btn"
                  onClick={() => {
                    setSales(null);
                    setInfo(null);
                    setSalesTrans([]);
                    setIsEdit(false);
                    toggle();
                  }}>
                  <i className="ri-tag-line me-1 align-bottom fs-14"></i> Tambah
                </button>
                <button
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger ms-1 add-btn" : userRole && userRole.split(",").indexOf("deleteSales") !== -1 ? "btn btn-soft-danger ms-1 add-btn" : "btn btn-soft-danger ms-1 add-btn d-none"}
                  onClick={() => setDeleteModalMulti(true)}>
                  <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                </button> */}
            {currentProgress === 4 && (
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-2">
                  <Select
                    name="sls_bb"
                    value={validation.values.sls_bb}
                    placeholder="Pilih Bank Pengajuan"
                    onChange={(e) => {
                      validation.setFieldValue("sls_bb", e);
                    }}
                    options={bankBranchList}
                  ></Select>
                </div>
                <div className="col-auto fs-10 text-center flex-grow-1">
                  <button className={"btn btn-info me-2 add-btn"} onClick={() => setApproveBankModalMulti(true)}>
                    {" "}
                    TANDAI BANK
                  </button>
                </div>
              </div>
            )}
            {currentProgress === 6 && (
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-2">
                  <Flatpickr
                    className="form-control "
                    id="datepicker-publish-input"
                    placeholder="Tanggal Akad"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    value={finalDate}
                    onChange={(selectedDates, dateStr) => {
                      setFinalDate(dateStr);
                    }}
                  />
                </div>
                <div className="col-auto fs-10 text-center flex-grow-1">
                  <button className={"btn btn-info me-2 add-btn"} onClick={() => setApproveFinalModalMulti(true)}>
                    {" "}
                    TANDAI SP3K FINAL
                  </button>
                </div>
                <div>
                  <ExportDoc data={salesDoc} />
                </div>
              </div>
            )}
            {currentProgress === 7 && (
              <button className={"btn btn-info me-2 add-btn"} onClick={() => setApproveModalMulti(true)}>
                {" "}
                TANDAI AKAD
              </button>
            )}
            {currentProgress !== 6 && currentProgress !== 4 && <ExportDoc data={salesDoc} />}
          </div>
        </BreadCrumb>
        <Row>
          <Col sm={12}>
            <div className="hstack gap-3">
              <div
                className="card align-items-center card-animate pt-2 pb-2 pe-3 ps-3"
                style={{ width: 100 / 7 + "%", cursor: "pointer", minHeight: "34px", verticalAlign: "middle", border: "1px solid #20A7DB" }}
                onClick={() => {
                  toggleType(4);
                  setCategoryActive(1);
                  gotoPage(0);
                  setIndexPage(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#20A7DB" }}>
                      {applicants.filter((sales) => (sales.typeId === 3 || sales.typeId === 4) && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                    </div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1"> CASH</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate pt-2 pb-2 pe-3 ps-3"
                style={{ width: 100 / 6 + "%", cursor: "pointer", minHeight: "34px", verticalAlign: "middle", border: "1px solid #ed57f7" }}
                onClick={() => {
                  toggleProgress(3);
                  setCategoryActive(3);
                  gotoPage(0);
                  setIndexPage(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className="avatar-title fw-semibold rounded-circle fs-14 text-dark" style={{ background: "#ed57f7" }}>
                      {salesOriginalList.filter((sales) => sales.statusDealId === 3 && sales.typeId !== 4 && sales.typeId !== 3 && sales.statusBankId !== 2 && sales.statusBankId !== 3 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                    </div>
                  </div>
                  <div className="col-auto fs-11 text-center flex-grow-1"> BOOKING</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate pt-2 pb-2 pe-3 ps-3"
                style={{ width: 100 / 6 + "%", cursor: "pointer", minHeight: "34px", verticalAlign: "middle", border: "1px solid #BDB395" }}
                onClick={() => {
                  toggleProgress(4);
                  setCategoryActive(4);
                  gotoPage(0);
                  setIndexPage(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className="avatar-title fw-semibold rounded-circle fs-14 text-dark" style={{ background: "#BDB395" }}>
                      {salesOriginalList.filter((sales) => sales.statusDealId === 4 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                    </div>
                  </div>
                  <div className="col-auto fs-11 text-center flex-grow-1"> KANTOR</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate pt-2 pb-2 pe-3 ps-3"
                style={{ width: 100 / 6 + "%", cursor: "pointer", minHeight: "34px", verticalAlign: "middle", border: "1px solid #75fb4c" }}
                onClick={() => {
                  toggleProgress(5);
                  setCategoryActive(5);
                  gotoPage(0);
                  setIndexPage(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className="avatar-title fw-semibold rounded-circle fs-14 text-dark" style={{ background: "#75fb4c" }}>
                      {salesOriginalList.filter((sales) => sales.statusDealId === 5 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                    </div>
                  </div>
                  <div className="col-auto fs-11 text-center flex-grow-1"> BANK</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate pt-2 pb-2 pe-3 ps-3"
                style={{ width: 100 / 6 + "%", cursor: "pointer", minHeight: "34px", verticalAlign: "middle", border: "1px solid #ffff55" }}
                onClick={() => {
                  toggleProgress(6);
                  setCategoryActive(6);
                  gotoPage(0);
                  setIndexPage(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className="avatar-title fw-semibold rounded-circle fs-14 text-dark" style={{ background: "#ffff55" }}>
                      {salesOriginalList.filter((sales) => sales.statusDealId === 6 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                    </div>
                  </div>
                  <div className="col-auto fs-11 text-center flex-grow-1"> SP3K</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate pt-2 pb-2 pe-3 ps-3"
                style={{ width: 100 / 6 + "%", cursor: "pointer", minHeight: "34px", verticalAlign: "middle", border: "1px solid #9ACBD0" }}
                onClick={() => {
                  toggleProgress(7);
                  setCategoryActive(6);
                  gotoPage(0);
                  setIndexPage(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className="avatar-title fw-semibold rounded-circle fs-14 text-dark" style={{ background: "#9ACBD0" }}>
                      {salesOriginalList.filter((sales) => sales.statusDealId === 7 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                    </div>
                  </div>
                  <div className="col-auto fs-11 text-center flex-grow-1"> SP3K FINAL</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate pt-2 pb-2 pe-3 ps-3"
                style={{ width: 100 / 6 + "%", cursor: "pointer", minHeight: "34px", verticalAlign: "middle", border: "1px solid #75fbfd" }}
                onClick={() => {
                  toggleProgress(8);
                  setCategoryActive(7);
                  gotoPage(0);
                  setIndexPage(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className="avatar-title fw-semibold rounded-circle fs-14 text-dark" style={{ background: "#75fbfd" }}>
                      {salesOriginalList.filter((sales) => sales.statusDealId === 8 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                    </div>
                  </div>
                  <div className="col-auto fs-11 text-center flex-grow-1"> AKAD</div>
                </div>
              </div>
            </div>
          </Col>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-1">
                <div className="align-items-center">
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                          setSalesList(applicants);
                          setSalesOriginalList(applicants);
                          setSearchType("");
                          setFilterDate(null);
                          setCategoryActive(3);
                        }}
                        href="#"
                      >
                        <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> SEMUA PENJUALAN
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
                <Row className="mb-3">
                  <CardBody className="border border-top-0 border-end-0 border-start-0 pb-1">
                    <Row>
                      <Col sm={1}>
                        <div className="me-2 mb-3 col-12">
                          <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                            {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                              <option key={pageSize} value={pageSize}>
                                {pageSize}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col sm={3}>
                        <div className="me-2 mb-3 d-inline-block col-12">
                          <input
                            id="search-bar-0"
                            type="text"
                            className="form-control search"
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                              onChange(e.target.value);
                              gotoPage(0);
                              setIndexPage(0);
                            }}
                            placeholder={`${countSearch} Search...`}
                            value={searchValue ?? ""}
                          />
                          {/* <i className="bx bx-search-alt search-icon"></i> */}
                        </div>
                      </Col>
                      <Col sm={3}>
                        <Select
                          name="searchType"
                          value={searchType}
                          placeholder="Jenis Penjualan"
                          onChange={(e) => {
                            setSearchType(e);
                            toggleType(e.value);
                          }}
                          options={salesTypeList}
                        ></Select>
                      </Col>
                      <Col sm={3}>
                        <div className="me-2 mb-3 col-12">
                          <Flatpickr
                            className="form-control"
                            id="datepicker-publish-input"
                            placeholder="Pilih Tanggal"
                            options={{
                              mode: "range",
                              dateFormat: "Y/m/d",
                            }}
                            value={filterDate}
                            onChange={(selectedDates, dateStr) => {
                              setFilterDate(dateStr);
                            }}
                          />
                          {/* <i className="bx bx-calendar-alt search-icon"></i> */}
                        </div>
                      </Col>
                      <Col sm={2}>
                        <div className="hstack gap-2">
                          <button
                            type="button"
                            className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                            onClick={() => {
                              handleFilter();
                            }}
                          >
                            <i className="ri-search-line align-bottom fs-16"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                            onClick={() => {
                              handleResetFilter();
                            }}
                          >
                            <i className="mdi mdi-restore align-bottom fs-18"></i>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Row>
                <div className="table-responsive table-card mb-1" style={{ minHeight: "420px" }}>
                  <Table hover {...getTableProps()} className="align-middle">
                    <thead className="table-light">
                      {headerGroups.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                  <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                        {"<"}
                      </Button>
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    Halaman {pageIndex + 1} dari {pageOptions.length}
                  </Col>
                  <Col className="col-md-auto">
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} value={pageIndex + 1} onChange={onChangeInInput} />
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                        {">"}
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Modal id="showModalDate" isOpen={modalDate} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDate}>
                    {!!isEdit ? "Form Penjualan" : "Form Penjualan"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDate.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody className={info && info.statusId > 1 ? "border-bottom ps-4 pe-4 position-relative" : "ps-4 pe-4 position-relative d-none"}>
                        <Row>
                          <Col lg={5} className="ms-auto">
                            <div className="row">
                              <div className="mb-1 fs-16 fw-semibold">{info && info.sales_company && info.sales_company.name}</div>
                              <div className="mb-1 fs-14">{info && info.sales_branch && info.sales_branch.name}</div>
                              <div className="mb-3 fs-14">{info && info.sales_type && info.sales_type.name}</div>
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={6} className="ms-auto">
                            <div className="mb-2 fs-14 fw-semibold">No Penjualan : {info && info.code && info.code}</div>
                            <div className="mb-2 fs-14 fw-semibold">Bank Pengajuan : {info && info.sls_bb && info.sls_bb.name}</div>
                            <div className="mb-2 fs-14 fw-semibold">
                              {info && info.sales_agent && info.sales_agent.name} <span className="badge text-uppercase badge-soft-info fs-12">{info && info.sales_customer && info.sales_customer.name}</span>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="pt-0 pb-4 ps-4 pe-4">
                        <h4 className="mb-3 pt-3">Koreksi Tanggal Penjualan</h4>
                        <div className="row mb-3">
                          <div className="mb-3 col-lg-6">
                            <label>Tanggal Booking</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationDate.setFieldValue("transactionat", dateStr);
                              }}
                              value={validationDate.values.transactionat ?? ""}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label>Tanggal Kantor</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationDate.setFieldValue("docat", dateStr);
                              }}
                              value={validationDate.values.docat ?? ""}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label>Tanggal Pengajuan</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationDate.setFieldValue("bankat", dateStr);
                              }}
                              value={validationDate.values.bankat ?? ""}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label>Tanggal SP3K</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationDate.setFieldValue("sp3at", dateStr);
                              }}
                              value={validationDate.values.sp3at ?? ""}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label>Tanggal Akad</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationDate.setFieldValue("completedat", dateStr);
                              }}
                              value={validationDate.values.completedat ?? ""}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label>Promo Penjualan</label>
                            <Select
                              name="sales_promo"
                              placeholder="Pilih Diskon Penjualan"
                              value={validationDate.values.sales_promo}
                              onChange={(e) => {
                                validationDate.setFieldValue("sales_promo", e);
                              }}
                              options={salesPromoList}
                            ></Select>
                          </div>
                        </div>

                        <h4 className="mb-3">Koreksi Transaksi Penjualan</h4>
                        <div className="row">
                          <div className="mb-3 col-lg-6">
                            <Label className="form-label">Biaya Proses SP3K</Label>
                            <CurrencyInput id="process_amount" name="process_amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control fw-semibold" placeholder="Input Nilai Kontrak" value={validationDate.values.process_amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validationDate.setFieldValue("process_amount", value)} />
                            {validationDate.touched.process_amount && validationDate.errors.process_amount && (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validationDate.errors.process_amount}
                              </p>
                            )}
                          </div>
                          <div className="mb-3 col-lg-6">
                            <Label className="form-label">Diskon Penjualan</Label>
                            <CurrencyInput id="disc_amount" name="disc_amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control fw-semibold" placeholder="Input Nilai Kontrak" value={validationDate.values.disc_amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validationDate.setFieldValue("disc_amount", value)} />
                            {validationDate.touched.disc_amount && validationDate.errors.disc_amount && (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validationDate.errors.disc_amount}
                              </p>
                            )}
                          </div>

                          <div className="mb-3 col-lg-6">
                            <Label className="form-label">Booking / Tanda Jadi</Label>
                            <CurrencyInput id="book_amount" name="book_amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control fw-semibold" placeholder="Input Nilai Kontrak" value={validationDate.values.book_amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validationDate.setFieldValue("book_amount", value)} />
                            {validationDate.touched.book_amount && validationDate.errors.book_amount && (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validationDate.errors.book_amount}
                              </p>
                            )}
                          </div>

                          <div className="mb-3 col-lg-6">
                            <Label className="form-label">Uang Muka</Label>
                            <CurrencyInput id="handling_amount" name="handling_amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control fw-semibold" placeholder="Input Nilai Kontrak" value={validationDate.values.handling_amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validationDate.setFieldValue("handling_amount", value)} />
                            {validationDate.touched.handling_amount && validationDate.errors.handling_amount && (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validationDate.errors.handling_amount}
                              </p>
                            )}
                          </div>

                          <div className="mb-3 col-lg-6">
                            <Label className="form-label">Harga Rumah</Label>
                            <CurrencyInput id="sub_amount" name="sub_amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control fw-semibold" placeholder="Input Nilai Kontrak" value={validationDate.values.sub_amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validationDate.setFieldValue("sub_amount", value)} />
                            {validationDate.touched.sub_amount && validationDate.errors.sub_amount && (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validationDate.errors.sub_amount}
                              </p>
                            )}
                          </div>

                          <div className="mb-3 col-lg-6">
                            <Label className="form-label">ACC SP3K</Label>
                            <CurrencyInput id="credit_amount" name="credit_amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control fw-semibold" placeholder="Input Nilai Kontrak" value={validationDate.values.credit_amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validationDate.setFieldValue("credit_amount", value)} />
                            {validationDate.touched.credit_amount && validationDate.errors.credit_amount && (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validationDate.errors.credit_amount}
                              </p>
                            )}
                          </div>

                          <div className="mb-3 col-lg-6">
                            <Label className="form-label">Harga Total Penjualan</Label>
                            <CurrencyInput id="total_amount" name="total_amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control fw-semibold" placeholder="Input Nilai Kontrak" value={validationDate.values.total_amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validationDate.setFieldValue("total_amount", value)} />
                            {validationDate.touched.total_amount && validationDate.errors.total_amount && (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validationDate.errors.total_amount}
                              </p>
                            )}
                          </div>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDate(false);
                            validationDate.resetForm({});
                          }}
                        >
                          TUTUP
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {"PERBARUI DATA PENJUALAN"}
                            &nbsp;
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Form Penjualan" : "Form Penjualan"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody className={validation.values.statusId > 1 ? "border-bottom ps-4 pe-4 position-relative" : "ps-4 pe-4 position-relative d-none"}>
                        <Row>
                          <Col lg={5} className="ms-auto">
                            <div className="row">
                              <div className="mb-1 fs-16 fw-semibold">{validation.values.company && validation.values.company.label}</div>
                              <div className="mb-1 fs-14">{validation.values.branch && validation.values.branch.label}</div>
                              <div className="mb-3 fs-14">{validation.values.sales_type && validation.values.sales_type.label}</div>
                            </div>
                          </Col>
                          <Col lg={2}></Col>
                          <Col lg={5} className="ms-auto">
                            <table className="mb-3 w-100">
                              <tbody>
                                <tr>
                                  <td className="pt-1">No Penjualan</td>
                                  <td className="pt-1 pe-2 ps-2">:</td>
                                  <td className="pt-1">{validation.values.code && validation.values.code}</td>
                                </tr>
                                <tr>
                                  <td className="pt-1">Debitur</td>
                                  <td className="pt-1 pe-2 ps-2">:</td>
                                  <td className="pt-1">
                                    {validation.values.customer && validation.values.customer.label} <span className="badge text-uppercase badge-soft-info fs-12">{validation.values.agent && validation.values.agent.label}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="pt-1">Bank Pengajuan</td>
                                  <td className="pt-1 pe-2 ps-2">:</td>
                                  <td className="pt-1">
                                    <Select
                                      name="sls_bb"
                                      value={validation.values.sls_bb}
                                      placeholder="Pilih Bank Pengajuan"
                                      onChange={(e) => {
                                        validation.setFieldValue("sls_bb", e);
                                      }}
                                      options={bankBranchList}
                                    ></Select>
                                    {validation.touched.sls_bb && validation.errors.sls_bb && (
                                      <small className="text-danger" type="invalid">
                                        {validation.errors.sls_bb}
                                      </small>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className={validation.values.statusId > 1 ? "pt-4 ps-4 pe-4 border-top" : "pt-4 ps-4 pe-4 border-top d-none"}>
                        <h4 className="mb-3">
                          Pemilihan Unit
                          {validation.values.item.length === 0 && (
                            <Link
                              to="#"
                              className="btn btn-soft-success fw-medium ms-2"
                              id="add-item"
                              onClick={() => {
                                handleSalesDetailAdd();
                              }}
                            >
                              <i className="ri-add-fill me-1 align-bottom"></i>Tambah Unit
                            </Link>
                          )}
                        </h4>
                        {productVarianLoading && (
                          <div className="position-absolute top-0">
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </div>
                        )}
                        <div>
                          <div>
                            <Table className="invoice-table table-borderless table-nowrap mb-0">
                              <thead className="align-middle">
                                <tr className="table-active">
                                  <th scope="col" style={{ width: "20px" }}>
                                    #
                                  </th>
                                  <th scope="col">Unit Yang Dipilih</th>
                                  {/* <th scope="col" className="text-center" style={{ width: "150px" }}>{"Status Pemilihan"}</th> */}
                                  <th scope="col" className="text-center" style={{ width: "150px" }}>
                                    Harga Jual
                                  </th>
                                  <th scope="col" className="text-center" style={{ width: "150px" }}>
                                    Booking
                                  </th>
                                  <th scope="col" className="text-center" style={{ width: "150px" }}>
                                    Uang Muka
                                  </th>
                                  <th scope="col" className="text-center" style={{ width: "150px" }}>
                                    {"> Tanah"}
                                  </th>
                                  <th scope="col" className="text-center" style={{ width: "150px" }}>
                                    {"Total > Tanah"}
                                  </th>
                                  <th scope="col" className="text-end" style={{ width: "35px" }}></th>
                                </tr>
                              </thead>
                              <tbody id="newlink">
                                {validation.values.item.map((o, i) => {
                                  return (
                                    <tr key={i} id={i} className="product">
                                      <th scope="row" className="product-id">
                                        {i + 1}
                                      </th>
                                      <td className="text-start">
                                        <div className="row">
                                          <div className="col-sm-11 m-0 p-0 pe-1">
                                            <Select
                                              name="item"
                                              value={validation.values.item[i].item ?? ""}
                                              placeholder="Select Product"
                                              onChange={(e) => {
                                                validation.values.item[i].item = e;
                                                validation.values.item[i].sku = e.sku;
                                                validation.values.item[i].barcode = e.barcode;
                                                validation.values.item[i].itemId = e.value;
                                                validation.values.item[i].brandId = e.brandId;
                                                validation.values.item[i].quantity = 1;
                                                validation.values.item[i].amount = parseFloat(e.price);
                                                validation.values.item[i].land_excess = e.land_excess;
                                                validation.values.item[i].land_price = e.land_price;
                                                validation.values.item[i].price_handling = e.price_handling;
                                                validation.values.item[i].price_dp = 0.01 * parseFloat(sales.sub_amount);
                                                validation.setFieldValue("sub_amount", e.amount * 1);
                                              }}
                                              options={productList}
                                              validate={{ required: { value: true } }}
                                            ></Select>
                                          </div>
                                          <div className="col-sm-1 m-0 p-0">
                                            <Link
                                              to="#"
                                              className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                              onClick={() => {
                                                onClickDeleteDetailItem(i);
                                              }}
                                            >
                                              <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </td>
                                      {/* <td>
                                      <Select
                                        name="status"
                                        value={validation.values.item[i].status}
                                        placeholder="Select Status"
                                        onChange={(e) => {
                                          validation.values.item[i].statusId = e.value;
                                          validation.values.item[i].status = e;
                                          validation.setFieldValue("sub_amount", e.amount);
                                        }}
                                        options={statusSalesData}
                                      ></Select></td> */}
                                      <td className="text-center fs-14">
                                        {currencyFormat(validation.values.item[i].amount)}
                                        <Input
                                          disabled={true}
                                          name="amount"
                                          placeholder="Price"
                                          type="text"
                                          className="form-control product-price d-none"
                                          style={{ width: "100px" }}
                                          value={validation.values.item[i].amount || 0}
                                          onChange={(e) => {
                                            let val = parseFloat(e.target.value);
                                            if (!isNaN(val)) {
                                              validation.values.item[i].amount = val;
                                              validation.values.item[i].total = val * validation.values.item[i].quantity;
                                            } else {
                                              validation.values.item[i].amount = 0;
                                              validation.values.item[i].total = 0;
                                            }
                                          }}
                                          onBlur={validation.handleBlur}
                                        />
                                      </td>
                                      <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat(parseFloat(info.book_amount))}</td>
                                      <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat(parseFloat(validation.values.item[i].price_handling))}</td>
                                      <td className="text-center fs-14">
                                        {parseInt(validation.values.item[i].land_excess) || 0} M<sup>2</sup> <span className="fs-12">({currencyFormat(validation.values.item[i].land_price || 0)})</span>
                                      </td>
                                      <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat(parseFloat(validation.values.item[i].land_price) * parseFloat(validation.values.item[i].land_excess) || 0)}</td>
                                    </tr>
                                  );
                                })}
                                {validation.values.item.length === 0 && (
                                  <tr>
                                    <td colSpan="7" className="p-3 text-center fs-14">
                                      Unit belum ditambahkan
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                          <div className="row border-top">
                            <div className="col-lg-5 mt-3">
                              {validation.values.item.length > 0 && validation.values.sales_type && (validation.values.sales_type.value === 1 || validation.values.sales_type.value === 2) && (
                                <>
                                  <div className="mb-3">
                                    <label className="text-muted">Maksimum KPR : </label>
                                    <div className="fw-semibold fs-15">{validation.values.item[0].amount && currencyFormat(parseFloat(validation.values.item[0].amount) - (parseFloat(validation.values.item[0].amount) * (1 / 100) + validation.values.branch.sbum) || 0)}</div>
                                  </div>
                                  <div className="mb-3">
                                    <div className="input-group">
                                      <span className="input-group-text">ACC KPR (RP)</span>
                                      <Input
                                        name="credit_amount"
                                        id="credit_amount"
                                        className="form-control-lg"
                                        placeholder="ACC KPR"
                                        type="number"
                                        value={validation.values.credit_amount}
                                        onFocus={(e) => e.target.select()}
                                        onChange={(e) => {
                                          let val = parseFloat(e.target.value);
                                          let subsidi = validation.values.sales_type.value === 1 ? validation.values.branch.sbum : 0;
                                          let maxKPR = parseFloat(validation.values.item[0].amount) - (parseFloat(validation.values.item[0].amount) * (1 / 100) + subsidi);
                                          let handling = parseFloat(validation.values.item[0].price_handling);
                                          let booking = parseFloat(info.book_amount);
                                          let land = validation.values.item[0].land_excess && validation.values.item[0].land_price ? parseFloat(validation.values.item[0].land_price) * parseFloat(validation.values.item[0].land_excess) : 0;
                                          validation.setFieldValue("handling_amount", handling);
                                          if (!isNaN(val)) {
                                            if (val >= maxKPR) {
                                              validation.setFieldValue("credit_amount", maxKPR);
                                              validation.values.item[0].credit_amount = maxKPR;
                                              validation.values.item[0].credit_decreased = parseFloat(validation.values.item[0].amount) - (parseFloat(validation.values.item[0].amount) * (1 / 100) + subsidi) - maxKPR;
                                            } else {
                                              validation.setFieldValue("credit_amount", val);
                                              validation.values.item[0].credit_amount = val;
                                              validation.values.item[0].credit_decreased = parseFloat(validation.values.item[0].amount) - (parseFloat(validation.values.item[0].amount) * (1 / 100) + subsidi) - val;
                                            }
                                          } else {
                                            validation.setFieldValue("credit_amount", 0);
                                            validation.values.item[0].credit_amount = 0;
                                            validation.values.item[0].credit_decreased = parseFloat(validation.values.item[0].amount) - (parseFloat(validation.values.item[0].amount) * (1 / 100) + subsidi) - 0;
                                          }
                                          validation.setFieldValue("total_amount", validation.values.item[0].credit_decreased + land + handling + booking);
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                </>
                              )}
                              <div className="row">
                                <div className="mb-3 col-lg-7">
                                  <Select
                                    name="status_bank"
                                    value={validation.values.status_bank}
                                    placeholder="Pilih Status Approval Bank"
                                    onChange={(e) => {
                                      validation.setFieldValue("status_bank", e);
                                    }}
                                    options={statusBankData}
                                  ></Select>
                                </div>
                                <div className="mb-3 col-lg-5">
                                  <Input name="process_amount" id="customername-field" className="form-control" placeholder="Input Biaya Proses" type="number" onFocus={(e) => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.process_amount ?? ""} invalid={validation.touched.process_amount && validation.errors.process_amount ? true : false} />
                                </div>
                                <div className="mb-3 col-lg-7">
                                  <Flatpickr
                                    className="form-control"
                                    id="datepicker-publish-input"
                                    placeholder="Pilih Tanggal SP3K"
                                    options={{
                                      mode: "single",
                                      dateFormat: "Y/m/d",
                                    }}
                                    onChange={(selectedDates, dateStr) => {
                                      validation.setFieldValue("bankat", dateStr);
                                    }}
                                    value={validation.values.bankat ?? ""}
                                  />
                                </div>
                                <div className="mb-3 col-lg-5">
                                  <Input name="tenor" id="customername-field" className="form-control" placeholder="Input tenor" type="number" onFocus={(e) => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tenor ?? ""} invalid={validation.touched.tenor && validation.errors.tenor ? true : false} />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-2"></div>
                            <div className="col-lg-5 mt-3">
                              {validation.values.item.length > 0 && validation.values.sales_type && (validation.values.sales_type.value === 1 || validation.values.sales_type.value === 2) && (
                                <>
                                  <div className="mb-3">
                                    <label className="text-muted">Penurunan KPR : </label>
                                    <div className="fw-semibold fs-15 text-danger">{validation.values.item[0].amount && currencyFormat(parseFloat(validation.values.item[0].amount) - (parseFloat(validation.values.item[0].amount) * (1 / 100) + (validation.values.sales_type.value === 1 ? validation.values.branch.sbum : 0)) - validation.values.credit_amount || 0)}</div>
                                  </div>
                                  <div className="mb-3">
                                    <div className="input-group">
                                      <span className="input-group-text">TOTAL (RP)</span>
                                      <Input name="total_amount" id="total_amount" className="form-control-lg fw-semibold" disabled={true} placeholder="Input jumlah penerimaan" type="number" value={validation.values.total_amount} onChange={validation.handleChange} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} />
                                    </div>
                                  </div>
                                </>
                              )}
                              <div className="mb-3">
                                <Input type="textarea" className="form-control" id="description_bank" placeholder="Keterangan Bank (Jika Ada)" name="description_bank" rows={3} value={validation.values.description_bank ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.description_bank && validation.errors.description_bank ? true : false} />
                              </div>
                            </div>
                          </div>
                          {validation.values.item.length > 0 && validation.values.sales_type && (validation.values.sales_type.value === 1 || validation.values.sales_type.value === 2) && (
                            <div className="pt-4 border-top">
                              <h4 className="mb-3">Jadwal Akad</h4>
                              <div className="row">
                                <div className="mb-3 col-lg-4">
                                  <Flatpickr
                                    className="form-control input-lg"
                                    id="datepicker-publish-input"
                                    placeholder="Pilih Tanggal Akad"
                                    options={{ mode: "single", dateFormat: "Y/m/d" }}
                                    onChange={(selectedDates, dateStr) => {
                                      validation.setFieldValue("completedat", dateStr);
                                    }}
                                    value={validation.values.completedat ?? ""}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="pt-4 border-top">
                            <h4 className="mb-3">Keterangan</h4>
                            <div className="mb-3">
                              <Input type="textarea" className="form-control" id="description" placeholder="Keterangan (Jika Ada)" name="description" rows={3} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.description && validation.errors.description ? true : false} />
                            </div>
                            <h4 className="mb-3">
                              Bukti dan Dokumen Penjualan
                              <button
                                type="button"
                                className="btn ms-2 btn-sm btn-label btn-soft-success"
                                onClick={() => {
                                  toggleMedia();
                                }}
                              >
                                <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                              </button>
                            </h4>
                            <div className="mb-3">
                              {salesImg.map((f, i) => {
                                if (f.isDeleted) {
                                  return null;
                                } else {
                                  return (
                                    <div key={i} className="border-bottom mb-3">
                                      <div className="d-flex justify-content-between mb-3 align-items-center">
                                        <div className="me-2">
                                          {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                            <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                          ) : (
                                            <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                              <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                            </Link>
                                          )}
                                        </div>
                                        <div className="text-truncate">{f.originalname}</div>
                                        <div>
                                          <Link
                                            to="#"
                                            className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                            onClick={(e) => {
                                              handleDeleteFile(f);
                                            }}
                                          >
                                            <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            validation.resetForm({});
                          }}
                        >
                          TUTUP
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            UPDATE DATA PENJUALAN
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalReceipt" isOpen={modalReceipt} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleReceipt}>
                    KWITANSI PEMBAYARAN
                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col lg={12}>
                        <div className="hero-kwitansi" style={{ padding: "20px 20px 20px 20px" }}>
                          {(companySelected?.value === 1 || companySelected?.value === 4) &&
                            <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
                              <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
                                <img src={logoHas} alt="" height="80" width="80" />
                              </div>
                              <div style={{ textAlign: "left" }}>
                                <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{companySelected?.label}</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                              </div>
                            </div>
                          }

                          {companySelected?.value === 2 &&
                            <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
                              <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
                                <img src={logoCms} alt="" height="80" width="80" />
                              </div>
                              <div style={{ textAlign: "left" }}>
                                <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{companySelected?.label}</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                              </div>
                            </div>
                          }

                          {companySelected?.value === 3 &&
                            <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
                              <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
                                <img src={logoWAP} alt="" height="80" width="80" />
                              </div>
                              <div style={{ textAlign: "left" }}>
                                <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{companySelected?.label}</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Jl Sudarmanik Desa Jagabaya Kec. Parung Panjang, Bogor</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                              </div>
                            </div>
                          }
                          <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", paddingTop: "30px", paddingBottom: "30px", display: "flex", justifyContent: "center", alignItems: "center", padding: "5px 0", marginBottom: "10px", fontSize: "22px", fontWeight: "bold" }}>KWITANSI</div>
                          <div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "5px 0", marginBottom: "10px" }}>{`No : ${branchCode ?? ""}${receiptCode ?? "-"}`}</div>
                            <table style={{ marginTop: "10px", width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <tbody>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Telah Diterima Dari</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{receiptName ?? "-"}</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Banyaknya Uang</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{`${receiptAmount !== null ? `${numberToWords(receiptAmount)}` : "-"}`}</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Untuk Pembayaran</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{receiptCode ? `Sales Invoice #${branchCode ?? ""}${receiptCode}` : "-"}</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Keterangan</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{receiptNote}</td>
                                </tr>
                              </tbody>
                            </table>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                              <div style={{ flex: "1 1 0%", marginTop: "40px" }}>
                                <div style={{ display: "flex", fontSize: "18px", fontWeight: "bold" }}>
                                  <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", padding: "10px 20px" }}>Jumlah</div>
                                  <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", padding: "10px 20px", backgroundColor: "rgb(255, 170, 0)" }}>{`Rp. ${currencyFormat(receiptAmount ?? 0)}`}</div>
                                </div>
                              </div>
                              <div style={{ textAlign: "center" }}>
                                <p style={{ marginTop: "30px", padding: "0", lineHeight: "0" }}>Bogor, {handleValidDate(receiptDate, "D MMM YYYY")}</p>
                                {companySelected?.label}
                                <div style={{ textAlign: "center", padding: "10px 0px" }}>
                                  <QRCodeSVG value={`https://pkg.pkdeveloper.id/qr/sl${receiptCode}-${companySelected?.value}`} size={90} bgColor={"#ffffff"} fgColor={"#000000"} level={"L"} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setDetailType("detail");
                          setModalReceipt(false);
                          if (!isEdit) setModalDetail(true);
                        }}
                      >
                        TUTUP
                      </button>
                      <ButtonPrintReceipt innerRef={printRef} title={`KWITANSI-${receiptName ?? "-"}`} />
                    </div>
                  </div>
                </Modal>

                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>
                    KONFIRMASI DATA
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationApprove.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="text-center">
                        <lord-icon src="https://cdn.lordicon.com/puvaffet.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <p className="fs-16">{sales && sales.actionTitle}</p>
                        </div>
                        <div className="mt-3 col-lg-12">
                          <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Enter Notes If Any" rows={4} type="textarea" onChange={validationApprove.handleChange} onBlur={validationApprove.handleBlur} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalApprove(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModal" isOpen={modalCustomer} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleCustomer}>
                    {!!isEdit ? "Edit Konsumen" : "Tambah Konsumen"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationCustomer.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3 d-none">
                            <Label htmlFor="agent-field" className="form-label">
                              Marketing
                              {agentLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="agent"
                              value={validationCustomer.values.agent}
                              placeholder="Select Marketing / Agent"
                              isDisabled={agentList.length > 0 ? false : true}
                              onChange={(e) => {
                                validationCustomer.setFieldValue("agent", e);
                              }}
                              options={agentList}
                            ></Select>
                            {validationCustomer.touched.agent && validationCustomer.errors.agent && <FormFeedback type="invalid">{validationCustomer.errors.agent}</FormFeedback>}
                          </div>

                          <div className="mb-3 d-none">
                            <Label htmlFor="customerGroup-field" className="form-label">
                              Customer Group (Optional)&nbsp;
                              {customerGroupsLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="customerGroup"
                              value={validationCustomer.values.customerGroup}
                              placeholder="Select Customer Group"
                              isDisabled={customerGroupList.length > 0 ? false : true}
                              onChange={(e) => {
                                validationCustomer.setFieldValue("customerGroup", e);
                              }}
                              options={customerGroupList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="customername-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="customername-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.name ?? ""} invalid={validationCustomer.touched.name && validationCustomer.errors.name ? true : false} />
                            {validationCustomer.touched.name && validationCustomer.errors.name ? <FormFeedback type="invalid">{validationCustomer.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="password-field" className="form-label">
                              Password <span className="text-danger">*</span>
                            </Label>
                            <Input name="password" id="password-field" className="form-control" placeholder="Isi Password" type="password" validate={{ required: { value: true } }} onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.password ?? ""} invalid={validationCustomer.touched.password && validationCustomer.errors.password ? true : false} />
                            {validationCustomer.touched.password && validationCustomer.errors.password ? (
                              <small className="text-danger" type="invalid">
                                {validationCustomer.errors.password}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="phone-field" className="form-label">
                              No Telepon
                            </Label>
                            <Input name="phone" id="phone-field" className="form-control" placeholder="Isi No. Telepon" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.phone ?? ""} invalid={validationCustomer.touched.phone && validationCustomer.errors.phone ? true : false} />
                            {validationCustomer.touched.phone && validationCustomer.errors.phone ? <FormFeedback type="invalid">{validationCustomer.errors.phone}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="email-field" className="form-label">
                              Email
                            </Label>
                            <Input name="email" id="email-field" className="form-control" placeholder="Isi Email" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.email ?? ""} invalid={validationCustomer.touched.email && validationCustomer.errors.email ? true : false} />
                            {validationCustomer.touched.email && validationCustomer.errors.email && <FormFeedback type="invalid">{validationCustomer.errors.email}</FormFeedback>}
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="des-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="address" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.address ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="street-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="street" id="street-field" className="form-control" placeholder="Isi Alamat" type="textarea" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.street} invalid={validationCustomer.touched.street && validationCustomer.errors.street ? true : false} />
                            {validationCustomer.touched.street && validationCustomer.errors.street && <FormFeedback type="invalid">{validationCustomer.errors.street}</FormFeedback>}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="zip-field" className="form-label">
                              Kode Pos
                            </Label>
                            <Input name="zip" id="zip-field" className="form-control" placeholder="Isi Kode Pos" type="number" validate={{ required: { value: true } }} onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.zip ?? ""} />
                          </div>
                        </div>
                        <div className="col-lg-6 mb-3">
                          <div className="row">
                            <div className="col-md-5 mb-3">
                              <Label htmlFor="identity_type" className="form-label">
                                Jenis ID
                                {identityTypeLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="identity_type"
                                value={validationCustomer.values.identity_type}
                                placeholder="Jenis ID"
                                onChange={(e) => {
                                  validationCustomer.setFieldValue("identity_type", e);
                                }}
                                options={identityTypeList}
                              ></Select>
                              {validationCustomer.touched.identity_type && validationCustomer.errors.identity_type ? (
                                <small className="text-danger" type="invalid">
                                  {validationCustomer.errors.identity_type}
                                </small>
                              ) : null}
                            </div>
                            <div className="col-md-7 mb-3">
                              <Label htmlFor="identity_type" className="form-label">
                                Nomor Identitas
                              </Label>
                              <Input name="identity" id="identity-field" className="form-control" placeholder="Isi No. Identitas" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.identity ?? ""} invalid={validationCustomer.touched.identity && validationCustomer.errors.identity ? true : false} />
                              {validationCustomer.touched.identity && validationCustomer.errors.identity ? <FormFeedback type="invalid">{validationCustomer.errors.identity}</FormFeedback> : null}
                            </div>
                          </div>
                          <div className=" mb-3">
                            <Label htmlFor="bank-field" className="form-label">
                              Bank
                            </Label>
                            <Select
                              name="bank"
                              value={validationCustomer.values.bank}
                              placeholder="Pilih Bank"
                              onChange={(e) => {
                                validationCustomer.setFieldValue("bank", e);
                              }}
                              options={bankList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="number-field" className="form-label">
                              No. Rekening
                            </Label>
                            <Input name="number" id="number-field" className="form-control" placeholder="Isi No. Rekening" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.number ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="tax_number-field" className="form-label">
                              No. Pajak
                            </Label>
                            <Input name="tax_number" id="tax_number-field" className="form-control" placeholder="Input No. Pajak" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.tax_number ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="insurance_number-field" className="form-label">
                              No. BPJS
                            </Label>
                            <Input name="insurance_number" id="insurance_number-field" className="form-control" placeholder="Isi No. Pajak" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.insurance_number ?? ""} />
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="description-field" className="form-label">
                              Customer Description (optional)
                            </Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Input Keterangan" type="textarea" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.description} />
                          </div>
                          <div className="mb-3 position-relative">
                            <Label htmlFor="customer_contact" className="form-label">
                              Kontak Darurat
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                handleCustomerContactAdd();
                              }}
                            >
                              <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Add
                            </button>
                          </div>
                          {customerContactItem.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3 d-flex gap-3 align-items-center">
                                <div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Nama Kontak
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.name`}
                                        className="form-control"
                                        placeholder="Isi Nama Kontak"
                                        type="text"
                                        value={customerContactItem[i].name ?? ""}
                                        onChange={(e) => {
                                          validationCustomer.setFieldValue(`customerContactItem.${i}.name`, e.target.value);
                                          customerContactItem[i].name = e.target.value;
                                        }}
                                        onBlur={validationCustomer.handleBlur}
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        No. Telp Kontak
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.phone`}
                                        className="form-control"
                                        placeholder="Isi Telepon"
                                        type="text"
                                        value={customerContactItem[i].phone ?? ""}
                                        onChange={(e) => {
                                          validationCustomer.setFieldValue(`customerContactItem.${i}.phone`, e.target.value);
                                          customerContactItem[i].phone = e.target.value;
                                        }}
                                        onBlur={validationCustomer.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Email
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.email`}
                                        className="form-control"
                                        placeholder="Isi Email"
                                        type="text"
                                        value={customerContactItem[i].email ?? ""}
                                        onChange={(e) => {
                                          validationCustomer.setFieldValue(`customerContactItem.${i}.email`, e.target.value);
                                          customerContactItem[i].email = e.target.value;
                                        }}
                                        onBlur={validationCustomer.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Hubungan Dengan Konsumen
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.position`}
                                        className="form-control"
                                        placeholder="Isi Hubungan Dengan Konsumen"
                                        type="text"
                                        value={customerContactItem[i].position ?? ""}
                                        onChange={(e) => {
                                          validationCustomer.setFieldValue(`customerContactItem.${i}.position`, e.target.value);
                                          customerContactItem[i].position = e.target.value;
                                        }}
                                        onBlur={validationCustomer.handleBlur}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <Button
                                  className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                                  style={{ width: "70px" }}
                                  onClick={() => {
                                    setCustomerContactItem((val) => [...val.slice(0, i), ...val.slice(i + 1)]);
                                  }}
                                >
                                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                </Button>
                              </div>
                            );
                          })}
                          <div className="mb-3 position-relative">
                            <Label htmlFor="customer_contact" className="form-label">
                              Dokumen Konsumen
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                toggleMediaCustomer();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {salesImgCustomer.map((f, i) => {
                            if (f.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                        <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                      ) : (
                                        <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                          <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                        </Link>
                                      )}
                                    </div>
                                    <div className="text-truncate">{f.filename}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          handleDeleteFileCustomer(f);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light" onClick={toggleCustomer}>
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update Data Konsumen" : "Simpan Data Konsumen"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalApplicationDoc" isOpen={modalApplicationDoc} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleApplicationDoc}>
                    {!!isEdit ? "KELENGKAPAN BERKAS KPR" : "KELENGKAPAN BERKAS KPR"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationApplicationDoc.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-3">
                          <h5 className="mb-3 bg-soft-info p-2 pb-3">Status Berkas</h5>
                          <div className="mb-3 pb-2">
                            <Select
                              name="status"
                              value={validationApplicationDoc.values.status}
                              placeholder="Pilih Status Berkas"
                              onChange={(e) => {
                                validationApplicationDoc.setFieldValue("status", e);
                              }}
                              options={statusApplicantData}
                            ></Select>
                            <div className="mb-3 mt-3">
                              <Label htmlFor="applicationAt" className="form-label">
                                Tanggal Verifikasi
                              </Label>
                              <Flatpickr
                                name="applicationAt"
                                className="form-control"
                                placeholder="Pilih Tanggal Verifikasi"
                                options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                value={validationApplicationDoc.values.applicationAt ?? ""}
                                onChange={(o, e) => {
                                  validationApplicationDoc.setFieldValue("applicationAt", e);
                                }}
                              />
                              {validationApplicationDoc.touched.applicationAt && validationApplicationDoc.errors.applicationAt ? (
                                <p className="text-danger" type="invalid">
                                  {validationApplicationDoc.errors.applicationAt}
                                </p>
                              ) : null}
                            </div>
                          </div>
                          <h5 className="mb-3 bg-soft-info p-2 pb-3">Daftar Ceklis</h5>
                          <div className="mb-3 pb-2">
                            {applicantDocuments.map((o, idx) => {
                              return (
                                <div key={idx} className="form-check form-switch form-switch-custom form-switch-success mb-3">
                                  <Input className={"form-check-input checked-all checked-method-all check-" + o.id + idx} type="checkbox" role="switch" id={"check-" + o.id + idx} value={o.id} defaultChecked={checkDocumentList.indexOf(o.id.toString()) !== -1 ? true : false} />
                                  <Label className="form-check-label text-dark text-uppercase" htmlFor={"check-" + o.id + idx}>
                                    {o.name}
                                  </Label>
                                </div>
                              );
                            })}
                          </div>

                          <h5 className="mb-3 bg-soft-info p-2 d-flex justify-content-between">
                            Softcopy Berkas
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-success"
                              onClick={() => {
                                toggleMediaApplicationDoc();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-14 pe-0 ps-0"></i> Media
                            </button>
                          </h5>
                          <div className="">
                            {applicationDocImg.map((f, i) => {
                              if (f.isDeleted) {
                                return null;
                              } else {
                                return (
                                  <div key={i} className="border-bottom mb-3">
                                    <div className="d-flex justify-content-between mb-3 align-items-center">
                                      <div className="d-flex align-items-center ">
                                        <div className="me-2">
                                          {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                            <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                          ) : (
                                            <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                              <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                            </Link>
                                          )}
                                        </div>
                                        <div className="text-truncate" style={{ maxWidth: "100px" }}>
                                          {f.originalname}
                                        </div>
                                      </div>
                                      <div>
                                        <Link
                                          to="#"
                                          className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                          onClick={(e) => {
                                            // e.stopPropagation();
                                            handleDeleteFileApplicationDoc(f);
                                          }}
                                        >
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                            {applicationDocImg.length === 0 && <p className="text-center text-danger">Belum upload berkas</p>}
                          </div>
                        </div>
                        <div className="col-lg-9 ps-3 pe-3">
                          <div className="row border-bottom mb-1 pb-2">
                            <h5 className="mb-3 bg-soft-info p-2 pb-3">Data Diri</h5>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="name-field" className="form-label">
                                Nama
                              </Label>
                              <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.name ?? ""} invalid={validationApplicationDoc.touched.name && validationApplicationDoc.errors.name ? true : false} />
                              {validationApplicationDoc.touched.name && validationApplicationDoc.errors.name ? <FormFeedback type="invalid">{validationApplicationDoc.errors.name}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="phone-field" className="form-label">
                                No. Telepon
                              </Label>
                              <Input name="phone" id="phone-field" className="form-control" placeholder="Isi No. Telepon" type="phone" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.phone ?? ""} invalid={validationApplicationDoc.touched.phone && validationApplicationDoc.errors.phone ? true : false} />
                              {validationApplicationDoc.touched.phone && validationApplicationDoc.errors.phone ? <FormFeedback type="invalid">{validationApplicationDoc.errors.phone}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="bttt-field" className="form-label">
                                Best Time To Call
                              </Label>
                              <Input name="bttt" id="bttt-field" className="form-control" placeholder="Best Time To Call" type="phone" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.bttt ?? ""} invalid={validationApplicationDoc.touched.bttt && validationApplicationDoc.errors.bttt ? true : false} />
                              {validationApplicationDoc.touched.bttt && validationApplicationDoc.errors.bttt ? <FormFeedback type="invalid">{validationApplicationDoc.errors.bttt}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="email-field" className="form-label">
                                Email
                              </Label>
                              <Input name="email" id="email-field" className="form-control" placeholder="Isi Email" type="email" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.email ?? ""} invalid={validationApplicationDoc.touched.email && validationApplicationDoc.errors.email ? true : false} />
                              {validationApplicationDoc.touched.email && validationApplicationDoc.errors.email ? <FormFeedback type="invalid">{validationApplicationDoc.errors.email}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="identity-field" className="form-label">
                                No. KTP
                              </Label>
                              <Input name="identity" id="identity-field" className="form-control" placeholder="Isi No. KTP" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.identity ?? ""} invalid={validationApplicationDoc.touched.identity && validationApplicationDoc.errors.identity ? true : false} />
                              {validationApplicationDoc.touched.identity && validationApplicationDoc.errors.identity ? <FormFeedback type="invalid">{validationApplicationDoc.errors.identity}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="bank_no-field" className="form-label">
                                No Rekening
                              </Label>
                              <Input name="bank_no" id="bank_no-field" className="form-control" placeholder="Isi Bank Pemohon" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.bank_no ?? ""} invalid={validationApplicationDoc.touched.bank_no && validationApplicationDoc.errors.bank_no ? true : false} />
                              {validationApplicationDoc.touched.bank_no && validationApplicationDoc.errors.bank_no ? <FormFeedback type="invalid">{validationApplicationDoc.errors.bank_no}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="tax_no-field" className="form-label">
                                NPWP
                              </Label>
                              <Input name="tax_no" id="tax_no-field" className="form-control" placeholder="Isi No. NPWP" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.tax_no ?? ""} invalid={validationApplicationDoc.touched.tax_no && validationApplicationDoc.errors.tax_no ? true : false} />
                              {validationApplicationDoc.touched.tax_no && validationApplicationDoc.errors.tax_no ? <FormFeedback type="invalid">{validationApplicationDoc.errors.tax_no}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="motherName-field" className="form-label">
                                Nama Ibu Kandung
                              </Label>
                              <Input name="motherName" id="motherName-field" className="form-control" placeholder="Isi Nama Ibu Kandung" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.motherName ?? ""} invalid={validationApplicationDoc.touched.motherName && validationApplicationDoc.errors.motherName ? true : false} />
                              {validationApplicationDoc.touched.motherName && validationApplicationDoc.errors.motherName ? <FormFeedback type="invalid">{validationApplicationDoc.errors.motherName}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="birth_place-field" className="form-label">
                                Tempat Lahir
                              </Label>
                              <Input name="birth_place" id="birth_place-field" className="form-control" placeholder="Isi Tempat Lahir" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.birth_place ?? ""} invalid={validationApplicationDoc.touched.birth_place && validationApplicationDoc.errors.birth_place ? true : false} />
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="birth_place-field" className="form-label">
                                Tanggal Lahir
                              </Label>
                              <Flatpickr
                                name="birthat"
                                className="form-control"
                                placeholder="Tanggal Lahir"
                                options={{
                                  enableTime: false,
                                  altInput: true,
                                  altFormat: "Y/m/d",
                                  dateFormat: "Y/m/d",
                                }}
                                value={validationApplicationDoc.values.birthat ?? ""}
                                onChange={(obj, str) => {
                                  validationApplicationDoc.setFieldValue("birthat", str);
                                }}
                              />
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="maritalStatus-field" className="form-label">
                                Status Menikah&nbsp;
                                {maritalLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="maritalStatus"
                                value={validationApplicationDoc.values.maritalStatus}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  validationApplicationDoc.setFieldValue("maritalStatus", e);
                                }}
                                options={maritalList}
                              ></Select>
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="children_number-field" className="form-label">
                                Jumlah Anak
                              </Label>
                              <Input name="children_number" id="children_number-field" className="form-control" placeholder="Isi Jumlah Anak" type="number" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.children_number ?? ""} invalid={validationApplicationDoc.touched.children_number && validationApplicationDoc.errors.children_number ? true : false} />
                              {validationApplicationDoc.touched.children_number && validationApplicationDoc.errors.children_number ? <FormFeedback type="invalid">{validationApplicationDoc.errors.children_number}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="city-field" className="form-label">
                                Kota
                              </Label>
                              <Input name="city" id="city-field" className="form-control" placeholder="Isi Kota" type="city" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.city ?? ""} invalid={validationApplicationDoc.touched.city && validationApplicationDoc.errors.city ? true : false} />
                              {validationApplicationDoc.touched.city && validationApplicationDoc.errors.city ? <FormFeedback type="invalid">{validationApplicationDoc.errors.city}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="address-field" className="form-label">
                                Alamat
                              </Label>
                              <Input name="address" id="address-field" className="form-control" placeholder="Isi Alamat" type="textarea" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.address ?? ""} invalid={validationApplicationDoc.touched.address && validationApplicationDoc.errors.address ? true : false} />
                              {validationApplicationDoc.touched.address && validationApplicationDoc.errors.address ? <FormFeedback type="invalid">{validationApplicationDoc.errors.address}</FormFeedback> : null}
                            </div>
                          </div>
                          <div className="row border-bottom mb-1">
                            <h5 className="mb-3 bg-soft-info p-2 d-flex justify-content-between">
                              Data Pasangan
                              <div className="fs-13">
                                <Input name="knownCrApplication" id="knownCrApplication-field" className="form-check-input fw-normal fs-12" type="checkbox" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} checked={validationApplicationDoc.values.knownCrApplication} /> &nbsp;
                                <Label htmlFor="knownCrApplication-field" className="form-label mt-1">
                                  Mengetahui KPR
                                </Label>
                              </div>
                            </h5>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="name_spouse-field" className="form-label">
                                Nama
                              </Label>
                              <Input name="name_spouse" id="name_spouse-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.name_spouse ?? ""} invalid={validationApplicationDoc.touched.name_spouse && validationApplicationDoc.errors.name_spouse ? true : false} />
                              {validationApplicationDoc.touched.name_spouse && validationApplicationDoc.errors.name_spouse ? <FormFeedback type="invalid">{validationApplicationDoc.errors.name_spouse}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="phone_spouse-field" className="form-label">
                                No. Telepon
                              </Label>
                              <Input name="phone_spouse" id="phone_spouse-field" className="form-control" placeholder="Isi No. Telepon" type="phone" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.phone_spouse ?? ""} invalid={validationApplicationDoc.touched.phone_spouse && validationApplicationDoc.errors.phone_spouse ? true : false} />
                              {validationApplicationDoc.touched.phone_spouse && validationApplicationDoc.errors.phone_spouse ? <FormFeedback type="invalid">{validationApplicationDoc.errors.phone_spouse}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="bttt_spouse-field" className="form-label">
                                Best Time To Call
                              </Label>
                              <Input name="bttt_spouse" id="bttt_spouse-field" className="form-control" placeholder="Best Time To Call" type="phone" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.bttt_spouse ?? ""} invalid={validationApplicationDoc.touched.bttt_spouse && validationApplicationDoc.errors.bttt_spouse ? true : false} />
                              {validationApplicationDoc.touched.bttt_spouse && validationApplicationDoc.errors.bttt_spouse ? <FormFeedback type="invalid">{validationApplicationDoc.errors.bttt_spouse}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_spouse-field" className="form-label">
                                Pekerjaan Pasangan
                              </Label>
                              <Input name="job_spouse" id="job_spouse-field" className="form-control" placeholder="Isi Pekerjaan Pasangan" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_spouse ?? ""} invalid={validationApplicationDoc.touched.job_spouse && validationApplicationDoc.errors.job_spouse ? true : false} />
                              {validationApplicationDoc.touched.job_spouse && validationApplicationDoc.errors.job_spouse ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_spouse}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="identity_spouse-field" className="form-label">
                                No. KTP Pasangan
                              </Label>
                              <Input name="identity_spouse" id="identity_spouse-field" className="form-control" placeholder="Isi No. KTP Pasangan" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.identity_spouse ?? ""} invalid={validationApplicationDoc.touched.identity_spouse && validationApplicationDoc.errors.identity_spouse ? true : false} />
                              {validationApplicationDoc.touched.identity_spouse && validationApplicationDoc.errors.identity_spouse ? <FormFeedback type="invalid">{validationApplicationDoc.errors.identity_spouse}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="birth_place_spouse-field" className="form-label">
                                Tempat Lahir Pasangan
                              </Label>
                              <Input name="birth_place_spouse" id="birth_place_spouse-field" className="form-control" placeholder="Isi Tempat Lahir" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.birth_place_spouse ?? ""} invalid={validationApplicationDoc.touched.birth_place_spouse && validationApplicationDoc.errors.birth_place_spouse ? true : false} />
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="birth_place_spouse-field" className="form-label">
                                Tanggal Lahir Pasangan
                              </Label>
                              <Flatpickr
                                name="birthat_spouse"
                                className="form-control"
                                placeholder="Tanggal Lahir"
                                options={{
                                  enableTime: false,
                                  altInput: true,
                                  altFormat: "Y/m/d",
                                  dateFormat: "Y/m/d",
                                }}
                                value={validationApplicationDoc.values.birthat_spouse ?? ""}
                                onChange={(obj, str) => {
                                  validationApplicationDoc.setFieldValue("birthat_spouse", str);
                                }}
                              />
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="city_spouse-field" className="form-label">
                                Kota Pasangan
                              </Label>
                              <Input name="city_spouse" id="city_spouse-field" className="form-control" placeholder="Isi Kota Pasangan" type="city_spouse" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.city_spouse ?? ""} invalid={validationApplicationDoc.touched.city_spouse && validationApplicationDoc.errors.city_spouse ? true : false} />
                              {validationApplicationDoc.touched.city_spouse && validationApplicationDoc.errors.city_spouse ? <FormFeedback type="invalid">{validationApplicationDoc.errors.city_spouse}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="address_spouse-field" className="form-label">
                                Alamat
                              </Label>
                              <Input name="address_spouse" id="address_spouse-field" className="form-control" placeholder="Isi Alamat Pasangan" type="textarea" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.address_spouse ?? ""} invalid={validationApplicationDoc.touched.address_spouse && validationApplicationDoc.errors.address_spouse ? true : false} />
                              {validationApplicationDoc.touched.address_spouse && validationApplicationDoc.errors.address_spouse ? <FormFeedback type="invalid">{validationApplicationDoc.errors.address_spouse}</FormFeedback> : null}
                            </div>
                          </div>
                          <div className="row border-bottom mb-1 pb-2">
                            <h5 className="mb-3 bg-soft-info p-2 d-flex justify-content-between">
                              Data Kontak Darurat
                              <div className="fs-13">
                                <Input name="emergencyKnownCrApplication" id="emergencyKnownCrApplication-field" className="form-check-input" type="checkbox" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} checked={validationApplicationDoc.values.emergencyKnownCrApplication} /> &nbsp;
                                <Label htmlFor="emergencyKnownCrApplication-field" className="form-label">
                                  Mengetahui KPR
                                </Label>
                              </div>
                            </h5>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="emergency_contact_name-field" className="form-label">
                                Nama
                              </Label>
                              <Input name="emergency_contact_name" id="emergency_contact_name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.emergency_contact_name ?? ""} invalid={validationApplicationDoc.touched.emergency_contact_name && validationApplicationDoc.errors.emergency_contact_name ? true : false} />
                              {validationApplicationDoc.touched.emergency_contact_name && validationApplicationDoc.errors.emergency_contact_name ? <FormFeedback type="invalid">{validationApplicationDoc.errors.emergency_contact_name}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="emergency_contact_phone-field" className="form-label">
                                No. Telepon
                              </Label>
                              <Input name="emergency_contact_phone" id="emergency_contact_phone-field" className="form-control" placeholder="Isi No. Telepon" type="phone" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.emergency_contact_phone ?? ""} invalid={validationApplicationDoc.touched.emergency_contact_phone && validationApplicationDoc.errors.emergency_contact_phone ? true : false} />
                              {validationApplicationDoc.touched.emergency_contact_phone && validationApplicationDoc.errors.emergency_contact_phone ? <FormFeedback type="invalid">{validationApplicationDoc.errors.emergency_contact_phone}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="bttt_other-field" className="form-label">
                                Best Time To Call
                              </Label>
                              <Input name="bttt_other" id="bttt_other-field" className="form-control" placeholder="Best Time To Call" type="phone" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.bttt_other ?? ""} invalid={validationApplicationDoc.touched.bttt_other && validationApplicationDoc.errors.bttt_other ? true : false} />
                              {validationApplicationDoc.touched.bttt_other && validationApplicationDoc.errors.bttt_other ? <FormFeedback type="invalid">{validationApplicationDoc.errors.bttt_other}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="emergency_contact_relation-field" className="form-label">
                                Hubungan Dg Pemohon
                              </Label>
                              <Input name="emergency_contact_relation" id="emergency_contact_relation-field" className="form-control" placeholder="Isi Hubungan Kontak" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.emergency_contact_relation ?? ""} invalid={validationApplicationDoc.touched.emergency_contact_relation && validationApplicationDoc.errors.emergency_contact_relation ? true : false} />
                              {validationApplicationDoc.touched.emergency_contact_relation && validationApplicationDoc.errors.emergency_contact_relation ? <FormFeedback type="invalid">{validationApplicationDoc.errors.emergency_contact_relation}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="emergency_contact_address-field" className="form-label">
                                Alamat Kontak Darurat
                              </Label>
                              <Input
                                name="emergency_contact_address"
                                id="emergency_contact_address-field"
                                className="form-control"
                                placeholder="Isi Alamat Kontak Darurat"
                                type="textarea"
                                onChange={validationApplicationDoc.handleChange}
                                onBlur={validationApplicationDoc.handleBlur}
                                value={validationApplicationDoc.values.emergency_contact_address ?? ""}
                                invalid={validationApplicationDoc.touched.emergency_contact_address && validationApplicationDoc.errors.emergency_contact_address ? true : false}
                              />
                              {validationApplicationDoc.touched.emergency_contact_address && validationApplicationDoc.errors.emergency_contact_address ? <FormFeedback type="invalid">{validationApplicationDoc.errors.emergency_contact_address}</FormFeedback> : null}
                            </div>
                          </div>
                          <div className="row border-bottom mb-1 pb-2">
                            <h5 className="mb-3 bg-soft-info p-2 pb-3">Data Pekerjaan</h5>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_business_name-field" className="form-label">
                                Nama Perusahaan
                              </Label>
                              <Input name="job_business_name" id="job_business_name-field" className="form-control" placeholder="Isi Nama Perusahaan" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_business_name ?? ""} invalid={validationApplicationDoc.touched.job_business_name && validationApplicationDoc.errors.job_business_name ? true : false} />
                              {validationApplicationDoc.touched.job_business_name && validationApplicationDoc.errors.job_business_name ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_business_name}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="pekerjaan-field" className="form-label">
                                Jenis Pekerjaan
                              </Label>
                              <Select
                                name="job_desc"
                                value={validationApplicationDoc.values.job_desc}
                                placeholder="Pilih Pekerjaan"
                                onChange={(e) => {
                                  validationApplicationDoc.setFieldValue("job_desc", e);
                                }}
                                options={pekerjaanData}
                              ></Select>
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_informan_name-field" className="form-label">
                                Nama Pimpinan
                              </Label>
                              <Input name="job_informan_name" id="job_informan_name-field" className="form-control" placeholder="Isi Nama Pimpinan" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_informan_name ?? ""} invalid={validationApplicationDoc.touched.job_informan_name && validationApplicationDoc.errors.job_informan_name ? true : false} />
                              {validationApplicationDoc.touched.job_informan_name && validationApplicationDoc.errors.job_informan_name ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_informan_name}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_informan_position-field" className="form-label">
                                Jabatan Pimpinan
                              </Label>
                              <Input name="job_informan_position" id="job_informan_position-field" className="form-control" placeholder="Isi Jabatan Pimpinan" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_informan_position ?? ""} invalid={validationApplicationDoc.touched.job_informan_position && validationApplicationDoc.errors.job_informan_position ? true : false} />
                              {validationApplicationDoc.touched.job_informan_position && validationApplicationDoc.errors.job_informan_position ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_informan_position}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_informan_phone-field" className="form-label">
                                No. Telp Pimpinan
                              </Label>
                              <Input name="job_informan_phone" id="job_informan_phone-field" className="form-control" placeholder="Isi No. Telp Pimpinan" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_informan_phone ?? ""} invalid={validationApplicationDoc.touched.job_informan_phone && validationApplicationDoc.errors.job_informan_phone ? true : false} />
                              {validationApplicationDoc.touched.job_informan_phone && validationApplicationDoc.errors.job_informan_phone ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_informan_phone}</FormFeedback> : null}
                            </div>

                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_business_phone-field" className="form-label">
                                No Telp Perusahaan
                              </Label>
                              <Input name="job_business_phone" id="job_business_phone-field" className="form-control" placeholder="Isi No Telp Perusahaan" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_business_phone ?? ""} invalid={validationApplicationDoc.touched.job_business_phone && validationApplicationDoc.errors.job_business_phone ? true : false} />
                              {validationApplicationDoc.touched.job_business_phone && validationApplicationDoc.errors.job_business_phone ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_business_phone}</FormFeedback> : null}
                            </div>

                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_business_mail-field" className="form-label">
                                Email Perusahaan
                              </Label>
                              <Input name="job_business_mail" id="job_business_mail-field" className="form-control" placeholder="Isi Email Perusahaan" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_business_mail ?? ""} invalid={validationApplicationDoc.touched.job_business_mail && validationApplicationDoc.errors.job_business_mail ? true : false} />
                              {validationApplicationDoc.touched.job_business_mail && validationApplicationDoc.errors.job_business_mail ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_business_mail}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_business-field" className="form-label">
                                Bidang Usaha Perusahaan
                              </Label>
                              <Input name="job_business" id="job_business-field" className="form-control" placeholder="Isi Bidang Usaha Perusahaan" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_business ?? ""} invalid={validationApplicationDoc.touched.job_business && validationApplicationDoc.errors.job_business ? true : false} />
                              {validationApplicationDoc.touched.job_business && validationApplicationDoc.errors.job_business ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_business}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_business_hour-field" className="form-label">
                                Jam Operasional Usaha / Perusahaan
                              </Label>
                              <Input name="job_business_hour" id="job_business_hour-field" className="form-control" placeholder="Isi Jam Operasional" type="job_business_hour" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_business_hour ?? ""} invalid={validationApplicationDoc.touched.job_business_hour && validationApplicationDoc.errors.job_business_hour ? true : false} />
                              {validationApplicationDoc.touched.job_business_hour && validationApplicationDoc.errors.job_business_hour ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_business_hour}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_business_city-field" className="form-label">
                                Kota Perusahaan
                              </Label>
                              <Input name="job_business_city" id="job_business_city-field" className="form-control" placeholder="Isi Kota" type="job_business_city" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_business_city ?? ""} invalid={validationApplicationDoc.touched.job_business_city && validationApplicationDoc.errors.job_business_city ? true : false} />
                              {validationApplicationDoc.touched.job_business_city && validationApplicationDoc.errors.job_business_city ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_business_city}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_business_address-field" className="form-label">
                                Alamat Perusahaan
                              </Label>
                              <Input name="job_business_address" id="job_business_address-field" className="form-control" placeholder="Isi Alamat Perusahaan" type="textarea" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_business_address ?? ""} invalid={validationApplicationDoc.touched.job_business_address && validationApplicationDoc.errors.job_business_address ? true : false} />
                              {validationApplicationDoc.touched.job_business_address && validationApplicationDoc.errors.job_business_address ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_business_address}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_position-field" className="form-label">
                                Jabatan Pemohon
                              </Label>
                              <Input name="job_position" id="job_position-field" className="form-control" placeholder="Isi Jabatan Pemohon" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_position ?? ""} invalid={validationApplicationDoc.touched.job_position && validationApplicationDoc.errors.job_position ? true : false} />
                              {validationApplicationDoc.touched.job_position && validationApplicationDoc.errors.job_position ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_position}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_payroll_bank-field" className="form-label">
                                Bank Transfer Gaji
                              </Label>
                              <Input name="job_payroll_bank" id="job_payroll_bank-field" className="form-control" placeholder="Isi Bank Transfer Gaji" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_payroll_bank ?? ""} invalid={validationApplicationDoc.touched.job_payroll_bank && validationApplicationDoc.errors.job_payroll_bank ? true : false} />
                              {validationApplicationDoc.touched.job_payroll_bank && validationApplicationDoc.errors.job_payroll_bank ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_payroll_bank}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_date-field" className="form-label">
                                Tanggal Mulai Bekerja
                              </Label>
                              <Flatpickr
                                name="job_date"
                                className="form-control"
                                placeholder="Pilih Tanggal Mulai Bekerja"
                                options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                value={validationApplicationDoc.values.job_date ?? ""}
                                onChange={(o, e) => {
                                  validationApplicationDoc.setFieldValue("job_date", e);
                                }}
                              />
                              {validationApplicationDoc.touched.job_date && validationApplicationDoc.errors.job_date ? (
                                <p className="text-danger" type="invalid">
                                  {validationApplicationDoc.errors.job_date}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_status-field" className="form-label">
                                Status Bekerja
                              </Label>
                              <Input name="job_status" id="job_status-field" className="form-control" placeholder="Isi Status Bekerja" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_status ?? ""} invalid={validationApplicationDoc.touched.job_status && validationApplicationDoc.errors.job_status ? true : false} />
                              {validationApplicationDoc.touched.job_status && validationApplicationDoc.errors.job_status ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_status}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_pay_rate-field" className="form-label">
                                Jumlah Gaji / Pendapatan Kotor
                              </Label>
                              <Input name="job_pay_rate" id="job_pay_rate-field" className="form-control" placeholder="Isi Jumlah Gaji" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_pay_rate ?? ""} invalid={validationApplicationDoc.touched.job_pay_rate && validationApplicationDoc.errors.job_pay_rate ? true : false} />
                              {validationApplicationDoc.touched.job_pay_rate && validationApplicationDoc.errors.job_pay_rate ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_pay_rate}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_pay_rate_net-field" className="form-label">
                                Jumlah Gaji / Pendapatan Bersih
                              </Label>
                              <Input name="job_pay_rate_net" id="job_pay_rate_net-field" className="form-control" placeholder="Isi Jumlah Gaji" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_pay_rate_net ?? ""} invalid={validationApplicationDoc.touched.job_pay_rate_net && validationApplicationDoc.errors.job_pay_rate_net ? true : false} />
                              {validationApplicationDoc.touched.job_pay_rate_net && validationApplicationDoc.errors.job_pay_rate_net ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_pay_rate_net}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_payroll_method-field" className="form-label">
                                Metode Penggajian
                              </Label>
                              <Input name="job_payroll_method" id="job_payroll_method-field" className="form-control" placeholder="Isi Metode Penggajian" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_payroll_method ?? ""} invalid={validationApplicationDoc.touched.job_payroll_method && validationApplicationDoc.errors.job_payroll_method ? true : false} />
                              {validationApplicationDoc.touched.job_payroll_method && validationApplicationDoc.errors.job_payroll_method ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_payroll_method}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_payroll_date-field" className="form-label">
                                Tanggal Penggajian
                              </Label>
                              <Input name="job_payroll_date" id="job_payroll_date-field" className="form-control" placeholder="Isi Tanggal Penggajian" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_payroll_date ?? ""} invalid={validationApplicationDoc.touched.job_payroll_date && validationApplicationDoc.errors.job_payroll_date ? true : false} />
                              {validationApplicationDoc.touched.job_payroll_date && validationApplicationDoc.errors.job_payroll_date ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_payroll_date}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_retirement_age-field" className="form-label">
                                Umur Pensiun
                              </Label>
                              <Input name="job_retirement_age" id="job_retirement_age-field" className="form-control" placeholder="Isi Umur Pensiun" type="number" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_retirement_age ?? ""} invalid={validationApplicationDoc.touched.job_retirement_age && validationApplicationDoc.errors.job_retirement_age ? true : false} />
                              {validationApplicationDoc.touched.job_retirement_age && validationApplicationDoc.errors.job_retirement_age ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_retirement_age}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_business_employee-field" className="form-label">
                                Jumlah Karyawan
                              </Label>
                              <Input name="job_business_employee" id="job_business_employee-field" className="form-control" placeholder="Isi Jumlah Karyawan" type="number" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_business_employee ?? ""} invalid={validationApplicationDoc.touched.job_business_employee && validationApplicationDoc.errors.job_business_employee ? true : false} />
                              {validationApplicationDoc.touched.job_business_employee && validationApplicationDoc.errors.job_business_employee ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_business_employee}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="job_business_date-field" className="form-label">
                                Tahun Berdiri Perusahaan
                              </Label>
                              <Input name="job_business_date" id="job_business_date-field" className="form-control" placeholder="Isi Tahun Berdiri Perusahaan" type="text" onChange={validationApplicationDoc.handleChange} onBlur={validationApplicationDoc.handleBlur} value={validationApplicationDoc.values.job_business_date ?? ""} invalid={validationApplicationDoc.touched.job_business_date && validationApplicationDoc.errors.job_business_date ? true : false} />
                              {validationApplicationDoc.touched.job_business_date && validationApplicationDoc.errors.job_business_date ? <FormFeedback type="invalid">{validationApplicationDoc.errors.job_business_date}</FormFeedback> : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="d-flex justify-content-between w-100">
                        <div className="hstack gap-2 justify-content-end">
                          {sales && applicationDoc && applicationDoc.name && sales.statusDealId < 5 && (
                            <button
                              className="btn btn-warning"
                              onClick={() => {
                                sales.actionTitle = `Anda akan melakukan penandaan Kantor untuk data ${applicationDoc.name}`;
                                sales.statusDealApproveId = 4;
                                toggleApprove();
                              }}
                            >
                              {!!isEditApllicationDoc ? "UPDATE & TANDAI KANTOR" : "SIMPAN & TANDAI KANTOR"}
                            </button>
                          )}
                        </div>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setModalApplicationDoc(false);
                            }}
                          >
                            TUTUP
                          </button>
                          <button type="submit" className="btn btn-success">
                            <span className="d-flex align-items-center">
                              <span className="flex-grow-1 me-2">{!!isEditApllicationDoc ? "UPDATE BERKAS" : "SIMPAN BERKAS"}</span>
                              {loading && (
                                <Spinner size="sm" className="flex-shrink-0" role="status">
                                  Loading...
                                </Spinner>
                              )}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {getDetailTitle(detailType)}
                  </ModalHeader>
                  {detailType === "spr" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          // border: "1px solid #000000",
                          lineHeight: "1.2",
                          display: "flex",
                          alignItems: "center",
                          padding: "5px 0",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        <div
                          style={{
                            marginTop: "15px",
                            paddingLeft: "20px",
                            paddingRight: "40px",
                            flex: "1",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            flexDirection: "column",
                          }}
                        >
                          {companySelected?.label}
                          <div style={{ textAlign: "center", fontWeight: "normal", padding: "0" }}>{info && info.sales_branch && info.sales_branch.name}</div>
                          <p
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                              fontWeight: "normal",
                              padding: "0",
                              // lineHeight: "0"
                            }}
                          >
                            {info.sales_branch?.branch_address[0]?.description}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          textDecoration: "underline",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PESANAN RUMAH (SPR)
                      </div>
                      <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.2" }}>
                          <tbody>
                            <tr>
                              <td rowSpan={11} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>
                                I.
                              </td>
                              <td colSpan={3} style={{ fontWeight: "bold" }}>
                                DATA PRIBADI
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>TANGGAL PEMESANAN</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{handleValidDate(info.transactionat)}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>ATAS NAMA</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sales_customer.name}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>ALAMAT</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl && info.sls_appl.address && info.sls_appl.address}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>KOTA / PROVINSI</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl && info.sls_appl.city && info.sls_appl.city}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>NO. IDENTITAS (KTP)</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl && info.sls_appl.identity}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>TELP / HP</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl && info.sls_appl.phone}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>NAMA INSTANSI</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl && info.sls_appl.job_business_name}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>ALAMAT</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl && info.sls_appl.job_business_address}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>KOTA / PROVINSI</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl && info.sls_appl.job_business_city}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>TAHUN PEMBANGUNAN</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sales_detail[0]?.sales_detail_product?.production_year}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          style={{
                            marginTop: "10px",
                            display: "flex",
                          }}
                        >
                          <table
                            style={{
                              borderCollapse: "collapse",
                              tableLayout: "fixed",
                              lineHeight: "1.2",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td rowSpan={3} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>
                                  II.
                                </td>
                                <td colSpan={4} style={{ fontWeight: "bold" }}>
                                  DATA KAVLING
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>a.</td>
                                <td style={{ verticalAlign: "top", width: "110px" }}>Type</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td style={{ fontWeight: "bold" }}>{info.sales_detail[0]?.name.substr(0, 10)}</td>
                              </tr>
                              <tr>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>b.</td>
                                <td style={{ verticalAlign: "top", width: "110px" }}>Blok Kavling</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td style={{ fontWeight: "bold" }}>{info.sales_detail[0]?.name.substr(-6)}</td>
                              </tr>
                            </tbody>
                          </table>
                          <table
                            style={{
                              borderCollapse: "collapse",
                              tableLayout: "fixed",
                              lineHeight: "1.2",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td rowSpan={3} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top", height: "21.5px" }}></td>
                                <td colSpan={4} style={{ fontWeight: "bold", height: "21.5px" }}></td>
                              </tr>
                              <tr>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>c.</td>
                                <td style={{ verticalAlign: "top", width: "110px" }}> Luas Bangunan</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td style={{ fontWeight: "bold" }}> 30 m²</td>
                              </tr>
                              <tr>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>d.</td>
                                <td style={{ verticalAlign: "top", width: "110px" }}> Luas Tanah</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td style={{ fontWeight: "bold" }}> 60 m²</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <table
                          style={{
                            marginTop: "10px",
                            borderCollapse: "collapse",
                            tableLayout: "fixed",
                            width: "100%",
                            lineHeight: "1.2",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td rowSpan={15} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>
                                III.
                              </td>
                              <td
                                colSpan={3}
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                PERHITUNGAN HARGA JUAL DAN KPR
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid #000000",
                                  textAlign: "center",
                                  padding: "10px 0",
                                  fontWeight: "bold",
                                }}
                              >
                                Keterangan
                              </td>
                              <td
                                style={{
                                  border: "1px solid #000000",
                                  textAlign: "center",
                                  padding: "10px 0",
                                  fontWeight: "bold",
                                }}
                              >
                                Penjelasan
                              </td>
                              <td
                                style={{
                                  border: "1px solid #000000",
                                  textAlign: "center",
                                  padding: "10px 0",
                                  fontWeight: "bold",
                                }}
                              >
                                Rp.
                              </td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Harga Jual</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(info.sales_detail[0]?.amount)}</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Uang Muka</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(info.sales_detail[0]?.amount * (1 / 100))}</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>PPH (HOOK)</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>BPHTB (HOOK)</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>SBUM (Subsidi Bantuan Uang Muka)</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(info.sales_branch.sbum)}</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Maksimal KPR</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(info.sales_detail[0]?.amount - info.sales_detail[0]?.amount * (1 / 100) - (validation.values.sales_type.value === 1 ? validation.values.branch.sbum : 0))}</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Biaya Administrasi dan Proses</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(info.sales_detail[0]?.sales_detail_product?.price_cogs)}</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Peningkatan Mutu</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Tabungan Mengendap</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Booking Fee</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(info.book_amount)}</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Total yang harus dibayar</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(parseFloat(info.sales_detail[0]?.price_handling) + parseFloat(info.book_amount))}</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Cicilan Uang Muka 1</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Sisa yang harus dibayar</td>
                              <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                              <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
                            </tr>
                          </tbody>
                        </table>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <table
                              style={{
                                marginTop: "10px",
                                borderCollapse: "collapse",
                                tableLayout: "fixed",
                                width: "100%",
                                lineHeight: "1.2",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td rowSpan={15} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>
                                    IV.
                                  </td>
                                  <td colSpan={3} style={{ fontWeight: "bold" }}>
                                    PERINCIAN PEMBAYARAN CICILAN UANG MUKA
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000000", textAlign: "center", padding: "10px 0", fontWeight: "bold" }}>Tanggal Jatuh Tempo</td>
                                  <td style={{ border: "1px solid #000000", textAlign: "center", padding: "10px 0", fontWeight: "bold" }}>Pembayaran</td>
                                  <td style={{ border: "1px solid #000000", textAlign: "center", padding: "10px 0", fontWeight: "bold" }}>Tanggal Cicil</td>
                                  <td style={{ border: "1px solid #000000", textAlign: "center", padding: "10px 0", fontWeight: "bold" }}>Sisa Cicilan</td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000000", padding: "0 10px" }}>-</td>
                                  <td style={{ border: "1px solid #000000", padding: "0 10px" }}></td>
                                  <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}></td>
                                  <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}></td>
                                </tr>
                                <tr>
                                  <td colSpan={3} style={{ border: "1px solid #000000", padding: "0 10px" }}>
                                    -
                                  </td>
                                  <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}></td>
                                </tr>
                              </tbody>
                            </table>
                            <table
                              style={{
                                borderCollapse: "collapse",
                                tableLayout: "fixed",
                                lineHeight: "1.2",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td rowSpan={4} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}></td>
                                  <td colSpan={2} style={{ fontWeight: "bold" }}></td>
                                </tr>
                                <tr>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>1.</td>
                                  <td style={{ verticalAlign: "top", width: "250px" }}>Putih Untuk Bank</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>2.</td>
                                  <td style={{ verticalAlign: "top", width: "250px" }}>Merah Untuk Konsumen</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>3.</td>
                                  <td style={{ verticalAlign: "top", width: "250px" }}>Kuning Untuk Arsip</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              width: "250px",
                              textAlign: "center",
                            }}
                          >
                            <div>Bogor, {handleValidDate()}</div>
                            <div>Konsumen</div>
                            <div
                              style={{
                                marginTop: "60px",
                                fontWeight: "bold",
                              }}
                            >
                              {info.sales_customer.name}
                            </div>
                            <div style={{ textAlign: "center", marginTop: "20px" }}>
                              <div>Developer</div>
                              <div style={{ textAlign: "center", padding: "10px 0px" }}>
                                <img src={companySelected?.value === 1 ? logoTtdHAS : logoTtdCMS} width={100} alt="" style={{ marginRight: "5px" }} />
                              </div>
                              <div style={{ fontWeight: "bold" }}>( {companySelected?.label} )</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {detailType === "spd_bangunan" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          textDecoration: "underline",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN
                      </div>
                      <div style={{ padding: "20px" }}>
                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                          <tbody>
                            <tr>
                              <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.name ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Tempat/Tanggal Lahir</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>NIK</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.identity ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Pekerjaan</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.job_desc ?? ""}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "40px" }}>
                          Dengan ini menyatakan telah mengetahui, memahami dan menerima kondisi Prasarana, Sarana dan Utilitas Umum (PSU) Jalan, Jaringan Listrik dan/atau Air *) Siteplan belum disahkan dan bersedia untuk pindah unit apabila terdapat pergeseran siteplan yang dikeluarkan oleh instansi setempat, dan/atau Dokumen Perizinan Mendirikan Bangunan atas pembelian unit rumah pada proyek perumahan {info.sales_branch?.name}, {info.sales_detail[0]?.name} yang dikembangkan oleh
                          <span style={{ fontWeight: "bold" }}> {companySelected?.label}</span> dengan kondisi sebagai berikut:
                        </p>
                        <ol>
                          <li>KWH listrik dalam proses penyelesaian/belum selesai.</li>
                          <li>Bangunan dalam proses penyelesaian/belum selesai.</li>
                          <li>Air dalam proses penyelesaian/belum selesai.</li>
                          <li>Jalan (Saluran) dalam proses penyelesaian/belum selesai.</li>
                          <li>Legalitas dalam proses penyelesaian/belum selesai.</li>
                        </ol>
                        <p>Sehubungan dengan hal di atas, kami menyatakan tidak akan mengaitkan penyelesaian kondisi di atas dengan pembayaran angsuran KPR Bersubsidi BTN.</p>
                        <p>Demikian surat pernyataan ini dibuat dan di tanda tangani dengan sebenarnya, dan untuk dipergunakan sebagaimana mestinya.</p>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "250px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              style={{
                                marginTop: "100px",
                              }}
                            >
                              Yang menyetujui KPR
                            </div>
                            <div>Bogor, {handleValidDate()}</div>
                            <div
                              style={{
                                marginTop: "100px",
                              }}
                            >{`${info.sales_customer?.name ?? ""}`}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {detailType === "spd_elektronik" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          textDecoration: "underline",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT KUASA
                      </div>
                      <div style={{ padding: "20px" }}>
                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                          <tbody>
                            <tr>
                              <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.name ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>No. KTP</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.identity ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Tempat/Tanggal Lahir</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Pekerjaan</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.job_position ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>No. Telepon/HP</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.phone ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address ?? ""}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "40px" }}>yang dalam hal ini bertindak untuk dan atas nama sendiri. Selanjutnya disebut “Pemberi Kuasa”. YAYAN SUTIATI,S.H.,M.Kn dalam hal ini bertindak dalam jabatan Notaris di Kabupaten Bogor yang Selanjutnya disebut “Penerima Kuasa”.</p>
                        <p style={{ textAlign: "center" }}>KHUSUS</p>
                        <p>dengan ini Pemberi Kuasa memberikan kuasa kepada Penerima Kuasa untuk dapat melakukan Pengambilan Sertifikat Elektronik atas nama Pemberi Kuasa di Kantor Pertanahan Kabupaten Bogor II</p>
                        <p>
                          yang selanjutnya Sertifikat tersebut akan diserahkan kepada PT Bank Tabungan Negara (Persero) Tbk atas dasar Perjanjian Kredit KPR Bersubsidi
                          No&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tanggal&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024
                        </p>
                        <p>Demikian Surat Kuasa ini dibuat dengan Hak Substitusi, dan tidak dapat dicabut kembali serta tidak akan berakhir karena sebab – sebab yang tercantum dalam Pasal 1813 Kitab Undang – Undang Hukum Perdata atau karena sebab apapun juga.</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "250px",
                              textAlign: "center",
                            }}
                          >
                            <div style={{ textAlign: "center" }}>PENERIMA KUASA</div>
                            <div
                              style={{
                                marginTop: "120px",
                              }}
                            >
                              (....................................................)
                            </div>
                            <div>Nama lengkap, Jabatan</div>
                            <div>*) coret yang tidak perlu</div>
                          </div>

                          <div
                            style={{
                              marginTop: "25px",
                              width: "250px",
                              textAlign: "center",
                            }}
                          >
                            <div>Bogor, {handleValidDate()}</div>
                            <div style={{ textAlign: "center" }}>PEMBERI KUASA</div>
                            <div
                              style={{
                                marginTop: "100px",
                              }}
                            >{`(${info.sls_appl?.name ?? ""})`}</div>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          textAlign: "center",
                          textDecoration: "underline",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN DEBITUR
                      </div>
                      <div style={{ padding: "20px" }}>
                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                          <tbody>
                            <tr>
                              <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.name ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>No. KTP</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.identity ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Tempat/Tanggal Lahir</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Pekerjaan</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.job_position ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>No. Telepon/HP</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.phone ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Alamat</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address ?? ""}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "10px" }}>Selanjutnya, terhadap pembelian atas Tanah dan/atau Bangunan tersebut dibawah ini.</p>
                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed", marginBottom: "20px" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Perumahan</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sales_branch?.name ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Blok Kavling No</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sales_detail[0]?.name ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Alamat rumah yang dibeli</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sales_branch?.branch_address[0]?.description}</td>
                            </tr>
                          </tbody>
                        </table>
                        <p>Dengan ini menyatakan bahwa</p>
                        <ol style={{ marginLeft: "-15px", marginTop: "-10px" }}>
                          <li>
                            Menyatakan bahwa Hak atas tanah dan/atau bangunan yang telah balik atas nama
                            {info.sls_appl?.name ?? ""} masih menjadi jaminan/agunan atas kredit KPR Bersubsidi sesuai dengan Perjanjian Kredit antara Debitur dengan Pihak Bank BTN.
                          </li>
                          <li>Selama jangka waktu kredit atau utang belum dilunasi sesuai dengan Perjanjian Kredit KPR Bersubsidi dengan Pihak Bank BTN, Debitur bersedia dan setuju untuk tidak mengalihkan dan memperjualbelikan unit blok kavling yang telah akad di Bank BTN.</li>
                        </ol>
                        <p>Demikian Surat Pernyataan ini dibuat untuk dapat dipergunakan sebagaimana mestinya.</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "250px",
                              textAlign: "center",
                            }}
                          ></div>

                          <div
                            style={{
                              marginTop: "25px",
                              width: "250px",
                              textAlign: "center",
                            }}
                          >
                            <div>Bogor, {handleValidDate()}</div>
                            <div style={{ textAlign: "center" }}>PEMOHON</div>
                            <div
                              style={{
                                marginTop: "100px",
                              }}
                            >{`(${info.sls_appl?.name ?? ""})`}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {detailType === "slp_pk" && sales !== undefined && sales !== null && (
                    <>
                      <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "5px 0",
                            fontSize: "18px",
                          }}
                        >
                          HASIL VERIFIKASI RUMAH DAN PSU RUMAH SUBSIDI
                        </div>
                        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed", marginTop: "20px" }}>
                          <thead>
                            <tr>
                              <th rowSpan="3" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                NO
                              </th>
                              <th rowSpan="3" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                PROVINSI
                              </th>
                              <th rowSpan="3" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                NAMA PENGEMBANG
                              </th>
                              <th rowSpan="3" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                NAMA PERUMAHAN
                              </th>
                              <th rowSpan="3" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                NO.UNIT RUMAH
                              </th>
                              <th rowSpan="3" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                NAMA DEBITUR
                              </th>
                              <th rowSpan="3" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                NIK
                              </th>
                              <th rowSpan="2" colSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                1. JARINGAN BERSIH
                              </th>
                              <th rowSpan="2" colSpan="3" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                2. JARINGAN LISTRIK
                              </th>
                              <th colSpan="5" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                3.JALAN LINGKUNGAN
                              </th>
                              <th rowSpan="2" colSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                4.SALURAN/DRAINASE LINGKUNGAN
                              </th>
                              <th rowSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                5.PLAFON
                              </th>
                              <th rowSpan="2" colSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                6.SANITASI
                              </th>
                              <th rowSpan="3" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                KET.
                              </th>
                            </tr>
                            <tr>
                              <th colSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                SELESAI/NBERFUNGSI
                              </th>
                              <th colSpan="3" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                BELUM SELESAI
                              </th>
                            </tr>
                            <tr>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>ADA/TERPASAMH</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>BERFUNGSI</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>ADA/TERPASAMH</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>BERFUNGSI</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>SURAT BUKTI PEMBAYARAN BIAYA PENYAMBUNGAN LISTRIK DARI PLN</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>SELESAI</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>BERFUNGSI</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>PERKERASAN BADAN JALAN</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>SURAT PERNYATAAN BERSEDIA MENYELESAIK AN</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>SURAT JAMINAN KEPADA BANK PELAKSANA</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>SELESAI</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>BERFUNGSI</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>TERPASANG</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>ADA</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>BERFUNGSI</th>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(1)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(2)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(3)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(4)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(5)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(6)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(7)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(8)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(9)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(10)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(11)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(12)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(13)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(14)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(15)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(16)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(17)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(18)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(19)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(20)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(21)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(22)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>(23)</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{"1"}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{info.sales_branch?.name ?? ""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{info.sls_appl?.name ?? ""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{info.sls_appl?.identity ?? ""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          style={{
                            marginTop: "20px",
                            display: "flex",
                            justifyContent: "end",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                padding: "2px 4px",
                                fontWeight: "bold",
                                textAlign: "center",
                              }}
                            >
                              BTN KC. SYARIAH
                            </div>
                            <div
                              style={{
                                fontWeight: "bold",
                                textAlign: "center",
                              }}
                            >
                              BOGOR
                            </div>

                            <div
                              style={{
                                marginTop: "100px",
                                textAlign: "center",
                              }}
                            >
                              (.........................................................)
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {detailType === "slp_pk_notaris" && sales !== undefined && sales !== null && (
                    <>
                      <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                        <div
                          style={{
                            textAlign: "center",
                            textDecoration: "underline",
                            fontSize: "34px",
                            fontWeight: "bold",
                          }}
                        >
                          AMIR SYARIFUDIN, ST.
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                            textDecoration: "underline",
                            fontSize: "18px",
                            fontWeight: "bold",
                          }}
                        >
                          ARSITEK – MUDA
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                            textDecoration: "underline",
                            fontSize: "18px",
                          }}
                        >
                          Nomor Registrasi
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                            textDecoration: "underline",
                            fontSize: "18px",
                          }}
                        >
                          1.1.101.3.056.10.1093051
                        </div>
                        <div style={{ height: "4px", width: "100%", backgroundColor: "black", marginTop: "10px", marginBottom: "2px" }}></div>
                        <div style={{ height: "2px", width: "100%", backgroundColor: "black", marginBottom: "10px" }}></div>
                        <div
                          style={{
                            textAlign: "center",
                            textDecoration: "underline",
                            fontSize: "18px",
                            fontWeight: "bold",
                          }}
                        >
                          SURAT PERNYATAAN KELAIKAN FUNGSI BANGUNAN RUMAH
                        </div>
                        <div style={{ padding: "20px" }}>
                          <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                            <tbody>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "150px" }}>Nomor</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td>{""}</td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "150px" }}>Tanggal</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td>{""}</td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "150px" }}>Lampiran</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td>{""}</td>
                              </tr>
                            </tbody>
                          </table>

                          <p style={{ marginTop: "40px" }}>Pada Hari ini Sabtu tanggal Lima bulan Oktober tahun Dua Ribu Dua Puluh Empat yang bertanda tangan dibawah ini :</p>
                          <p>Penyedia Jasa Pengkaji Teknis/Penyedia jasa pengawas Kontruksi/Penyedia jasa Manajemen Konstruksi.</p>
                          <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
                            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <tbody>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>a.</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Nama Perorangan</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>b.</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Bidang Keahlian</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>c.</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Nomor Badan Usaha</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>d.</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>e.</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Telepon</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>f.</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Email</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <p>Telah melaksanakan Pemeriksaan kelaikan Fungsi Bangunan Rumah Pada :</p>
                          <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
                            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <tbody>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>1)</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Nama Bangunan</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>2)</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Blok/Kavling</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>3)</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Alamat Bangunan</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>4)</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Posisi Koordinat</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>5)</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Fungsi Bangunan</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>6)</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Klasiﬁkasi Kompleksitas</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>7)</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Ketinggian Bangunan</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>8)</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Jumlah Lantai Bangunan</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>9)</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Luas Lantai Bangunan</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>10)</td>
                                  <td style={{ verticalAlign: "top", width: "150px" }}>Luas Tanah</td>
                                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                  <td>{""}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <p>Berdasarkan Hasil Pemeriksaan Persyaratan kelaikan fungsi yang terdiri dari :</p>

                          <div style={{ marginLeft: "20px" }}>
                            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <tbody>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>1)</td>
                                  <td style={{ verticalAlign: "top" }}>Persyaratan dokumen administrative Bangunan Gedung.</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>2)</td>
                                  <td style={{ verticalAlign: "top" }}>Pemeriksaan persyaratan teknis Bangunan Gedung, yaitu :</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div style={{ marginLeft: "40px" }}>
                            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <tbody>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>a.</td>
                                  <td style={{ verticalAlign: "top" }}>pemeriksaan persyarata tata Bangunan, meliputi :</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div style={{ marginLeft: "60px" }}>
                            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <tbody>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>I.</td>
                                  <td style={{ verticalAlign: "top" }}>Persyaratan peruntukan Bangunan Gedung.</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>II.</td>
                                  <td style={{ verticalAlign: "top" }}>Persyaratan intensitas Bangunan Gedung,</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>III.</td>
                                  <td style={{ verticalAlign: "top" }}>Persyaratan arsitektur Bangunan Gedung</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div style={{ marginLeft: "40px" }}>
                            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <tbody>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>b.</td>
                                  <td style={{ verticalAlign: "top" }}>Pemeriksaan persyaratan keadaan bangunan,meliputi :</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div style={{ marginBottom: "20px", marginLeft: "60px" }}>
                            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <tbody>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>I.</td>
                                  <td style={{ verticalAlign: "top" }}>Persyaratan keselamatan</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>II.</td>
                                  <td style={{ verticalAlign: "top" }}>Persyaratan kesehatan</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>III.</td>
                                  <td style={{ verticalAlign: "top" }}>Persyaratan kenyamanan</td>
                                </tr>
                                <tr>
                                  <td style={{ verticalAlign: "top", width: "20px" }}>IV.</td>
                                  <td style={{ verticalAlign: "top" }}>Persyaratan keindahan</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <p>Dengan ini menyatakan bahwa :</p>
                          <p style={{ fontWeight: "bold", textAlign: "center" }}>BANGUNAN RUMAH DINYATAKAN LAIK PUNGSI</p>
                          <p>Sesuai kesimpulan dari analis dan evaluasi terhadap hasil pemeriksaan dokumen dan pemeriksaan Kondisi bangunan rumah sebagaimana termuat dalam laporanpemeriksaan kelaikan fungsi bangunan Rumah terlampir.</p>
                          <p>Surat pernyataan ini berlaku sepanjang tidak ada perubahan yang dilakukan oleh pemilik bangunan Rumah/pengguna Bangunan Rumah terhadap bangunan rumah atau penyebab gangguan lainnya yang Dibuktikan kemudian.</p>
                          <p>Demikian surat pernyataan ini dibuat dengan penuh tanggung jawab professional sesuai dengan Ketentuan dalam undang-undang nomor 2 tahun 2017 tentang jasa kontrituksi.</p>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              alignItems: "start",
                              gap: "10px",
                            }}
                          >
                            <div
                              style={{
                                marginTop: "25px",
                                width: "280px",
                                textAlign: "center",
                              }}
                            >
                              <div>Bogor, {handleValidDate()}</div>
                              <div>Pelaksana pemeriksaan kelaikan Fungsi</div>

                              <div style={{ marginTop: "100px" }}>..................................................................</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* ///// */}
                      <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "5px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                          }}
                        >
                          LAMPIRAN
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "5px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                          }}
                        >
                          LAPORAN PEMERIKSAAN KELAIAKAN FUNGSI BANGUNAN RUMAH
                        </div>
                        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed", marginTop: "20px" }}>
                          <thead>
                            <tr>
                              <th rowSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word", width: "50px" }}>
                                No
                              </th>
                              <th rowSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                Komponen Pemeriksaan
                              </th>
                              <th rowSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                Hasil Pengukuran Kondisi Faktual
                              </th>
                              <th rowSpan="1" colSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                Checklist Kesesuaian Kondisi Faktual Dengan Rencana Teknis dan Gambar Terbangun
                              </th>
                              <th rowSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>
                                Keterangan
                              </th>
                            </tr>
                            {/* <tr>
                                <th colSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>SELESAI/NBERFUNGSI</th>
                                <th colSpan="2" style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>BELUM SELESAI</th>
                              </tr> */}
                            <tr>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>Sesuai</th>
                              <th style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>Tidak Sesuai yaitu...</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th style={{ padding: "2px 4px", borderLeft: "1px solid #000000", textAlign: "center", wordWrap: "break-word", width: "50px" }}>1.</th>
                              <th colSpan="5" style={{ padding: "2px 4px", borderRight: "1px solid #000000", textAlign: "start", wordWrap: "break-word" }}>
                                PEMERIKSAAN PERSYARATAN TATA BANGUNAN GEDUNG
                              </th>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>a</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Persyaratan Peruntukan Bangunan Rumah (Fungsi Bangunan Gedung)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>b.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemanfaatan Setiap Ruang Dalam Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>c.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemanfaatan Ruang Luar Pada Persil Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>d.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Persyaratan Intensitas Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Luas Lantai Dasar Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Luas Total Lantai Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>3) Jumlah Lantai Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>4) Ketinggian Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>5) Luas Daerah Hijau Dalam Persil</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>6) Jarak Sempadan : </td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Jalan/Sungai/Pantai/Danau/Rel Kereta Api/Jalur Tegangan Tinggi</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Jalan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Sungai</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pantai</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Danau</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Rel Kereta Api</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Jalur Tegangan Tinggi</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>7) Jarak Bangunan Dengan Batas Persil </td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Jarak Bangunan Dengan Batas Kiri</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Jarak Bangunan Gedung Dengan Batas Kanan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Jarak Bangunan Gedung Dengan Batas Belakang</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>8) Jarak Antar Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>e.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Penampilan Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Bentuk Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Bentuk Denah Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>3) Tampak Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>4) Bentuk dan Penutup Atap Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>5) Profile, Detail, dan Materai Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>6) Batas Fisik Atau Pagar Pekarangan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>7) Kulit Atau Selubung Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>f.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Tata Ruang Ruang-Dalam Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Kebutuhan Ruang Utama</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Bidang-Bidang Dinding</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>3) Dinding-Dinding Penyekat</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>4) Pintu/Jendela</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>5) Tinggi Ruang</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>6) Tinggi Lantai Dasar</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>7) Ruang Rongga Atap</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>8) Penutup Lantai</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>9) Penutup Langit-Langit</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>g.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Keseimbangan, Keserasian, dan Keselarasan Dengan Lingkungan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Tinggi (Peil) Pekarangan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Ruang Terbuka Hijau Pekarangan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>3) Pemanfaatan Ruang Sempadan Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>4) Daerah Hijau Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>5) Tata Tanaman</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>6) Tata Perkerasan Pekarangan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>7) Sirkulasi Manusia Dengan Kendaraan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Sirkulasi Manusia</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Sirkulasi Kendaraan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>8) Perabot Lansekap (Landscape Furniture)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>9) Pencahayaan Ruang Luar Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <th style={{ padding: "2px 4px", borderLeft: "1px solid #000000", textAlign: "center", wordWrap: "break-word", width: "50px" }}>2.</th>
                              <th colSpan="5" style={{ padding: "2px 4px", borderRight: "1px solid #000000", textAlign: "start", wordWrap: "break-word" }}>
                                PEMERIKSAAN PERSYARATAN KESELAMATAN
                              </th>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>a.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Sistem Struktur Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Pondasi (Apabila Dapat Diamati)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengamatan Visual Terhadap Kerusakan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengukuran</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Kesesuaian Rencana Teknis dan Gambar Terbangun</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Penggunaan Peralatan Non Destruktif</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengujian Kekuatan dan Material (Apabila Diperlukan)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Kolom</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengamatan Visual Terhadap Kerusakan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengukuran</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Kesesuaian Rencana Teknis dan Gambar Terbangun</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Penggunaan Peralatan Non Destruktif</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengujian Kekuatan dan Material (Apabila Diperlukan)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>3) Balok Lantai</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengamatan Visual Terhadap Kerusakan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengukuran</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Kesesuaian Rencana Teknis dan Gambar Terbangun</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Penggunaan Peralatan Non Destruktif</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengujian Kekuatan dan Material (Apabila Diperlukan)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>4) Rangka Atap</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengamatan Visual Terhadap Kerusakan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengukuran</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Kesesuaian Rencana Teknis dan Gambar Terbangun</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Penggunaan Peralatan Non Destruktif</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>- Pengujian Kekuatan dan Material (Apabila Diperlukan)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>b.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Sistem Instalasi Listrik</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Sumber Listrik</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Panel Listrik</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>3) Instalasi Listrik</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>4) Sistem Pembumian</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <th style={{ padding: "2px 4px", borderLeft: "1px solid #000000", textAlign: "center", wordWrap: "break-word", width: "50px" }}>3.</th>
                              <th colSpan="5" style={{ padding: "2px 4px", borderRight: "1px solid #000000", textAlign: "start", wordWrap: "break-word" }}>
                                PEMERIKSAAN PERSYARATAN KESEHATAN
                              </th>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>a.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Sistem Penghawaan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Ventilasi Alami</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Ventilasi Mekanik</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>b.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Sistem Pencahayaan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Sistem Pencahayaan Alami</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Sistem Pencahayaan Mekanik</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>c.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Sistem Penyediaan Air Bersih/Minum</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Sumber Air Bersih/Minum</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Sistem Distribusi Air Bersih/Minum</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>3) Kualitas Air Bersih/Minum</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>d.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Sistem Pengelolaan Air Kotor dan/atau Air Limbah (Black Water)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Peralatan Saniter</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Instalasi Inlet/Outlet</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>3) Sistem Jaringan Pembuangan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>4) Sistem Penampungan dan Pengelolahan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>e.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Sistem Pengolahan Kotoran dan Sampah</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Penampungan Sementara Dalam Persil</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>f.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Sistem Pengolahan Air Hujan (Grey Water)</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Sistem Penangkapan Air Hujan, Termasuk Talang</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Sistem Penyaluran Air Hujan, Termasuk Pipa Tegak dan Drainase Dalam Persil</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>3) Sistem Penampungan, Pengelolahan, Peresapan dan/Atau Pembuangan Air Hujan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>g.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Penggunaan Bahan Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Bahan Bangunan yang Mengandung Bahan Berbahaya/Beracun</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Bahan Bangunan yang Menyebabkan Efek Silau dan Pantulan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <th style={{ padding: "2px 4px", borderLeft: "1px solid #000000", textAlign: "center", wordWrap: "break-word", width: "50px" }}>4.</th>
                              <th colSpan="5" style={{ padding: "2px 4px", borderRight: "1px solid #000000", textAlign: "start", wordWrap: "break-word" }}>
                                PEMERIKSAAN PERSYARATAN KENYAMANAN
                              </th>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>a.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Ruang Gerak Dalam Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Jumlah Pengguna atau Batas Okupansi</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>b.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Kondisi Udara Dalam Ruangan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Temperatur Ruang</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Kelembaban Ruang</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>c.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Pandangan Dari dan Ke Dalam Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Pandangan Dari Dalam Ruang ke Luar Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Pandangan Dari Luar Bangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <th style={{ padding: "2px 4px", borderLeft: "1px solid #000000", textAlign: "center", wordWrap: "break-word", width: "50px" }}>5.</th>
                              <th colSpan="5" style={{ padding: "2px 4px", borderRight: "1px solid #000000", textAlign: "start", wordWrap: "break-word" }}>
                                PEMERIKSAAN PERSYARATAN KEMUDAHAN
                              </th>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>a.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Sarana Hubungan Horisontal Antarruang/Antarbangunan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Kondisi Bukaan Pintu</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pengukuran Dimensi dan Arah Bukaan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pengamatan Visual Terhadap Kerusakan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Kesesuaian Kondisi Faktual Dengan Rencana Teknis dan Gambar Terbangun</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}>b.</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Kelengkapan Prasarana dan Sarana Bangunan Gedung</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>1) Toilet</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pengukuran Dimensi dan Arah Bukaan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pengamatan Visual Terhadap Kerusakan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Kesesuaian Kondisi Faktual Dengan Rencana Teknis dan Gambar Terbangun</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>2) Tempat Sampah</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pengukuran Dimensi dan Arah Bukaan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pengamatan Visual Terhadap Kerusakan</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", textAlign: "center", wordWrap: "break-word" }}></td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>Pemeriksaan Kesesuaian Kondisi Faktual Dengan Rencana Teknis dan Gambar Terbangun</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                              <td style={{ padding: "2px 4px", border: "1px solid #000000", wordWrap: "break-word" }}>{""}</td>
                            </tr>
                          </tbody>
                        </table>
                        {/* /// */}

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "center",
                            padding: "5px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            marginTop: "20px",
                          }}
                        >
                          HASIL PEMERIKSAAN LAIK FUNGSI BANGUNAN
                        </div>
                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Kondisi Keseluruhan</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Estimasi Sisi Material</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Kesimpulan</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Pemeriksa</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Tanggal</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{""}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          style={{
                            marginTop: "20px",
                            display: "flex",
                            justifyContent: "end",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                padding: "2px 4px",
                                fontWeight: "bold",
                                textAlign: "center",
                              }}
                            >
                              Tanda Tangan
                            </div>

                            <div
                              style={{
                                marginTop: "100px",
                                textAlign: "center",
                              }}
                            >
                              (.........................................................)
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {detailType === "spd_pbg" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          textDecoration: "underline",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN
                      </div>
                      <div style={{ padding: "20px" }}>
                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                          <tbody>
                            <tr>
                              <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sales_customer?.name ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Tempat, Tanggal Lahir</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>NIK</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.identity ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Blok</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{`${info.sales_detail[0]?.sales_detail_product?.product_block?.name ?? ""} - ${info.sales_detail[0]?.sales_detail_product?.name ?? ""}`}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "40px" }}>Dalam Kapasitasnya Selaku : Debitur {info.sales_branch?.name}</p>
                        <p>Dengan ini menyatakan hal-hal sebagai berikut: </p>
                        <ol style={{ marginLeft: "-30px", listStyle: "none" }}>
                          <li>
                            1. Mengetahui dan menerima bahwa kondisi dokumen saat akad kredit adalah berupa <span style={{ fontWeight: "bold" }}>Izin Mendirikan Bangunan (IMB) / Persetujuan Bangunan Gedung (PBG)</span>.
                          </li>
                          <li>2. Mengetahui bahwa dokumen yang diterima Bank dari pihak Pengembang pada saat akad adalah dokumen Persetujuan Bangunan Gedung (PBG) sedang dalam Proses.</li>
                          <li>3. Mengetahui bahwa dokumen bukti kepemilikan bangunan gedung adalah Sertifikat Bukti Kepemilikan Bangunan Gedung (SBKBG).</li>
                          <li>4. Dalam hal Pemerintah Kabupaten/Kota setempat memberlakukan ketentuan penerbitan Persetujuan Bangunan Gedung (PBG), Sertifikat Laik Fungsi (SLF) dan Surat Bukti Kepemilikan Bangunan Gedung (SBKBG), maka pengurusan dokumen tersebut merupakan tanggung jawab dari Pengembang.</li>
                        </ol>
                        <p>Surat Pernyataan ini saya buat dengan kesadaran tanpa adanya paksaan dari pihak manapun.</p>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "250px",
                              textAlign: "center",
                            }}
                          >
                            <div>Bogor, {handleValidDate()}</div>
                            <div>yang menyatakan</div>
                            <div
                              style={{
                                marginTop: "100px",
                              }}
                            >{`${info.sls_appl?.name ?? ""}`}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {detailType === "spd_pbt" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          textDecoration: "underline",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN
                      </div>
                      <div style={{ padding: "20px" }}>
                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                          <tbody>
                            <tr>
                              <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sales_customer?.name ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Tempat, Tanggal Lahir</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>NIK</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.identity ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address ?? ""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "150px" }}>Pekerjaan</td>
                              <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.job_desc ?? ""}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "40px" }}>
                          Dengan ini menyatakan telah mengetahui, memahami dan menerima kondisi atas pembelian unit rumah pada proyek perumahan {info.sales_branch?.name}, {info.sales_detail[0]?.name} yang dikembangkan oleh <span style={{ fontWeight: "bold" }}> {companySelected?.label}</span> dengan kondisi sebagai berikut:{" "}
                        </p>
                        <ol style={{ marginLeft: "-30px", listStyle: "none" }}>
                          <li>1. Legalitas dalam proses penyelesaian/belum selesai saat ini masih berupa Peta bidang tanah dan masih dalam proses pengindukan.</li>
                        </ol>
                        <p>Sehubungan dengan hal di atas, kami menyatakan tidak akan mengaitkan penyelesaian kondisi di atas dengan pembayaran angsuran KPR Bersubsidi BTN.</p>
                        <p>Demikian surat pernyataan ini dibuat dan di tanda tangani dengan sebenarnya, dan untuk dipergunakan sebagaimana mestinya.</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "250px",
                              textAlign: "center",
                            }}
                          >
                            <div>Yang menyetujui KPR</div>
                            <div>Bogor, {handleValidDate()}</div>
                            <div
                              style={{
                                marginTop: "100px",
                              }}
                            >{`${info.sls_appl?.name ?? ""}`}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {detailType === "verifikasi" && sales !== undefined && sales !== null && (
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          {/* okkkk print */}
                          <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                            <div
                              style={{
                                border: "1px solid #000000",
                                padding: "20px",
                              }}
                            >
                              <div
                                style={{
                                  backgroundColor: "#00afef",
                                  border: "1px solid #000000",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "5px 0",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                }}
                              >
                                FORM VERIFIKASI PESONA KAHURIPAN
                              </div>
                              <p
                                style={{
                                  marginTop: "15px",
                                  textAlign: "center",
                                  padding: "0",
                                  lineHeight: "0",
                                }}
                              >
                                {info.sales_branch?.branch_address[0]?.description}
                              </p>
                              <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                                <tbody>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Hari/Tanggal</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{formatDatePrint(info.sls_appl?.applicationAt) ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Pengajuan</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sales_deal_status?.name ?? "-"}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <div
                                style={{
                                  backgroundColor: "#00afef",
                                  border: "1px solid #000000",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "5px 0",
                                  fontWeight: "bold",
                                  margin: "10px 0",
                                }}
                              >
                                DATA PERUMAHAN
                              </div>
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  tableLayout: "fixed",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Perumahan</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sales_branch?.name ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Blok dan Type</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sales_detail[0]?.name ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Kelebihan Tanah</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sales_detail[0]?.land_excess ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jangka Waktu/Tenor</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.tenor ?? "-"}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <div
                                style={{
                                  backgroundColor: "#00afef",
                                  border: "1px solid #000000",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "5px 0",
                                  fontWeight: "bold",
                                  margin: "10px 0",
                                }}
                              >
                                {info?.sls_appl?.job_desc === "WIRASWASTA" ? "VERIFIKASI USAHA & KONTAK DARURAT" : "VERIFIKASI PEKERJAAN, KONDAR, DAN PIMPINAN"}
                              </div>
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  tableLayout: "fixed",
                                }}
                              >
                                {info?.sls_appl?.job_desc === "WIRASWASTA" ? (
                                  <tbody>
                                    <tr>
                                      <td style={{ width: "200px", backgroundColor: "#00afef", border: "1px solid #000000", padding: "2px 4px", fontWeight: "bold" }}>DATA PEMOHON</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%" }}></td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Pemohon</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.name ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>No. Telp Pemohon</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.phone ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Usaha</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_business_name ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Alamat Usaha</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_business_address ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Tahun Berdiri Perusahaan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_business_date ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Ibu Kandung</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.mother_name ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Perkawinan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.applicant_marital_status?.name ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Penghasilan Kotor /Bulan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_pay_rate ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Penghasilan Bersih /Bulan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_pay_rate_net ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jam Dapat dihubungi/BTTC</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.bttt}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jam Operasional /Hari Libur</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_business_hour}</td>
                                    </tr>
                                  </tbody>
                                ) : (
                                  <tbody>
                                    <tr>
                                      <td style={{ width: "200px", backgroundColor: "#00afef", border: "1px solid #000000", padding: "2px 4px", fontWeight: "bold" }}>DATA PEMOHON</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%" }}></td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Pemohon</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.name ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>No. Telp Pemohon</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.phone ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Perkawinan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.applicant_marital_status?.name ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Ibu Kandung</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.mother_name ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jabatan Pemohon</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_position ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Perusahaan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_business_name ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Alamat Perusahaan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_business_address ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Tahun Berdiri Perusahaan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_business_date ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Pimpinan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_informan_name ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>No. Telp Pimpinan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_informan_phone ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jabatan Pimpinan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_informan_position ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Gaji/Bulan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_pay_rate ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Metode Pembayaran Gaji</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_payroll_method ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Bank Transfer Gaji</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_payroll_bank ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jam Dapat dihubungi/BTTC</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.bttt}</td>
                                    </tr>
                                  </tbody>
                                )}
                              </table>
                              <table style={{ marginTop: "10px", width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                                <tbody>
                                  <tr>
                                    <td style={{ width: "200px", backgroundColor: "#00afef", border: "1px solid #000000", padding: "2px 4px", fontWeight: "bold" }}>DATA PASANGAN PEMOHON</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%" }}></td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Pasangan Pemohon</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.name_spouse ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>No. Telp Pasangan Pemohon</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.phone_spouse ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Perkawinan</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.applicant_marital_status?.name ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Pekerjaan Pasangan</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_spouse ?? "-"}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <table style={{ marginTop: "10px", width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                                <tbody>
                                  <tr>
                                    <td style={{ width: "200px", backgroundColor: "#00afef", border: "1px solid #000000", padding: "2px 4px", fontWeight: "bold" }}>DATA KONTAK DARURAT</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%" }}></td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Kontak Darurat</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.emergency_contact_name ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>No. Telp Kontak Darurat</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.emergency_contact_phone ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Hubungan Dengan Pemohon</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.emergency_contact_relation ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Perkawinan Pemohon</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.applicant_marital_status?.name ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Alamat Tempat Tinggal Kontak Darurat</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.emergency_contact_address ?? "-"}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Pekerjaan Pemohon</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_desc ?? "-"}</td>
                                  </tr>
                                </tbody>
                              </table>

                              {info?.sls_appl?.job_desc !== "WIRASWASTA" && (
                                <table
                                  style={{
                                    marginTop: "10px",
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    tableLayout: "fixed",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td style={{ width: "200px", backgroundColor: "#00afef", border: "1px solid #000000", padding: "2px 4px", fontWeight: "bold" }}>PIMPINAN PERUSAHAAN/HRD</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%" }}></td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Bidang Perusahaan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_business ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Lama Berdiri Perusahaan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_business_date}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Pekerjaan Pemohon</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_status ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jabatan Pemohon</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_position ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Gaji</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_pay_rate ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Alamat Perusahaan</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_business_address ?? "-"}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Lama Bekerja Pemohon</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{longTime(info.sls_appl?.job_date)}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Job Desk Pemohon</td>
                                      <td style={{ width: "15px" }}></td>
                                      <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{info.sls_appl?.job_position ?? "-"}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              )}
                              <table
                                style={{
                                  marginTop: "10px",
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  tableLayout: "fixed",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <td style={{ width: "50px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Note :</td>
                                    <td style={{ width: "15px" }}></td>
                                    <td style={{ width: "100%" }}>Pastikan nomor - nomor yang tercantum pada form aplikasi aktif dan dapat dihubungi dalam 1 minggu kedepan!!! jawab sesuai berkas yang diajukan dan pastikan jangan salah jawab guna meminimalisir riject/ditolak Bank mudah-mudahan pengajuannya dilancarkan sampai di ACC oleh Pihak Bank</td>
                                  </tr>
                                </tbody>
                              </table>
                              <p
                                style={{
                                  marginTop: "30px",
                                  textAlign: "end",
                                  padding: "0",
                                  lineHeight: "0",
                                }}
                              >
                                Terima Kasih
                              </p>
                            </div>
                            <div
                              style={{
                                padding: "0 20px",
                                marginTop: "20px",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  border: "1px solid #000000",
                                  width: "150px",
                                  height: "130px",
                                  textAlign: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "#00afef",
                                    borderBottom: "1px solid #000000",
                                    padding: "2px 4px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                  }}
                                >
                                  PIC Analis & Verif
                                </div>
                              </div>
                            </div>
                            <p
                              style={{
                                marginTop: "30px",
                                padding: "0",
                                lineHeight: "0",
                              }}
                            >
                              **harap paraf & nama jelas
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </ModalBody>
                  )}
                  {detailType === "detail" && info !== undefined && info !== null && (
                    <ModalBody>
                      <CardBody className="pt-4 ps-4 pe-4">
                        <Row>
                          <Col lg={5} className="ms-auto">
                            <div className="row">
                              <div className="mb-1 fs-14 fw-semibold">{info.sales_client && info.sales_client.name}</div>
                              <div className="mb-3 fs-14 fw-semibold">{info.sales_company && info.sales_company.name}</div>
                              <div className="mb-1 fs-14">{info.sales_branch && info.sales_branch.name}</div>
                              <div className="mb-3 fs-14">
                                PENJUALAN {info.sales_type && info.sales_type.name} {info.tenor ? ", Tenor " + info.tenor + " Bulan" : ""}
                              </div>
                            </div>
                          </Col>
                          <Col lg={3}></Col>
                          <Col lg={4} className="ms-auto">
                            <div className="mb-2 fs-14 fw-semibold">No Penjualan : {info.transaction_no && info.transaction_no}</div>
                            <div className="mb-2 fs-14 fw-semibold">Bank Pengajuan : {info.sls_bb && info.sls_bb.name}</div>
                            <div className="mb-2 fs-14 fw-semibold">{info.sales_customer && info.sales_customer.name}</div>
                            <div className="mb-2 fs-14 fw-semibold">
                              <span className="badge text-uppercase badge-soft-info fs-12">{info.sales_agent && info.sales_agent.name}</span>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="pt-4 ps-4 pe-4 border-top">
                        <h4 className="mb-3">Pemilihan Unit</h4>
                        <div>
                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <td style={{ width: "20px" }}>#</td>
                                <td>Unit Yang Dipilih</td>
                                {/* <td className="text-center" style={{ width: "150px" }}>{"Status Pemilihan"}</td> */}
                                <td className="text-center" style={{ width: "170px" }}>
                                  Harga Jual
                                </td>
                                <td className="text-center" style={{ width: "170px" }}>
                                  Booking Fee
                                </td>
                                <td className="text-center" style={{ width: "150px" }}>
                                  Administrasi
                                </td>
                                <td className="text-center" style={{ width: "170px" }}>
                                  {"> Tanah"}
                                </td>
                                <td className="text-center" style={{ width: "170px" }}>
                                  {"Total > Tanah"}
                                </td>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(info.sales_detail.sort((a, b) => a.transaction_no - b.transaction_no) || []).map((o, i) => {
                                return (
                                  <tr key={i} id={i} className="product">
                                    <td className="product-id">{i + 1}</td>
                                    <td className="text-start">{o.name}</td>
                                    <td className="text-center fs-14">{currencyFormat(o.amount)}</td>
                                    <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat(info.book_amount)}</td>
                                    <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat(o.price_handling)}</td>
                                    <td className="text-center fs-14">
                                      {parseInt(o.land_excess) || 0} M<sup>2</sup> <span className="fs-12">({currencyFormat(o.land_price || 0)})</span>
                                    </td>
                                    <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat(parseFloat(o.land_price) * parseFloat(o.land_excess) || 0)}</td>
                                  </tr>
                                );
                              })}
                              <tbody></tbody>
                              {info.sales_detail && info.sales_detail.length === 0 && (
                                <tr>
                                  <td colSpan="7" className="p-3 text-center fs-14">
                                    Unit belum ditambahkan
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                          <h4 className="mb-3 mt-3 pt-3 border-top">History Pembayaran</h4>
                          <div className="pt-3 ps-3 pe-3">
                            <div className="table-responsive mb-3 table-card">
                              <Table className="invoice-table table-borderless table-nowrap mb-0">
                                <thead className="align-middle">
                                  <tr className="table-active">
                                    <td></td>
                                    <td style={{ width: "20px" }}>#</td>
                                    <td>No Transaksi</td>
                                    <td>Tanggal Transaksi</td>
                                    <td className="text-end" style={{ width: "120px" }}>
                                      Jumlah
                                    </td>
                                    <td>Keterangan</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(info.sales_trans || [])
                                    .filter((f) => f.statusId === 1 || f.statusId === 2 || f.statusId === 3)
                                    .map((o, i) => {
                                      return (
                                        <tr key={i}>
                                          <td>
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-success"
                                              onClick={() => {
                                                setDetailType("receipt");
                                                setReceiptAmount(o.amount);
                                                setReceiptDate(o.transactionat);
                                                setReceiptCode(o.transaction_no);
                                                setReceiptNote(o.description + itemName + ", " + branchCode);
                                                setModalDetail(false);
                                                toggleReceipt();
                                              }}
                                            >
                                              KWITANSI
                                            </button>
                                          </td>
                                          <td className="product-id">{i + 1}</td>
                                          <td>{o.transaction_no}</td>
                                          <td>{handleValidDate(o.transactionat)}</td>
                                          <td className="text-end" style={{ width: "170px" }}>
                                            {currencyFormat(o.amount)}
                                          </td>
                                          <td>{o.description}</td>
                                        </tr>
                                      );
                                    })}
                                  {info.sales_trans && info.sales_trans.length === 0 && (
                                    <tr>
                                      <td colSpan="6" className="p-3 text-center fs-14">
                                        Belum ada transaksi Penerimaan
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                          {info.credit_amount && info.credit_amount > 0 && (
                            <div className="row border-top">
                              <div className="col-lg-5 mt-3">
                                <div className="mb-3">
                                  <label className="text-muted">Maksimum KPR : </label>
                                  <div className="fw-semibold fs-16">{currencyFormat(parseFloat(info.sub_amount) - (parseFloat(info.sub_amount ?? 0) * (1 / 100) + parseFloat(info.typeId === 1 ? info.sales_branch?.sbum : 0)) || 0)}</div>
                                </div>
                                <div className="mb-3">
                                  <label className="text-muted">ACC KPR : </label>
                                  <div className={currencyFormat(info.credit_amount) ? "fw-semibold text-success fs-16" : "fw-semibold fs-16"}>{currencyFormat(info.credit_amount)}</div>
                                </div>
                                <div className="row">
                                  <div className="mb-1 col-lg-12">
                                    <label>Tanggal SP3K</label> {handleValidDate(info.bankat)} (Tenor {info.tenor})
                                  </div>
                                </div>
                                <div className="mb-1">
                                  <label>Status : </label> <span className="fw-semibold fs-14">{info.sales_bank_status && info.sales_bank_status.name}</span>
                                </div>
                                <div className="mb-3">
                                  <label>Keterangan Bank : </label> {info.description_bank ? info.description_bank : "-"}
                                </div>
                              </div>
                              <div className="col-lg-3"></div>
                              <div className="col-lg-4 mt-3">
                                <div className="mb-3">
                                  <label className="text-muted">Penurunan KPR : </label>
                                  <div className="fw-semibold fs-16 text-danger">{currencyFormat(parseFloat(info.sub_amount) - (parseFloat(info.sub_amount) * (1 / 100) + parseFloat(info.typeId === 1 ? info.sales_branch?.sbum : 0)) - info.credit_amount || 0)}</div>
                                </div>
                                <div className="mb-3">
                                  <label className="text-muted">TOTAL Tagihan : </label>
                                  <div className="fw-semibold text-danger fs-16">{currencyFormat(info.total_amount)}</div>
                                </div>
                              </div>
                            </div>
                          )}

                          {info.completedat && (
                            <div className="pt-4 border-top">
                              <h4 className="mb-3">Jadwal Akad</h4>
                              <div className="row">
                                <div className="mb-3 col-lg-4">
                                  <label>Tanggal Akad : </label> <span className="fw-semibold text-success fs-16">{info.completedat && handleValidDate(info.completedat)}</span>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="pt-4 border-top">
                            <h4 className="mb-3">Bukti Transaksi</h4>
                            <div className="mb-3">
                              {info.sales_file &&
                                info.sales_file.length > 0 &&
                                info.sales_file.map((f, i) => {
                                  if (f.isDeleted) {
                                    return null;
                                  } else {
                                    return (
                                      <div key={i} className="border-bottom mb-3">
                                        <div className="d-flex justify-content-between mb-3 align-items-center">
                                          <div className="me-2">
                                            {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                              <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                            ) : (
                                              <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                                <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                              </Link>
                                            )}
                                          </div>

                                          <div className="text-truncate">{f.originalname}</div>
                                        </div>
                                      </div>
                                    );
                                  }
                                })}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </ModalBody>
                  )}

                  {detailType === "form_wawancara" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                        <tbody>
                          <tr>
                            <td colSpan={5} style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px", padding: "8px", border: "1px solid #000" }}>
                              FORM WAWANCARA
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px" }}>Cabang</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>{info.sales_branch && info.sales_branch.name}</td>
                            <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px" }}>Nama Pemohon</td>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                              {info.sls_appl?.name ?? "-"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>No. Kontrol</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>LMS No. :</td>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Nama Petugas</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>{info.sales_agent && info.sales_agent.name}</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Produk</td>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td style={{ border: "1px solid #000", borderBottom: "0px", padding: "4px 6px" }}>NIP</td>
                            <td style={{ border: "1px solid #000", borderBottom: "0px", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", borderBottom: "0px", padding: "4px 6px" }}>Subsidi / Non Subsidi</td>
                            <td colSpan={2} style={{ border: "1px solid #000", borderBottom: "0px", padding: "4px 6px" }}></td>
                          </tr>
                        </tbody>
                      </table>
                      {/* Bagian A */}
                      <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                        <tbody>
                          <tr>
                            <td colSpan={5} style={{ backgroundColor: "#d9d9d9", fontWeight: "bold", textAlign: "center", padding: "6px", height: "32px", border: "1px solid #000" }}>
                              {/* A. VALIDITAS DAN KELENGKAPAN DATA DEBITUR */}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                              A. VALIDITAS DAN KELENGKAPAN DATA DEBITUR
                            </td>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                              Cek Kesesuaian Fisik
                            </td>
                            <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Keterangan</td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                              A.1 Kelengkapan Data Debitur
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Sesuai</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Tidak</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px" }}></td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                              1. Identitas Diri (KTP / Paspor)
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                              Photo Pribadi (KTP / Pas Foto vs Aktual)
                              <br />
                              Bentuk Tandatangan (di Form Aplikasi vs KTP)
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>

                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                              A.2 Validitas Data Debitur
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Valid</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Tidak</td>
                            <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Keterangan</td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                              Validitas KTP / Identitas Lainnya
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                              Masa Berlaku KTP / Paspor
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td rowSpan={2} colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                              B. PENJELASAN MENGENAI PRODUK
                            </td>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}></td>
                            <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Keterangan</td>
                          </tr>
                          <tr>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Ya</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Tidak</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px" }}></td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                              Calon Debitur Sudah Faham akan Produk yang akan Dibeli
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td colSpan={5} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                              C. PENJELASAN MENGENAI HUBUNGAN ANTARA BANK - DEVELOPER – DEBITUR
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>C.1</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                              <span style={{ fontWeight: "bold" }}>Bank - Debitur : Hubungan Utang Piutang</span>
                              <br />
                              <br />
                              Bank Memberikan Kredit Kepada Debitur, Debitur Membayar Pokok Hutang Beserta Bunga ke Bank Secara Mengangsur dalam Jangka Waktu yang DisepakatiBersama Antara Bank dan Debitur
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>C.2</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                              <span style={{ fontWeight: "bold" }}>Developer - Debitur :Hubungan Jual Beli</span>
                              <br />
                              <br />
                              Developer Sebagai Penjual, Debitur Sebagai Pembeli Sehingga Segala Sesuatu Mengenai Objek Rumah baik Fisik Rumah, Sarana dan Prasarana maupun Legalitasnya (Sertifikat dan IMB) Merupakan Tanggungjawab pihak Developer (Bukan Pihak Bank)
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>C.2</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                              <span style={{ fontWeight: "bold" }}>Bank - Developer : Hubungan Kerjasama</span>
                              <br />
                              <br />
                              Developer dan Bank Bekerjasama dalam Pembiayaan KPR bagi Pembeli Rumah yang Dibangun/ Dijual oleh Developer
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td rowSpan={2} colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                              D. KETENTUAN KPR SUBSIDI
                            </td>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                              Kesesuaian Kualifikasi Calon Debitur
                            </td>
                            <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Keterangan</td>
                          </tr>
                          <tr>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Ya</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Tidak</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px" }}></td>
                          </tr>
                          <tr>
                            <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>D.1</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Gaji Pokok Calon Debitur Sesuai dengan KPR Bersubsidi yang Berlaku</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>D.2</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Calon Debitur Belum Memiliki Rumah</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>D.3</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Calon Debitur Belum Pernah Memperoleh Fasilitas KPR Bersubsidi</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
                          </tr>
                          <tr>
                            <td colSpan={5} style={{ border: "1px solid #000", borderBottom: "none", padding: "8px 6px", textAlign: "justify" }}>
                              Pada hari ini Tanggal ......... Saya/Kami yang bertandatangan dibawah ini telah memberikan keterangan data yang valid dalam wawancara yang dilakukan oleh Loan Service PT. Bank Tabungan Negara (Persero) Cabang ......... Untuk keperluan penilaian atas kelayakan kredit yang Saya/Kami ajukan.
                              <br />
                              <br />
                              Saya/Kami telah memahami produk yang akan Saya/Kami ambil serta hubungan antara Bank BTN - Developer - Debitur dalam pengambilan KPR ini.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                        <tbody>
                          <tr>
                            <td colSpan={5} style={{ textAlign: "center", border: "1px solid #000", fontWeight: "bold", padding: "4px 6px" }}>
                              BANK BTN
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", width: "50%" }}>
                              Loan Service/ Petugas Wawancara
                            </td>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", width: "50%" }}>
                              Pemohon
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", height: "80px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", height: "80px" }}></td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", height: "80px" }}></td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                              Nama : {info.sales_agent && info.sales_agent.name}
                            </td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Nama Pasangan : {info.sls_appl?.name_spouse ?? "-"}</td>
                            <td style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Nama Pemohon : {info.sls_appl?.name ?? "-"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  {detailType === "bast" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        BERITA ACARA SERAH TERIMA
                        <br />
                        RUMAH SEJAHTERA TAPAK / SATUAN RUMAH SEJAHTERA SUSUN*)
                      </div>
                      <div style={{ height: "2px", width: "100%", backgroundColor: "black", marginBottom: "10px" }}></div>
                      <div style={{ padding: "20px" }}>
                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                          <tbody>
                            <tr>
                              <div style={{ verticalAlign: "top" }}>Nomor :</div>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Pada tanggal,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;telah dilakukan serah terima dari :</td>
                            </tr>
                          </tbody>
                        </table>

                        <table style={{ borderCollapse: "collapse", marginTop: "20px", marginBottom: "20px", tableLayout: "fixed" }}>
                          <tbody>
                            <tr>
                              <div style={{ verticalAlign: "top", fontWeight: "bold" }}>PT. HIKMAH ALAM SENTOSA</div>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>
                                (selanjutnya disebut <span style={{ fontWeight: "bold" }}>”Pihak Pertama”</span>);
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <p>Kepada :</p>
                        <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
                          <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                            <tbody>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>1.</td>
                                <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td>{info.sls_appl?.name ?? "-"}</td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>2.</td>
                                <td style={{ verticalAlign: "top", width: "150px" }}>NIK</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td>{info.sls_appl?.identity ?? "-"}</td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>3.</td>
                                <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td>{info.sls_appl?.address ?? "-"}</td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>4.</td>
                                <td style={{ verticalAlign: "top", width: "150px" }}>No Telp/HP</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td>{info.sls_appl?.phone ?? "-"}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div>
                            Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Pihak Kedua”</span>)
                          </div>
                        </div>
                        <div>
                          Berdasarkan PPJB/AJB*).................... No .............................. Tanggal :<br />
                          Atas 1 (satu) unit Rumah Sejahtera Tapak/Satuan Rumah Sejahtera Susun*) pada lokasi sebagai berikut :
                        </div>
                        <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
                          <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                            <tbody>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>1.</td>
                                <td style={{ verticalAlign: "top", width: "250px" }}>Nama Perumahan/Tower</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                {info.sales_branch?.name ?? "-"}
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>2.</td>
                                <td style={{ verticalAlign: "top", width: "250px" }}>Lantai / No. Unit</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td>{info.sales_detail?.[0]?.sales_detail_product?.product_block?.name ?? "-"}</td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>3.</td>
                                <td style={{ verticalAlign: "top", width: "250px" }}>Luas Lantai Bersih (Netto)</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td>{info.sales_detail?.[0]?.sales_detail_product?.product_category?.name ?? "-"}</td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>4.</td>
                                <td style={{ verticalAlign: "top", width: "250px" }}>Alamat</td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                {info.sales_branch?.branch_address[0]?.description}
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>5.</td>
                                <td style={{ verticalAlign: "top", width: "250px" }}>Kota/Kabupaten/Provinsi </td>
                                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                                <td>Bogor – Jawa Barat</td>
                              </tr>
                            </tbody>
                          </table>
                          <div>
                            Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Objek Serah Terima”</span>)
                          </div>
                        </div>

                        <div>Adapun serah terima atas Objek Serah Terima dilakukan dengan syarat dan ketentuan sebagai berikut : </div>
                        <div style={{ marginBottom: "20px" }}>
                          <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                            <tbody>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>1.</td>
                                <td style={{ verticalAlign: "top", width: "250px" }}>.........................</td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>2.</td>
                                <td style={{ verticalAlign: "top", width: "250px" }}>.........................</td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>3.</td>
                                <td style={{ verticalAlign: "top", width: "250px" }}>.........................</td>
                              </tr>
                            </tbody>
                          </table>
                          <div>
                            Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Objek Serah Terima”</span>)
                          </div>
                        </div>

                        <div
                          style={{
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                            }}
                          >
                            <div>
                              PIHAK PERTAMA /KUASA*),
                              <br />
                              PT. HIKMAH ALAM SENTOSA
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                            }}
                          >
                            <div>PIHAK KEDUA,</div>
                            <div
                              style={{
                                marginTop: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                                Materai
                                <br />
                                10.000,-
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            marginTop: "20px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                            }}
                          >
                            <div>ANGGA BUDI KUSUMA</div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              width: "88px",
                            }}
                          >
                            <div>{info.sls_appl?.name ?? "-"}</div>
                          </div>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                          *) Pilih salah satu <br />
                          *diberikan cap perusahaan/instansi
                        </div>
                      </div>
                    </div>
                  )}
                  {/* /// */}
                  {detailType === "surat_prasarana" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          marginBottom: "20px",
                        }}
                      >
                        <div>LAMPIRAN 7</div>
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN PRASARANA, SARANA & UTILITAS PERUMAHAN
                      </div>
                      <div style={{ marginTop: "10px", height: "2px", width: "100%", backgroundColor: "black", marginBottom: "10px" }}></div>
                      <div style={{ padding: "20px" }}>
                        <p>Yang bertanda tangan di bawah ini :</p>

                        <table style={{ marginTop: "10px" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "20px" }}>1.</td>
                              <td style={{ width: "120px" }}>Nama </td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>Tempat/tgl lahir</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? "-"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>Pekerjaan</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>No. KTP/NIK</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>Alamat</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginLeft: "20px" }}>Selaku calon debitur.</div>
                        <table>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "20px" }}></td>
                              <td style={{ width: "120px" }}>Nama </td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.name_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>Tempat/tgl lahir</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>
                                {" "}
                                {info.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(info.sls_appl?.birthat_spouse) ?? "-"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>Pekerjaan</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.job_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>No. KTP/NIK</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.identity_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>Alamat</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.address_spouse ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginLeft: "20px" }}>Selaku suami/istri *) pemohon.</div>

                        <div style={{ marginTop: "20px" }}>Menyatakan hal-hal sebagai berikut:</div>
                        <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
                          <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                            <tbody>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>1.</td>
                                <td style={{ verticalAlign: "top" }}>
                                  Saya telah mempertimbangkan dengan baik dan tanpa paksaan dari pihak manapun sebelum memutuskan untuk membeli 1 (satu) unit Rumah Sejahtera Tapak/Satuan Rumah Sejahtera Susun*) dari pengembang/developer <span style={{ fontWeight: "bold" }}>{companySelected?.label}</span>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>2.</td>
                                <td style={{ verticalAlign: "top" }}>
                                  {" "}
                                  aya telah mengetahui dan bersedia menerima kondisi Rumah Sejahtera Tapak/Satuan Rumah Sejahtera Susun*) beserta dengan kondisi Prasarana, Sarana dan Utilitas (PSU) dengan rincian sebagai berikut: <br />
                                  3.1. Telah ada bukti pembayaran biaya penyambungan listrik dari PLN. <br />
                                  3.2. Telah tersedia sumber air yang berfungsi. <br />
                                  3.3. Badan jalan telah dilakukan pengerasan. <br />
                                  3.4. Saluran/drainase lingkungan telah selesai dan berfungsi.
                                </td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "top", width: "20px" }}>3.</td>
                                <td style={{ verticalAlign: "top" }}>Saya tidak akan mengkaitkan kondisi Rumah Sejahtera Tapak/Satuan Rumah Sejahtera Susun*) Prasarana, Sarana dan Utilitas (PSU) dengan kewajiban pembayaran angsuran KPR BTN Bersubsidi </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                            }}
                          >
                            <div>Menyetujui,</div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                            }}
                          >
                            <div>
                              Bogor, ................................
                              <br />
                              Yang membuat pernyataan,
                            </div>
                            <div
                              style={{
                                marginTop: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                                Materai
                                <br />
                                10.000,-
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            marginTop: "20px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                            }}
                          >
                            <div>ANGGA BUDI KUSUMA</div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              width: "168px",
                            }}
                          >
                            <div>{info.sls_appl?.name ?? "-"}</div>
                          </div>
                        </div>
                        <div style={{ marginTop: "20px" }}>*) Pilih salah satu</div>
                      </div>
                    </div>
                  )}
                  {/* /// */}
                  {detailType === "surat_pernyataan_data" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          padding: "5px 0",
                          textDecoration: "underline",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        <div>SURAT PERNYATAAN PENYERAHAN DATA</div>
                      </div>
                      <div style={{ padding: "10px" }}>
                        <span>Saya yang bertanda tangan dibawah ini :</span>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Tempat/Tgl Lahir</td>
                              <td>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Pekerjaan</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td>NIK</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat Domisili</td>
                              <td style={{ verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat Sesuai KTP</td>
                              <td style={{ verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Nomor Telp/HP</td>
                              <td>:</td>
                              <td>{info.sls_appl?.phone ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Alamat Email</td>
                              <td>:</td>
                              <td>{info.sls_appl?.email ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div>Selaku Pemohon</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Tempat/Tgl Lahir</td>
                              <td>:</td>
                              <td>
                                {info.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(info.sls_appl?.birthat_spouse) ?? "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Pekerjaan</td>
                              <td>:</td>
                              <td>{info.sls_appl?.job_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>NIK</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat Domisili</td>
                              <td style={{ verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address_spouse ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div>Selaku suami/istri pemohon</div>

                        <div style={{ marginTop: "15px" }}>Bersama ini ;</div>
                        <p>Menyatakan telah mengetahui, memahami dan menyanggupi untuk memenuhi seluruh ketentuan dan persyaratan Pusat Pengelolaan Dana Pembiayaan Perumahan (PPDPP) untuk mendapatkan fasilitas KPR Sejahtera.</p>
                        <p>Menyampaikan semua data pribadi (KTP, NPWP, Pas Photo) untuk mendapatkan fasilitas KPR Sejahtera dan semua data lainnya yang diperlukan oleh PPDPP melalui Bank BTN, serta menjamin bahwa semua data yang saya sampaikan tersebut adalah benar dan dapat dipertanggung jawabkan keabsahannya.</p>
                        <p>Memberikan kuasa PPDPP untuk mengakses semua data pribadi saya yang terkait data FLPP yang ada di Bank BTN. Apabila dikemudian hari pernyataan saya ini tidak benar dan/atau tidak saya penuhi, saya bers edia mengembalikan seluruh subsidi yang telah saya terima dari Pemerintah dan bersedia dikenakan sanksi sesuai dengan ketentuan peraturan perundang-undangan.</p>
                        <p>Memberikan persetujuan kepada Bank BTN untuk memberikan semua data pribadi saya yang terdapat di Bank BTN kepada PPDPP. Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                              width: "170px",
                            }}
                          >
                            <div>
                              Menyetujui, <br />
                              Suami/Istri*
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                              width: "170px",
                            }}
                          >
                            <div>
                              Bogor, ................................
                              <br />
                              Yang membuat pernyataan,
                            </div>
                            <div
                              style={{
                                marginTop: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                                Materai
                                <br />
                                10.000,-
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            marginTop: "20px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "170px",
                              textAlign: "center",
                            }}
                          >
                            <div>{info.sls_appl?.name_spouse ?? "-"}</div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              width: "170px",
                              textAlign: "center",
                            }}
                          >
                            <div>{info.sls_appl?.name ?? "-"}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* /// */}
                  {detailType === "surat_kuasa_debet" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          marginBottom: "20px",
                        }}
                      >
                        <div>LAMPIRAN XIb</div>
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT KUASA PENDEBETAN DANA
                      </div>

                      <div style={{ padding: "20px" }}>
                        <p>Yang bertanda tangan di bawah ini :</p>

                        <table style={{ marginTop: "10px" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "20px" }}>I.</td>
                              <td style={{ width: "120px" }}>Nama </td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>Tempat/tgl lahir</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? "-"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>Pekerjaan</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>No. KTP/NIK</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}></td>
                              <td>Alamat</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td style={{ fontWeight: "bold" }}>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginLeft: "20px" }}>
                          yang dalam hal ini bertindak untuk dan atas nama sendiri. Selanjutnya disebut : <span style={{ fontWeight: "bold" }}>PEMBERI KUASA</span>
                        </div>

                        <table style={{ marginTop: "10px" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "20px" }}>II.</td>
                              <td>
                                PT BANK TABUNGAN NEGARA (Persero) Tbk, berkedudukan di Jl. Gajah Mada No.1 Jakarta Pusat yang dalam ini di wakili oleh <span style={{ fontWeight: "bold" }}>RACHMAT SUPRIYADI.C.B</span> selaku <span style={{ fontWeight: "bold" }}>BCLU Head Subsidi</span> BTN KC Depok di PT. BANK TABUNGAN NEGARA (Persero) Selanjutnya disebut : <span style={{ fontWeight: "bold" }}>PENERIMA KUASA</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "20px" }}>
                          dengan ini <span style={{ fontWeight: "bold" }}>PEMBERI KUASA</span> memberi kuasa kepada <span style={{ fontWeight: "bold" }}>PENERIMA KUASA</span> untuk melakukan pendebetan pada Nomor Rekening : <span style={{ fontWeight: "bold" }}>00130.0130.000188.0 (an PT. HIKMAH ALAM SENTOSA)</span> atas biaya asuransi, biaya pengikatan agunan, dan biaya lainnya yang timbul atas penghentian KPR Sejahtera yang disebabkan oleh dokumen pernyataan yang saya buat tidak benar dan/atau
                          tidak saya penuhi dalam proses pengajuan KPR Sejahtera pada Bank BTN.
                        </p>
                        <p>Kuasa ini diberikan dengan hak Substitusi, tidak dapat dicabut kembali dan tidak akan berakhir karena sebab -sebab yang tercantum dalam pasal 1813 Kitab Undang-Undang Hukum Perdata atau karena sebab apapun juga.</p>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                              width: "170px",
                            }}
                          >
                            <div>
                              Penerima Kuasa
                              <br />
                              <div style={{ textAlign: "start" }}>PT Bank Tabungan Negara (Persero), Tbk Kantor Depok</div>
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                              width: "170px",
                            }}
                          >
                            <div>
                              Bogor, ................................
                              <br />
                              Pemberi Kuasa
                            </div>
                            <div
                              style={{
                                marginTop: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                                Materai
                                <br />
                                10.000,-
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            marginTop: "20px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "170px",
                              textAlign: "center",
                            }}
                          >
                            <div>
                              RACHMAT SUPRIYADI.C.B
                              <br />
                              <span style={{ fontWeight: "normal" }}>BCLU HEAD</span>
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              width: "170px",
                              textAlign: "center",
                            }}
                          >
                            <div>
                              {info.sls_appl?.name ?? "-"} <br />
                              <span style={{ fontWeight: "normal" }}>Pemohon</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* /// */}
                  {detailType === "sbum" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          padding: "5px 0",
                          textDecoration: "underline",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        <div>SURAT PERMOHONAN SUBSIDI BANTUAN UANG MUKA (SBUM)</div>
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginTop: "10px" }}>
                          <div>Kepada Yth:</div>
                          <div style={{ fontWeight: "bold" }}>Kepala Satuan Kerja Direktorat Jenderal Pembiayaan Perumahan</div>
                          <div>Kementerian Pekerjaan Umum dan Perumahan Rakyat</div>
                          <div>Jalan Raden Patah 1 No 1 Lantai 2 Wing 3.</div>
                          <div>Kebayoran Baru, Jakarta Selatan 12110</div>
                        </div>
                        <div style={{ marginTop: "10px", fontWeight: "bold" }}>Perihal : Permohonan Subsidi Bantuan Uang Muka (SBUM)</div>
                        <span>Saya yang bertanda tangan dibawah ini :</span>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Tempat/Tgl Lahir</td>
                              <td>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Pekerjaan</td>
                              <td>:</td>
                              <td>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>No. KTP</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td style={{ verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div style={{ marginTop: "20px" }}>mengajukan permohonan Subsidi Bantuan Uang Muka untuk pembelian rumah sejahtera tapak dengan keterangan sebagai berikut:</div>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "220px" }}>Nama Pengembang</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td> {companySelected?.label ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Alamat Rumah Yang Dibeli</td>
                              <td>:</td>
                              <td> {info.sales_branch?.branch_address[0]?.description}</td>
                            </tr>
                            <tr>
                              <td>Harga Jual Rumah</td>
                              <td>:</td>
                              <td>{currencyFormat(info.sales_detail[0]?.amount)}</td>
                            </tr>
                            <tr>
                              <td>Besaran Uang Muka</td>
                              <td>:</td>
                              <td>{currencyFormat(info.sales_detail[0]?.price_dp)}</td>
                            </tr>
                            <tr>
                              <td>Bank Pelaksana</td>
                              <td>:</td>
                              <td>{"Bank BTN KC Harapan Indah"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "15px" }}>Sebagai pertimbangan, bersama ini kami lampirkan dokumen fotokopi surat pengakuan kekurangan bayar uang muka pembelian rumah sejahtera tapak yang disetujui oleh ………………………………………….……………………………………*)</p>
                        <p>Dengan surat permohonan ini saya menyatakan telah memahami dan tunduk pada ketentuan Pemerintah yang mengatur Subsidi Bantuan Uang Muka (SBUM). Apabila dikemudian hari saya tidak dapat menjalankan ketentuan Pemerintah tersebut di atas yang mengakibatkan Pemerintah mencabut semua kemudahan dan subsidi terkait kemudahan dalam perolehan rumah, saya bersedia mengembalikan semua kemudahan dan subsidi yang telah saya terima tersebut.</p>
                        <p>Demikian kami sampaikan, atas perhatiannya kami ucapkan terima kasih.</p>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                              width: "170px",
                            }}
                          >
                            <div>..........................</div>
                            <div
                              style={{
                                marginTop: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            marginTop: "20px",
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "170px",
                              textAlign: "center",
                            }}
                          >
                            <div>
                              {info.sls_appl?.name ?? "-"}
                              <br />
                              <span style={{ fontWeight: "normal" }}>Nasabah</span>
                            </div>
                          </div>
                        </div>

                        <div style={{ marginTop: "20px" }}>*) diisi dengan nama direktur atau yang mewakili pengemban dan nama perusahaan/pengembang</div>
                      </div>
                    </div>
                  )}
                  {/* /// */}
                  {detailType === "standing_instruction" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          padding: "5px 0",
                          textDecoration: "underline",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        <div>
                          STANDING INSTRUCTION
                          <br />
                          <span style={{ fontWeight: "normal" }}>(Perintah Pemindahbukuan)</span>
                        </div>
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginTop: "10px" }}>
                          <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sehubungan dengan permohonan dana Subsidi bantuan Uang muka Kepada Kepala Satuan kerja Direktorat Jenderal Pembiayaan Perumahan Kementerian Pekerjaan Umum dan Perumahan Rakyat, maka saya yang bertandatangan dibawah ini :</div>
                        </div>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Tempat/Tgl Lahir</td>
                              <td>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Pekerjaan</td>
                              <td>:</td>
                              <td>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>No. KTP</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td style={{ verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div style={{ marginTop: "20px" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dengan ini memberikan kuasa kepada PT . Bank Tabungan Negara (Persero) Tbk. Kantor Cabang untuk melakukan pemindahanbukuan pencairan dana Subsidi Bantuan Uang Muka (SBUM) senilai Rp 4.000.000,- ( Empat Juta Rupiah ) untuk digunakan sebagai pengurang pokok kredit atau pembayaran kekurangan uang muka pembelian rumah sejahtera *), kepada:</div>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "220px" }}>Nama Pengembang</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{companySelected?.label ?? ""}</td>
                            </tr>
                            <tr>
                              <td>No Rekening</td>
                              <td>:</td>
                              <td>{"00130.0130.000188.0"}</td>
                            </tr>
                            <tr>
                              <td>Rekening Atas Nama</td>
                              <td>:</td>
                              <td>{"PT. HIKMAH ALAM SENTOSA"}</td>
                            </tr>
                            <tr>
                              <td>BTN</td>
                              <td>:</td>
                              <td>{"(KC/KCP/KANKAS)"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "15px" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Demikian Standing Intruction ini di buat tanpa adanya paksaan dari pihak manapun.Akibat apapun yang Mungkin timbul dari pelaksanaan penyaluran dana oleh PT. Bank Tabungan Negara (Persero) Tbk, berdasarkan Standing Intruction ini adalah sepenuhnya menjadi tanggung jawab saya.</p>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                              width: "170px",
                            }}
                          >
                            <div>
                              Penerima Kuasa
                              <br />
                              <div style={{ textAlign: "start" }}>PT Bank Tabungan Negara (Persero), Tbk Kantor Depok</div>
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                              width: "170px",
                            }}
                          >
                            <div>
                              Bogor, ................................
                              <br />
                              Yang Membuat Standing Instruction
                            </div>
                            <div
                              style={{
                                marginTop: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                                Materai
                                <br />
                                10.000,-
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            marginTop: "20px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "170px",
                              textAlign: "center",
                            }}
                          >
                            <div>
                              RACHMAT SUPRIYADI.C.B
                              <br />
                              <span style={{ fontWeight: "normal" }}>Sub Branch Head</span>
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              width: "170px",
                              textAlign: "center",
                            }}
                          >
                            <div>
                              {info.sls_appl?.name ?? "-"} <br />
                              <span style={{ fontWeight: "normal" }}>Pemohon</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {detailType === "surat_kekurangan_uang_muka" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          padding: "5px 0",
                          textDecoration: "underline",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        <div>SURAT PENGAKUAN KEKURANGAN BAYAR UANG MUKA</div>
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginTop: "10px" }}>Saya yang bertanda tangan di bawah ini:</div>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Tempat/Tgl Lahir</td>
                              <td>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Pekerjaan</td>
                              <td>:</td>
                              <td>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>No. KTP</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td style={{ verticalAlign: "top" }}>:</td>
                              <td>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div style={{ marginTop: "20px" }}>Dengan ini menyatakan bahwa saya telah melakukan pembayaran uang muka sebesar Rp. Dan masih memiliki kekurangan bayar uang muka sebesar Rp. Untuk pembelian rumah sejahtera tapak kepada :</div>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr style={{ fontWeight: "bold" }}>
                              <td style={{ verticalAlign: "top", width: "240px" }}>Nama Pengembang</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{companySelected?.label ?? "-"}</td>
                            </tr>
                            <tr style={{ fontWeight: "bold" }}>
                              <td>Alamat Rumah Yang Dibeli</td>
                              <td>:</td>
                              <td> {info.sales_branch?.branch_address[0]?.description}</td>
                            </tr>
                            <tr>
                              <td>Harga Jual Rumah</td>
                              <td>:</td>
                              <td>{currencyFormat(info.sales_detail[0]?.amount)}</td>
                            </tr>
                            <tr>
                              <td>Besaran Uang Muka</td>
                              <td>:</td>
                              <td>{currencyFormat(info.sales_detail[0]?.price_dp)}</td>
                            </tr>
                            <tr>
                              <td>Bank Pelaksana</td>
                              <td>:</td>
                              <td>{"Bank Tabungan Negara ( Persero )"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "15px" }}>Jika permohonan SBUM saya tidak disetujui,maka saya bersedia untuk membayar kekurangan uang muka pembelian rumah sejahtera tapak menggunakan dana sendiri.</p>

                        <p>Demikian kami sampaikan, atas perhatiannya kami ucapkan terimakasih.</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                              width: "170px",
                            }}
                          >
                            <div>Menyetujui</div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              textAlign: "center",
                              width: "170px",
                            }}
                          >
                            <div>Bogor, ................................</div>
                            <div
                              style={{
                                marginTop: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                                Materai
                                <br />
                                10.000,-
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            marginTop: "20px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "170px",
                              textAlign: "center",
                            }}
                          >
                            <div>
                              Angga Budi Kusuma
                              <br />
                              <span style={{ fontWeight: "normal" }}>Direktur utama</span>
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: "25px",
                              width: "170px",
                              textAlign: "center",
                            }}
                          >
                            <div>
                              {info.sls_appl?.name ?? "-"} <br />
                              <span style={{ fontWeight: "normal" }}>Pemohon</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {detailType === "kelompok_sasaran" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          padding: "5px 0",
                          textDecoration: "underline",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        <div>PERSYARATAN KELOMPOK SASARAN</div>
                      </div>

                      <div style={{ padding: "10px" }}>
                        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                          <tbody>
                            <tr>
                              <td rowSpan={3} style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                                No.
                              </td>
                              <td rowSpan={3} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                                Persyaratan
                              </td>
                              <td colSpan={3} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                                Kelompok Sasaran
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>
                                Kawin
                              </td>
                              <td rowSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>
                                Lajang
                              </td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Suami</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Istri</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>1</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Kartu Tanda Penduduk (KTP) elektronik atau resi kartu tanda penduduk elektronik</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>2</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Kartu Keluarga (KK)</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>3</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Akta Nikah</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>4</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Tidak memiliki rumah *</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>5</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Belum pernah menerima subsidi perolehan rumah berupa pemilikan rumah dari Pemerintah *</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>6</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Nomor Pokok Wajib Pajak (NPWP) **</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>7</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>SPT Tahunan PPh Orang Pribadi sesuai peraturan perundang-undangan ***</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>8</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Penghasilan tidak melebihi batas penghasilan yang ditentukan **</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>9</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Surat pemesanan rumah dari pengambang yang paling sedikit memuat harga jual rumah dan alamat rumah</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>10</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Surat pernyataan Pemohon</td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "15px" }}>Catatan :</p>
                        <div> ** berstatus kawin hanya dipersyaratkan suami/istri.</div>
                        <div>*** dikecualikan untuk penghasilan dibawah PTKP.</div>
                      </div>
                    </div>
                  )}
                  {detailType === "pernyataan_verivikasi" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div style={{ marginBottom: "40px" }}>
                        <img src={logoBtn} alt="" width="150" />
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          padding: "5px 0",
                          textDecoration: "underline",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        <div>SURAT PERNYATAAN VERIFIKASI</div>
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{"YUDHISTIRA DIAN ASMARA KHARMA"}</td>
                            </tr>
                            <tr>
                              <td>Jabatan</td>
                              <td>:</td>
                              <td>{"BRANCH MANAGER"}</td>
                            </tr>
                            <tr>
                              <td>Alamat Kantor</td>
                              <td>:</td>
                              <td>{"JL.Margonda No 186, Kemiri muka, kecbeji , Kota Depok"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div style={{ marginTop: "10px", marginBottom: "10px", fontWeight: "bold", textAlign: "center" }}>MENYATAKAN</div>
                        <ol style={{ paddingLeft: "15px" }}>
                          <li>
                            Telah melaksanakan verifikasi dokumen kelompok sasaran KPR Sejahtera / KPR SSB / KPR SSM sebanyak{" "}
                            <span
                              style={{
                                color: "#d32f2f",
                                fontWeight: "bold",
                                borderBottom: "2px dotted #d32f2f",
                                padding: "0 4px",
                              }}
                            >
                              ................................................
                            </span>{" "}
                            pemohon.
                          </li>

                          <li>
                            Bahwa verifikasi dilakukan berupa verifikasi administrasi untuk memastikan ketepatan sasaran dan pemenuhan ketentuan <strong>KPR Sejahtera</strong>.
                          </li>

                          <li>
                            Bahwa verifikasi administrasi yang dilakukan meliputi:
                            <ol type="a" style={{ paddingLeft: "24px" }}>
                              <li>
                                Pemeriksaan kelengkapan dan kesesuaian dokumen persyaratan pemohon yang meliputi:
                                <ol type="1" style={{ paddingLeft: "32px", listStyleType: "decimal" }}>
                                  <li>Surat Pemesanan Rumah dari Pengembang;</li>
                                  <li>Identitas pemohon KPR Sejahtera / KPR SSB / KPR SSM;</li>
                                  <li>Surat keterangan penghasilan yang sah / slip gaji;</li>
                                  <li>Fotokopi Nomor Pokok Wajib Pajak (NPWP);</li>
                                  <li>Fotokopi Surat Pemberitahuan (SPT) Tahunan Orang Pribadi;</li>
                                  <li>Surat Pernyataan pemohon KPR Sejahtera / KPR SSB / KPR SSM;</li>
                                </ol>
                              </li>

                              <li>Pemeriksaan kesesuaian penghasilan pemohon dengan ketentuan kelompok sasaran sesuai ketentuan peraturan perundang-undangan;</li>

                              <li>Pemeriksaan kesesuaian harga Rumah Umum Tapak / Rumah Susun Umum dengan batasan harga jual sesuai ketentuan peraturan perundang-undangan;</li>

                              <li>Analisa kemampuan mengangsur pemohon;</li>
                            </ol>
                          </li>

                          <li>
                            Pemberian KPR Sejahtera / KPR SSB / KPR SSM dimaksud telah melalui prosedur sebagai berikut:
                            <ol type="a" style={{ paddingLeft: "15px" }}>
                              <li>Pemeriksaan kelengkapan data administrasi.</li>
                              <li>Wawancara terhadap pemohon.</li>
                            </ol>
                          </li>

                          <li>Berdasarkan hal-hal tersebut pada angka 1 sampai dengan angka 4, maka pemohon sebagaimana dimaksud telah memenuhi syarat dan ketentuan sebagai kelompok sasaran KPR Sejahtera / KPR SSB / KPR SSM dan layak untuk diberikan dana FLPP / Subsidi Bunga Kredit (SBUM).</li>

                          <li>Seluruh dokumen persyaratan pemohon sebagaimana dimaksud angka 3 butir a, sesuai dengan aslinya dan dapat dibuktikan sewaktu-waktu apabila dibutuhkan.</li>

                          <li>Surat Pernyataan Verifikasi sesuai dengan aslinya, dapat dipertanggungjawabkan dan dapat dibuktikan apabila dibutuhkan sewaktu-waktu.</li>
                        </ol>
                        <p>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "280px",
                            }}
                          >
                            <div>
                              Bogor, ................................, <br />
                              PT. BANK TABUNGAN NEGARA (PERSERO) Tbk
                            </div>
                            <div
                              style={{
                                marginTop: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            marginTop: "20px",
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25px",
                              width: "280px",
                              textAlign: "center",
                            }}
                          >
                            <div>YUDHISTIRA DIAN ASMARA KHARMA</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {detailType === "daftar_kpr_subsidi" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        DAFTAR DOKUMEN KPR BERSUBSIDI BTN
                      </div>

                      <div style={{ padding: "10px" }}>
                        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                          <tbody>
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid #000",
                                  padding: "8px 10px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                }}
                              >
                                KELENGKAPAN DOKUMEN KPR BERSUBSIDI BTN
                              </td>
                            </tr>

                            {/* A */}
                            <tr>
                              <td
                                style={{
                                  width: "60px",
                                  border: "1px solid #000",
                                  padding: "6px 8px",
                                  verticalAlign: "top",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                }}
                              >
                                A
                              </td>
                              <td
                                style={{
                                  border: "1px solid #000",
                                  padding: "6px 8px",
                                  fontWeight: "bold",
                                }}
                              >
                                Dokumen Pemohon
                              </td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>1.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi buku tabungan atas nama pemohon pada Bank BTN</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>2.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Formulir aplikasi kredit</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>3.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Pas foto terbaru</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>4.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat pemesanan rumah atau Resi KPR Elektronik</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>5.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi KTP Elektronik atau SSM KPR Elektronik</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>6.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi Kartu Keluarga</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>7.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi Akta Nikah atau akta perkawinan (bagi yang berstatus kawin) atau fotokopi akta cerai (bagi yang berstatus cerai)</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>8.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi NPWP (khusus yang debitur dengan penghasilan telah menjadi wajib pajak ≥ 1 tahun)</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>9.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>
                                Fotokopi bukti pelaporan pajak (khusus debitur dengan penghasilan telah menjadi wajib pajak ≥ 1 tahun dan penghasilan ≥ PTKP, melampirkan SPT PPh)
                                <br />• Telah menjadi wajib pajak ≥ 1 tahun dan penghasilan ≥ PTKP → melampirkan SPT PPh
                                <br />• Telah menjadi wajib pajak &lt; 1 tahun → melampirkan surat keterangan PTKP, melampirkan penyampaian SPT PPh tahun selanjutnya
                              </td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>10.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi rekening koran tabungan atau fotokopi buku tabungan yang disahkan oleh Bank (sekurang-kurangnya 3 bulan terakhir)</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>11.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat keterangan bertempat tinggal dari kepala desa/lurah tempat tinggal saat ini (bilamana kelompok sasaran tidak bertempat tinggal sesuai alamat pada KTP Elektronik)</td>
                            </tr>

                            {/* B */}
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "6px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>B</td>
                              <td style={{ border: "1px solid #000", padding: "6px 8px", fontWeight: "bold" }}>Dokumen Penghasilan (Pemohon Pegawai)</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>1.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Slip gaji yang disahkan oleh pejabat yang berwenang pada tempat bekerja</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>2.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat keterangan kepegawaian dari tempat bekerja</td>
                            </tr>

                            {/* C */}
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "6px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>C</td>
                              <td style={{ border: "1px solid #000", padding: "6px 8px", fontWeight: "bold" }}>Dokumen Khusus Pemohon Wiraswasta / Pekerja Mandiri</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>1.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat pernyataan penghasilan yang ditandatangani oleh pemohon dan diketahui oleh kepala desa/lurah</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>2.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi dokumen perizinan usaha atau sekurang-kurangnya asli surat keterangan usaha dari kepala desa/lurah</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>3.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Catatan keuangan usaha, dan/atau rekening koran / fotokopi buku tabungan keuangan usaha</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>4.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Dokumen informasi usaha (foto, alamat, waktu operasional, denah lokasi / titik koordinat lokasi usaha)</td>
                            </tr>

                            {/* D SBUM */}
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "6px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>D</td>
                              <td style={{ border: "1px solid #000", padding: "6px 8px", fontWeight: "bold" }}>Dokumen Pemohon SBUM (Untuk KPR Bersubsidi BTN yang mendapatkan fasilitas SBUM)</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>1.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat permohonan Subsidi Bantuan Uang Muka Perumahan (SBUM)</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>2.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat pengakuan kekurangan bayar uang muka KPR Bersubsidi BTN</td>
                            </tr>

                            {/* Pernyataan Debitur (D lagi di dokumen asli) */}
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "6px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>D</td>
                              <td style={{ border: "1px solid #000", padding: "6px 8px", fontWeight: "bold" }}>Surat Pernyataan Debitur</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>1.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat Pernyataan Tidak Bekerja yang diketahui oleh kepala desa/lurah (bilamana salah satu dari kelompok sasaran suami/istri tidak bekerja)</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>2.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat Pernyataan KPR Bersubsidi BTN Format Internal Bank</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>3.</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat Pernyataan KPR Bersubsidi BTN Format Kementerian PUPR</td>
                            </tr>

                            {/* E s/d I */}
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>E</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Surat Kuasa Pemohon</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>F</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Laporan Pemeriksaan Akhir (LPA)</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>G</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Surat Pernyataan Pemeriksaan Kelaikan Fungsi Bangunan Gedung</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>E</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Foto dokumentasi akad kredit pemohon KPR Bersubsidi BTN</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>I</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Berita Acara Serah Terima (BAST) Rumah Umum Tapak / Sarusun Umum</td>
                            </tr>
                            <tr>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>J</td>
                              <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Foto dokumentasi stiker atau plat KPR Bersubsidi telah terpasang</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {detailType === "flpp_ta" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN PERSETUJUAN <br /> PENYALURAN KPR SEJAHTERA FLPP TA 2025
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>No. KTP</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Tempat, Tanggal Lahir</td>
                              <td>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Pekerjaan</td>
                              <td>:</td>
                              <td>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td>:</td>
                              <td>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <p>Selaku Pemohon.</p>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>No. KTP</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Tempat, Tanggal Lahir</td>
                              <td>:</td>
                              <td>
                                {info.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(info.sls_appl?.birthat_spouse) ?? "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Pekerjaan</td>
                              <td>:</td>
                              <td>{info.sls_appl?.job_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td>:</td>
                              <td>{info.sls_appl?.address_spouse ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p>Selaku istri/suami* pemohon.</p>
                        <p>Menyatakan dengan sesungguhnya bahwa sehubungan dengan kerja sama penyaluran Subsidi Bantuan Uang Muka Perumahan (SBUM) Tahun 2025 masih dalam proses kajian internal Kementerian PUPR, maka atas fasilitas Kredit Pemilikan Rumah (KPR) Sejahtera FLPP yang Saya dan istri/suami* ajukan maka Saya dan istri/suami*:</p>
                        <ol style={{ paddingLeft: "15px" }}>
                          <li>Mengetahui dan menyetujui bahwa penyaluran KPR Sejahtera FLPP TA 2025 dimaksud atas pembelian rumah umum tapak pada proyek perumahan Pesona Kahuripan Cluster ……………………………………… Blok/No D2 - 14 yang dikembangkan oleh PT.Hikmah Alam Sentosa dengan fasilitas SBUM yang akan dibayarkan apabila telah dapat ditagihkan dan sesuai dengan ketentuan pada PKS SBUM TA 2025.</li>
                          <li>Bersedia dilakukan pemblokiran dana sebesar Rp. 4.000.000,-/Rp. 10.000.000,-*) dan bersedia untuk dilakukan pemindahanbukuan atas dana tersebut ke Rekening Develover dengan Nomor Rekening :00130.0130.000188.0 atas nama PT.Hikmah Alam Sentosa sebagai pengganti Dana SBUM apabila fasilitas SBUM tidak dapat ditagihkan kepada Setker PUPR.</li>
                        </ol>
                        <p>Demikian surat pernyataan ini saya buat dengan sebenarnya tanpa paksaan dari pihak manapun dan apabila di kemudian hari pernyataan saya ini tidak benar, saya bersedia mengembalikan seluruh subsidi yang saya terima.</p>
                        <p>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "70%",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  width: "50%",
                                  textAlign: "center",
                                }}
                              >
                                Menyetujui,
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  textAlign: "center",
                                }}
                              >
                                ......................, tanggal ................ 20...
                                <br />
                                <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                                <br /> <br /> <br /> <br />
                              </td>
                            </tr>

                            {/* Kotak Materai */}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "28px 12px 8px 12px",
                                  verticalAlign: "top",
                                }}
                              >
                                {/* Kosong untuk tanda tangan kiri */}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    border: "1px solid black",
                                    width: "140px",
                                    height: "80px",
                                    top: "-50px",
                                    left: "50%",
                                    padding: "10px",
                                    fontSize: "12px",
                                    textAlign: "center",
                                    position: "absolute",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "white",
                                  }}
                                >
                                  Meterai
                                  <br />
                                  Rp. 10.000,-
                                </div>
                              </td>
                            </tr>

                            {/* Baris tanda tangan */}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                <br />
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                {info.sls_appl?.name ?? "-"}
                              </td>
                            </tr>

                            {/* Baris Mengetahui */}
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "12px",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                }}
                              >
                                Mengetahui,
                                <br />
                                Pengembang PT ANGGGA BUDI KUSUMA
                              </td>
                            </tr>

                            {/* Baris tanda tangan bawah */}
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "60px 12px 20px 12px",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                Nama Lengkap, Jabatan dan Stempel
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <p>*)Coret salah satu yang tidak perlu</p>
                    </div>
                  )}
                  {detailType === "pernyataan_developer" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN DEVELOPER
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>No. KTP</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Jabatan</td>
                              <td>:</td>
                              <td>{info.sls_appl?.job_position ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Nama Developer</td>
                              <td>:</td>
                              <td>{companySelected?.label}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td>:</td>
                              <td>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginTop: "10px" }}>Dengan ini menyatakan bahwa debitur:</div>{" "}
                        <table style={{ marginTop: "10px", marginBottom: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>No. KTP</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat Perumahan</td>
                              <td>:</td>
                              <td>{info.sales_branch?.branch_address[0]?.description ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <p>Melaksanakan akad kredit di Bank BTN dengan kondisi saat ini fasilitas SBUM akan dibayarkan apabila telah dapat ditagihkan dan sesuai dengan ketentuan pada PKS SBUM TA 2025. Sehubungan dengan hal tersebut kami menyatakan tidak akan mengaitkan pembayaran SBUM debitur dimaksud kepada Bank BTN.</p>
                        <p>Demikian surat pernyataan ini dibuat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "70%",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  width: "50%",
                                  textAlign: "center",
                                }}
                              >
                                <br />
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  textAlign: "center",
                                }}
                              >
                                ......................, ................ 20...
                                <br />
                                <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                                <br />
                                <span style={{ fontWeight: "bold" }}>Yang Menyatakan,</span>
                                <br /> <br /> <br /> <br />
                              </td>
                            </tr>

                            {/* Kotak Materai */}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "28px 12px 8px 12px",
                                  verticalAlign: "top",
                                }}
                              >
                                {/* Kosong untuk tanda tangan kiri */}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    border: "1px solid black",
                                    width: "140px",
                                    height: "80px",
                                    top: "-50px",
                                    left: "50%",
                                    padding: "10px",
                                    fontSize: "12px",
                                    textAlign: "center",
                                    position: "absolute",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "white",
                                  }}
                                >
                                  Meterai
                                  <br />
                                  Rp. 10.000,-
                                </div>
                              </td>
                            </tr>

                            {/* Baris tanda tangan */}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                <br />
                                <br />
                                <br />
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                Nama Lengkap Pembuat Pernyataan dan Stempel <br /> Developer
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <p>*) coret salah yang tidak perlu</p>
                    </div>
                  )}
                  {detailType === "batasan_harga_jual_rumah" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        BATASAN HARGA JUAL RUMAH UMUM TAPAK <br />
                        DAN SATUAN RUMAH SUSUN UMUM
                      </div>

                      <div style={{ padding: "10px" }}>
                        <ol style={{ paddingLeft: "15px" }}>
                          <li>
                            Rumah Umum Tapak
                            <br />{" "}
                            <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                              <tbody>
                                {/* A */}
                                <tr>
                                  <td
                                    style={{
                                      width: "60px",
                                      border: "1px solid #000",
                                      padding: "6px 8px",
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                    NO
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #000",
                                      padding: "6px 8px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    WILAYAH
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #000",
                                      padding: "6px 8px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    HARGA JUAL PALING BANYAK 2024 (Rp)
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "center" }}>1.</td>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Jawa (kecuali Jakarta, Bogor, Depok, Tangerang, Bekasi) dan Sumatera (kecuali Kep. Riau, Bangka Belitung, Kepulauan Mentawai)</td>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top" }}>166.000.000</td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "center" }}>2.</td>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kalimantan (kecuali Kabupaten Murung Raya dan Kabupaten Mahakam Ulu)</td>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top" }}>182.000.000</td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "center" }}>3.</td>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Sulawesi, Bangka Belitung, Kepulauan Mentawai, dan Kepulauan Riau (kecuali Kepulauan Anambas)</td>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top" }}>173.000.000</td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "center" }}>4.</td>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Maluku, Maluku Utara, Bali dan Nusa Tenggara, Jabodetabek (Jakarta, Bogor,Depok, Tangerang, Bekasi), Kepulauan Anambas, Kabupaten Murung Raya, dan Kabupaten Mahakam Ulu</td>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top" }}>185.000.000</td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "center" }}>5.</td>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Papua dan Papua Barat</td>
                                  <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top" }}>240.000.000</td>
                                </tr>
                              </tbody>
                            </table>
                          </li>
                          <li>
                            Satuan Rumah Susun Umum
                            <ol type="a" style={{ paddingLeft: "24px" }}>
                              <li>
                                Provinsi
                                <br />{" "}
                                <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          width: "60px",
                                          border: "1px solid #000",
                                          padding: "6px 8px",
                                          fontWeight: "bold",
                                          textAlign: "center",
                                        }}
                                      >
                                        NO
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #000",
                                          padding: "6px 8px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        WILAYAH
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #000",
                                          padding: "6px 8px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        HARGA JUAL/m2 PALING BANYAK (Rp)
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #000",
                                          padding: "6px 8px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        HARGA JUAL PALING BANYAK (Rp)
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>1</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Nanggroe Aceh Darussalam</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.500.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>306.000.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>2</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sumatera Utara</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.800.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>280.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>3</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sumatera Barat</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.800.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>316.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>4</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Riau</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.500.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>342.000.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>5</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kepulauan Riau</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>10.000.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>360.000.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>6</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Jambi</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.800.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>316.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>7</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Bengkulu</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.000.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>288.000.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>8</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sumatera Selatan</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.700.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>313.200.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>9</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Bangka Belitung</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.900.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>320.400.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>10</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Lampung</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.000.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>288.400.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>11</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Banten (kecuali Kota/Kabupaten Tangerang dan Kota Tangerang Selatan)</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.600.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>273.600.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>12</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Jawa Barat (kecuali Kota Depok, Kota/Kabupaten Bogor, dan Kota/Kabupaten Bekasi)</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.300.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>262.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>13</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Jawa Tengah</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.200.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>259.200.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>14</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Daerah Istimewa Yogyakarta</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.300.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>262.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>15</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Jawa Timur</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.900.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>284.400.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>16</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Bali</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.300.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>298.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>17</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Nusa Tenggara Barat</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.400.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>266.400.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>18</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Nusa Tenggara Timur</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.600.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>309.600.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>19</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kalimantan Barat</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.700.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>349.200.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>20</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kalimantan Tengah</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.400.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>338.400.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>21</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kalimantan Utara</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.800.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>352.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>22</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kalimantan Timur</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.900.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>356.000.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>23</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kalimantan Selatan</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.000.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>324.400.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>24</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sulawesi Utara</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.800.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>280.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>25</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Gorontalo</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.300.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>298.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>26</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sulawesi Tengah</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>6.900.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>248.400.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>27</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sulawesi Tenggara</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.200.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>295.200.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>28</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sulawesi Barat</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.700.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>313.200.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>29</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sulawesi Selatan</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.300.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>262.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>30</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Maluku</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.600.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>273.600.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>31</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Maluku Utara</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.600.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>345.600.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>32</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Papua</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>15.700.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>565.200.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>33</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Papua Barat</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>10.700.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>385.200.000</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </li>
                              <li>
                                Kota/Kabupaten
                                <br />{" "}
                                <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          width: "60px",
                                          border: "1px solid #000",
                                          padding: "6px 8px",
                                          fontWeight: "bold",
                                          textAlign: "center",
                                        }}
                                      >
                                        NO
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #000",
                                          padding: "6px 8px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        WILAYAH
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #000",
                                          padding: "6px 8px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        HARGA JUAL/m2 PALING BANYAK (Rp)
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #000",
                                          padding: "6px 8px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        HARGA JUAL PALING BANYAK (Rp)
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>1</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Jakarta Barat</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.900.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>320.400.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>2</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Jakarta Selatan</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.200.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>331.200.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>3</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Jakarta Timur</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.800.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>316.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>4</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Jakarta Utara</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.600.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>345.600.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>5</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Jakarta Pusat</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.300.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>334.800.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>6</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota/Kabupaten Tangerang dan Kota Tangerang Selatan</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.400.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>302.400.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>7</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Depok</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.500.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>306.000.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>8</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota/Kabupaten Bogor</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.600.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>309.600.000</td>
                                    </tr>
                                    <tr>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>9</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota/Kabupaten Bekasi</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.400.000</td>
                                      <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>302.400.000</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </li>
                            </ol>
                          </li>
                        </ol>
                      </div>
                    </div>
                  )}
                  {detailType === "permohonan_kpr_subsidi" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN PEMOHON KPR BERSUBSIDI BTN
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Tempat/Tanggal Lahir</td>
                              <td>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr>
                              <td>Pekerjaan</td>
                              <td>:</td>
                              <td>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>No. KTP/NIK</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td>:</td>
                              <td>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginBottom: "20px" }}>Selaku Pemohon.</div>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Tempat/Tanggal Lahir</td>
                              <td>:</td>
                              <td>
                                {info.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(info.sls_appl?.birthat_spouse) ?? ""}
                              </td>
                            </tr>
                            <tr>
                              <td>Pekerjaan</td>
                              <td>:</td>
                              <td>{info.sls_appl?.job_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>No. KTP/NIK</td>
                              <td>{info.sls_appl?.identity_spouse ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td>:</td>
                              <td>{info.sls_appl?.address_spouse ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginBottom: "20px" }}>Selaku suami/istri* pemohon.</div>

                        <div style={{ marginTop: "20px" }}>Menyatakan dengan sesungguhnya bahwa:</div>
                        <ol style={{ paddingLeft: "15px" }}>
                          <li>Saya memiliki gaji/upah pokok/penghasilan bersih/upah rata – rata *) per bulan sebesar Rp. ................................,- (................................)</li>
                          <li>Saya dan (istri/suami*)) tidak memiliki hak kepemilikan atas rumah pada saat pengajuan pembiayaan KPR Bersubsidi.</li>
                          <li>Saya dan (istri/suami*)) belum pernah menerima subsidi atau bantuan pembiayaan perumahan dari pemerintah terkait kredit/pembiayaan perumahan dari pemerintah terkait kredit/pembiayaan kepemilikan rumah dan pembangunan Rumah Swadaya.</li>
                          <li>Saya membeli Rumah Umum Tapak/Sarusun Umum dengan harga Rp ............................................. ,- (........................................................) dari PT................................</li>
                          <li>Saya dan (istri/suami*)) akan menggunakan Rumah Umum Tapak/Sarusun Umum sebagai tempat tinggal saya dan/atau keluarga dalam kurun waktu paling lambat 1 (satu) tahun setelah serah terima rumah.</li>
                          <li>
                            Saya dan (istri/suami*)) tidak akan menyewakan/mengontrakkan, memperjualbelikan atau memindahtangankan dengan bentuk perbuatan hukum apapun, kecuali:
                            <br />
                            <ol type="a" style={{ paddingLeft: "15px" }}>
                              <li>penghunian telah melampaui 5 (lima) tahun untuk Rumah Umum Tapak;</li>
                              <li>penghunian telah melampaui 20 (dua puluh) tahun untuk Sarusun Umum;</li>
                              <li>pindah tempat tinggal sesuai ketentuan peraturan perundang-undangan; atau</li>
                              <li>meninggal dunia (pewarisan); atau</li>
                              <li>untuk kepentingan Bank BTN dalam rangka penyelesaian kredit bermasalah.</li>
                            </ol>
                          </li>
                          <li>Bahwa semua dokumen persyaratan yang disampaikan kepada Bank BTN untuk memperoleh subsidi adalah benar dan dapat dipertanggungjawabkan keabsahannya.</li>
                          <li>Apabila di kemudian hari pernyataan saya ini tidak benar dan/atau tidak saya penuhi, saya bersedia mengembalikan seluruh dana kemudahan dan/atau bantuan pembiayaan perumahan yang telah diperoleh melalui Bank BTN dan bersedia dikenakan sanksi sesuai dengan ketentuan peraturan perundang- undangan.</li>
                        </ol>
                        <p>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "70%",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  width: "50%",
                                  textAlign: "center",
                                }}
                              >
                                Menyetujui,
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  textAlign: "center",
                                }}
                              >
                                ......................, tanggal ................ 20...
                                <br />
                                <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                                <br /> <br /> <br /> <br />
                              </td>
                            </tr>

                            {/* Kotak Materai */}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "28px 12px 8px 12px",
                                  verticalAlign: "top",
                                }}
                              >
                                {/* Kosong untuk tanda tangan kiri */}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    border: "1px solid black",
                                    width: "140px",
                                    height: "80px",
                                    top: "-50px",
                                    left: "50%",
                                    padding: "10px",
                                    fontSize: "12px",
                                    textAlign: "center",
                                    position: "absolute",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "white",
                                  }}
                                >
                                  Meterai
                                  <br />
                                  Rp. 10.000,-
                                </div>
                              </td>
                            </tr>

                            {/* Baris tanda tangan */}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                <br />
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                {info.sls_appl?.name ?? "-"}
                              </td>
                            </tr>

                            {/* Baris Mengetahui */}
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "12px",
                                  textAlign: "center",
                                }}
                              >
                                Mengetahui,
                                <br />
                                Pimpinan Tempat Bekerja/Kepala Desa/Lurah* ......................................................
                              </td>
                            </tr>

                            {/* Baris tanda tangan bawah */}
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "60px 12px 20px 12px",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                Nama Lengkap, Jabatan dan Stempel
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <p>*) coret salah yang tidak perlu</p>
                    </div>
                  )}
                  {detailType === "penyerahan_spt_pph" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN PENYERAHAN SPT PPH
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>No. KTP/NIK</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td>Tempat/Tanggal Lahir</td>
                              <td>:</td>
                              <td>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr>
                              <td>Pekerjaan</td>
                              <td>:</td>
                              <td>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td>:</td>
                              <td>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div style={{ marginTop: "20px" }}>Menyatakan hal-hal sebagai berikut:</div>
                        <ol style={{ paddingLeft: "15px" }}>
                          <li>Bahwa dikarenakan saya memiliki Nomor Pokok Wajib Pajak (NPWP) kurang dari 1 (satu) tahun pada saat pengajuan KPR Bersubsidi BTN, maka saya belum dapat menyampaikan Surat Pemberitahuan Tahunan (SPT) Pajak Penghasilan (PPh) Orang Pribadi sebagai salah satu dokumen persyaratan pengajuan KPR Bersubsidi BTN sebagaimana telah diatur pada ketentuan Pemerintah.</li>
                          <li>Bahwa saya bersedia menyampaikan dokumen SPT PPh tahun berikutnya setelah akad kredit KPR Bersubsidi BTN kepada Bank BTN.</li>
                          <li>Bahwa saya bersedia menerima konsekuensi yang diberikan oleh Pemerintah dalam hal saya terlambat dan/atau tidak menyerahkan dokumen SPT PPh tahun berikutnya setelah akad kredit KPR Bersubsidi kepada Bank BTN.</li>
                        </ol>
                        <p>Demikian surat pernyataan ini saya buat dengan sebenarnya tanpa paksaan dari pihak manapun dan apabila di kemudian hari pernyataan saya ini tidak benar, saya bersedia mengembalikan seluruh subsidi yang saya terima.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "300px",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "12px",
                                  textAlign: "center",
                                }}
                              >
                                ......................, tanggal ................ 20...
                                <br />
                                <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                                <br /> <br /> <br /> <br />
                              </td>
                            </tr>
                            {/* Baris Mengetahui */}
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "12px",
                                  textAlign: "center",
                                }}
                              >
                                <br />
                                <br />
                                <br />
                              </td>
                            </tr>

                            {/* Baris tanda tangan bawah */}
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "60px 12px 20px 12px",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                {info.sls_appl?.name ?? "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {detailType === "bast_rumah_umum_tapak" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        BERITA ACARA SERAH TERIMA
                        <br /> RUMAH UMUM TAPAK
                      </div>

                      <div style={{ padding: "10px" }}>
                        <p>Berdasarkan PPJB/AJB*) No. ........... Tanggal : ............................ 20...................... telah dilakukan serah terima pada tanggal ............................ 20...................... dari Pengembang ...................... (diisi nama Pengembang) , selanjutnya disebut “Pihak Pertama”;</p>
                        <div style={{ marginTop: "10px" }}>Kepada pembeli:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ width: "10px" }}>{"1."}</td>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"2."}</td>
                              <td>NIK</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"3."}</td>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td>:</td>
                              <td>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"4."}</td>
                              <td>Nomor Telp./HP</td>
                              <td>:</td>
                              <td>{info.sls_appl?.phone ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginBottom: "20px" }}>
                          selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Pihak Kedua”</span>
                        </div>

                        <div style={{ marginTop: "10px" }}>Atas 1 (Satu) unit Rumah Umum Tapak pada lokasi sebagai berikut:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ width: "10px" }}>{"1."}</td>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama Perumahan</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"2."}</td>
                              <td>No. Rumah</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"3."}</td>
                              <td>Luas Tanah dan Lantai Rumah</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"4."}</td>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"5."}</td>
                              <td>Kota/Kabupaten/Provinsi</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginBottom: "20px" }}>
                          Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Obyek Serah Terima”</span>
                        </div>

                        <div style={{ marginTop: "20px" }}>Obyek Serah Terima dengan kondisi laik fungsi dan dilengkapi dengan:</div>
                        <ol style={{ paddingLeft: "15px" }}>
                          <li>Jaringan air bersih sudah berfungsi;</li>
                          <li>Jaringan listrik sudah berfungsi;</li>
                          <li>Jalan lingkungan sudah selesai dan berfungsi;</li>
                          <li>Saluran/drainase lingkungan sudah selesai dan berfungsi;</li>
                          <li>Saluran air limbah/air kotor rumah tangga sudah selesai dan berfungsi; dan</li>
                          <li>Sarana pewadahan sampah individual dan tempat pembuangan sampah sementara.</li>
                        </ol>
                        <p>Demikian berita acara serah terima ini ditandatangani oleh kedua belah pihak dan dapat dipertanggungjawabkan.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "70%",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                Pihak Pertama/Kuasa*,
                                <br />
                                <span style={{ fontWeight: "bold" }}>ANGGA BUDI KUSUMA</span>
                                <br />
                                <br />
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  verticalAlign: "top",
                                  textAlign: "center",
                                }}
                              >
                                Pihak Kedua
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                Nama Lengkap, Jabatan dan Stempel
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                {info.sls_appl?.address ?? "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <p>*) coret salah yang tidak perlu</p>
                    </div>
                  )}
                  {detailType === "bast_sarusun_umum" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        BERITA ACARA SERAH TERIMA
                        <br /> SARUSUN UMUM
                      </div>

                      <div style={{ padding: "10px" }}>
                        <p>Berdasarkan PPJB/AJB*) No. ........... Tanggal : ............................ 20...................... telah dilakukan serah terima pada tanggal ............................ 20...................... dari Pengembang ...................... (diisi nama Pengembang) , selanjutnya disebut “Pihak Pertama”;</p>
                        <div style={{ marginTop: "10px" }}>Kepada pembeli:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ width: "10px" }}>{"1."}</td>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"2."}</td>
                              <td>NIK</td>
                              <td>:</td>
                              <td>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"3."}</td>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"4."}</td>
                              <td>Nomor Telp./HP</td>
                              <td>:</td>
                              <td>{info.sls_appl?.phone ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginBottom: "20px" }}>
                          selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Pihak Kedua”</span>
                        </div>

                        <div style={{ marginTop: "10px" }}>Atas 1 (Satu) unit Rumah Umum Tapak pada lokasi sebagai berikut:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                          <tbody>
                            <tr>
                              <td style={{ width: "10px" }}>{"1."}</td>
                              <td style={{ verticalAlign: "top", width: "180px" }}>Nama Perumahan</td>
                              <td style={{ width: "15px" }}>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"2."}</td>
                              <td>No. Rumah</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"3."}</td>
                              <td>Luas Tanah dan Lantai Rumah</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"4."}</td>
                              <td style={{ verticalAlign: "top" }}>Alamat</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "10px" }}>{"5."}</td>
                              <td>Kota/Kabupaten/Provinsi</td>
                              <td>:</td>
                              <td>{""}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginBottom: "20px" }}>
                          Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Obyek Serah Terima”</span>
                        </div>

                        <div style={{ marginTop: "20px" }}>Obyek Serah Terima dengan kondisi laik fungsi dan dilengkapi dengan:</div>
                        <ol style={{ paddingLeft: "15px" }}>
                          <li>Jaringan air bersih sudah berfungsi;</li>
                          <li>Jaringan listrik sudah berfungsi;</li>
                          <li>Tangga dan/atau lift;</li>
                          <li>Jalan lingkungan sudah selesai dan berfungsi;</li>
                          <li>Saluran/drainase lingkungan sudah selesai dan berfungsi;</li>
                          <li>Saluran air limbah/air kotor rumah tangga sudah selesai dan berfungsi; dan</li>
                          <li>Sarana pewadahan sampah individual dan tempat pembuangan sampah sementara.</li>
                        </ol>
                        <p>Demikian berita acara serah terima ini ditandatangani oleh kedua belah pihak dan dapat dipertanggungjawabkan.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "70%",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                Pihak Pertama/Kuasa*,
                                <br />
                                <span style={{ fontWeight: "bold" }}>ANGGA BUDI KUSUMA</span>
                                <br />
                                <br />
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  verticalAlign: "top",
                                  textAlign: "center",
                                }}
                              >
                                Pihak Kedua
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                Nama Lengkap, Jabatan dan Stempel
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                {info.sls_appl?.name ?? "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <p>*) coret salah yang tidak perlu</p>
                    </div>
                  )}
                  {detailType === "pernyataan_verivikasi_2" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN VERIFIKASI
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
                          <tbody style={{ border: "1px solid black" }}>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>NIK</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>NIP</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Jabatan</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.job_position ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Alamat Kantor</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.job_business_address ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>No. Telp./Fax.</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.phone ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div style={{ marginTop: "20px", fontWeight: "bold", textAlign: "center" }}>Menyatakan</div>
                        <ol style={{ paddingLeft: "15px" }}>
                          <li>Telah melaksanakan verifikasi dokumen Kelompok Sasaran KPR Sejahtera sebanyak ..................................................... Pemohon</li>
                          <li>Bahwa verifikasi dilakukan berupa verifikasi administrasi untuk memastikan ketetapan sasaran dan pemenuhan ketentuan KPR Sejahtera.</li>
                          <li>
                            Bahwa verifikasi administrasi yang dilakukan meliputi:
                            <br />{" "}
                            <ol type="a" style={{ paddingLeft: "15px" }}>
                              <li>
                                Pemeriksaan kelengkapan dan kesesuaian dokumen persyaratan pemohon yang meliputi:
                                <br />
                                <ol style={{ paddingLeft: "15px" }}>
                                  <li>Surat Pemesanan Rumah dari Pengembang</li>
                                  <li>Identitas pemohon KPR KPR Sejahtera/KPR SSB/KPR SSM*);</li>
                                </ol>
                              </li>
                              <li>Pemeriksaan kesesuaian penghasilan Pemohon dengan ketentuan Kelompok Sasaran sesuai ketentuan peraturan perundang-undangan;</li>
                              <li>Pemeriksaan kesesuaian harga Rumah Umum Tapak/Sarusun Umum*) dengan batasan harga jual sesuai ketentuan peraturan perundang-undangan;</li>
                              <li>Analisa kemampuan mengangsur Pemohon;</li>
                            </ol>
                          </li>
                          <li>
                            Pemberian KPR KPR Sejahtera dimaksud telah melalui prosedur sebagai berikut:
                            <br />
                            <ol type="a" style={{ paddingLeft: "15px" }}>
                              <li>Pemeriksaan kelengkapan data administrasi.</li>
                              <li>Wawancara terhadap pemohon.</li>
                            </ol>
                          </li>
                          <li>Berdasarkan hal-hal tersebut pada angka 1 sampai dengan angka 4, maka pemohon sebagaimana dimaksud telah memenuhi syarat dan ketentuan sebagai Kelompok Sasaran KPR Sejahtera dan layak untuk diberikan dana FLPP/SBUM*).</li>
                          <li>Seluruh dokumen persyaratan pemohon sebagaimana dimaksud angka 3 butir a, sesuai dengan aslinya dan dapat dibuktikan apabila dibutuhkan sewaktu-waktu.</li>

                          <li>Surat Pernyataan Verifikasi sesuai dengan aslinya, dapat dipertanggungjawabkan dan dapat dibuktikan apabila dibutuhkan sewaktu-waktu.</li>
                        </ol>
                        <p>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "350px",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "12px",
                                  textAlign: "center",
                                  position: "relative",
                                }}
                              >
                                ......................, tanggal ................ 20...
                                <br />
                                <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                                <br /> <span style={{ fontWeight: "bold" }}>PT. BANK TABUNGAN NEGARA (PERSERO) Tbk.</span> <br /> ..................................................... <br /> <br />
                                <br />
                                <div
                                  style={{
                                    border: "1px solid black",
                                    width: "140px",
                                    bottom: "-20px",
                                    left: "50%",
                                    padding: "10px",
                                    fontSize: "12px",
                                    textAlign: "center",
                                    position: "absolute",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "white",
                                  }}
                                >
                                  Meterai
                                  <br />
                                  Rp. 10.000,-
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "60px 12px 20px 12px",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                Nama Lengkap, Jabatan dan Stempel
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {detailType === "permohonan_kpr_subsidi2" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERNYATAAN PEMOHON KPR BERSUBSIDI BTN
                      </div>

                      <div style={{ padding: "10px" }}>
                        <p>Berkenaan dengan persetujuan Kredit Pemilikan Rumah Bersubsidi BTN (KPR Bersubsidi BTN) yang disampaikan PT Bank Tabungan Negara (Persero) Tbk (Bank BTN) melalui Surat Persetujuan Pemberian Kredit (SP3K) No..................................................... Tanggal....................................................., kami yang bertanda tangan dibawah ini:</p>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
                          <tbody style={{ border: "1px solid black" }}>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>• Nama Lengkap</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>• No. KTP</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>• Tempat, Tanggal Lahir</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>• Pekerjaan</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>• Alamat</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginBottom: "10px" }}>Selaku Calon Debitur.</div>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
                          <tbody style={{ border: "1px solid black" }}>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>• Nama Lengkap</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.name_spouse ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>• No. KTP</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.identity_spouse ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>• Tempat, Tanggal Lahir</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>
                                {info.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(info.sls_appl?.birthat_spouse) ?? ""}
                              </td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>• Pekerjaan</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.job_spouse ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>• Alamat</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.address_spouse ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginBottom: "10px" }}>Selaku suami/istri* Calon Debitur.</div>

                        <div style={{ marginTop: "20px", fontWeight: "bold", textAlign: "center" }}>Menyatakan dengan sesungguhnya bahwa:</div>
                        <ol style={{ paddingLeft: "15px" }}>
                          <li>Telah melaksanakan setiap proses permohonan KPR Bersubsidi BTN sesuai dengan ketentuan Bank BTN dan menyetujui SP3K dimaksud berdasarkan itikad baik, dalam keadaan bebas, mandiri dan tidak di bawah tekanan maupun pengaruh dari pihak lain (independency).</li>
                          <li>Telah menerima dan memahami dengan baik setiap penjelasan yang disampaikan Bank BTN mengenai fasilitas KPR Bersubsidi BTN, hak dan kewajiban kami sebagai Debitur serta kewajiban lainnya sesuai ketentuan peraturan perundang – undangan.</li>
                          <li>Bersedia melakukan aktivasi ulang QR Code setiap tahun hingga tahun ke 5 (lima) sejak akad KPR Bersubsidi BTN sesuai dengan ketentuan Pemerintah.</li>
                          <li>Bersedia menyerahkan data pribadi (KTP dan NPWP) untuk mendapatkan fasilitas KPR Sejahtera dan semua data lainnya yang diperlukan oleh Regulator melalui Bank.</li>
                          <li>
                            Bersedia menyerahkan dokumen bukti pelaporan Pajak :
                            <br />
                            <ol type="a" style={{ paddingLeft: "15px" }}>
                              <li>Telah menjadi wajib pajak ≥ 1 tahun dan penghasilan ≥ PTKP, melampirkan SPT PPh</li>
                              <li>{`Belum menjadi wajib pajak < 1 tahun, melampirkan surat pernyataan penyerahan SPT PPh tahun selanjutnya`}.</li>
                              <li>Apabila dikemudian hari diperlukan penyampaian SPT PPH, Saya bersedia menyerahkan SPT PPh kepada pihak Bank.</li>
                            </ol>
                          </li>
                          <li>Seluruh dokumen persyaratan yang disampaikan kepada Bank BTN untuk memperoleh fasilitas subsidi adalah benar dan dapat dipertanggungjawabkan keabsahannya baik secara formil maupun material.</li>
                          <li>Bersedia untuk menanggung segala biaya yang meliputi biaya asuransi, biaya pengikatan agunan, dan biaya lainnya yang timbul karena terjadinya penghentian KPR Bersubsidi BTN dan/atau perubahan/konversi menjadi KPR Non-Subsidi.</li>

                          <li>
                            Tidak akan menjanjikan atau memberikan sesuatu baik secara langsung dan tidak langsung, baik atas inisiatif sendiri maupun orang lain, baik dengan menggunakan sarana elektronik atau tanpa sarana elektronik, baik dalam bentuk uang atau bukan uang seperti hadiah, cinderamata, komisi, pinjaman tanpa bunga, tiket perjalanan, fasilitas penginapan, perjalanan wisata, pengobatan cuma – cuma, hiburan dan fasilitas lainnya atau bentuk lainnya kepada setiap pejabat dan/atau
                            pegawai Bank BTN termasuk anggota keluarga intinya.
                          </li>
                          <li>Apabila dikemudian hari diketahui bahwa pernyataan kami ini dan pernyataan lainnya yang kami sampaikan kepada Bank BTN tidak benar dan/atau saya penuhi, maka saya bersedia mengembalikan seluruh subsidi yang telah saya terima dari Pemerintah, bersedia dikenakan sanksi sesuai dengan ketentuan peraturan perundang – undangan dan bersedia mengubah/mengkonversi menjadi KPR Non-Subsidi.</li>
                        </ol>
                        <p>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "70%",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  width: "50%",
                                  textAlign: "center",
                                }}
                              >
                                Menyetujui,
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  textAlign: "center",
                                }}
                              >
                                ......................, tanggal ................ 20...
                                <br />
                                <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                                <br /> <br /> <br /> <br />
                              </td>
                            </tr>

                            {/* Kotak Materai */}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "28px 12px 8px 12px",
                                  verticalAlign: "top",
                                }}
                              >
                                {/* Kosong untuk tanda tangan kiri */}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    border: "1px solid black",
                                    width: "140px",
                                    height: "80px",
                                    top: "-50px",
                                    left: "50%",
                                    padding: "10px",
                                    fontSize: "12px",
                                    textAlign: "center",
                                    position: "absolute",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "white",
                                  }}
                                >
                                  Meterai
                                  <br />
                                  Rp. 10.000,-
                                </div>
                              </td>
                            </tr>

                            {/* Baris tanda tangan */}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                <br />
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                {info.sls_appl?.name ?? "-"}
                              </td>
                            </tr>

                            {/* Baris Mengetahui */}
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "12px",
                                  textAlign: "center",
                                }}
                              >
                                Mengetahui,
                                <br />
                                Pimpinan Tempat Bekerja/Kepala Desa/Lurah* ……………………………….
                              </td>
                            </tr>

                            {/* Baris tanda tangan bawah */}
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "60px 12px 20px 12px",
                                  textAlign: "center",
                                }}
                              ></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {detailType === "surat_kuasa_bphtb" && ((sales !== undefined && sales !== null) || (info !== undefined && info !== null)) && (
                    <PrintDocSuratKuasaBPHTB innerRef={printRef} item={info || sales} preview />
                  )}
                  {detailType === "surat_kuasa" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT KUASA
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginBottom: "10px" }}>Yang bertanda tangan di bawah ini:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
                          <tbody style={{ border: "1px solid black" }}>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama Lengkap</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>No. KTP</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Tempat, Tanggal Lahir</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Pekerjaan</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>No. Telepon/HP</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.phone ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Alamat</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>
                                <br />
                              </td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}></td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Nomor Rekening Tabungan</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>No. SP3K</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Tanggal Akad KPR Bersubsidi</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Nomor Rekening KPR Bersubsidi</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p>
                          PT. Bank Tabungan Negara (Persero) Tbk., berkedudukan di Jalan Gajah Mada No. 01 Jakarta Pusat yang dalam hal ini diwakili oleh ..................................................... selaku ......................................................di PT. Bank Tabungan Negara (Persero) Tbk. Kantor Cabang ........................................................ Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Penerima Kuasa” KHUSUS</span>.
                        </p>
                        <div style={{ marginTop: "20px" }}>
                          dengan ini <span style={{ fontWeight: "bold" }}>Pemberi Kuasa</span> memberikan kuasa kepada Penerima Kuasa untuk dapat melakukan hal-hal sebagai berikut:
                        </div>

                        <ol style={{ paddingLeft: "15px" }}>
                          <li>Membayarkan sejumlah dana kepada Penjual/Pengembang dari hasil pencairan kredit yang diterima oleh Pemberi Kuasa dari Bank BTN untuk pembayaran lunas harga jual rumah beserta lahan sesuai dengan tujuan pemberian kredit.</li>
                          <li>Melakukan pemindahbukuan pencairan dana Subsidi Bantuan Uang Muka (SBUM) dari rekening simpanan milik Pemberi Kuasa di Bank BTN sebagaimana tersebut di atas senilai ..........................................................(.........................................................) untuk digunakan sebagai pengurang pokok kredit/pembayaran kekurangan uang muka pembelian Rumah Umum Tapak dalam hal Pemberi Kuasa mendapatkan fasilitas SBUM.</li>
                          <li>
                            Pembayaran dan pemindahbukuan dana sebagaimana dimaksud pada butir 1 dan butir 2 ditujukan kepada:
                            <br />
                            <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
                              <tbody style={{ border: "1px solid black" }}>
                                <tr style={{ border: "1px solid black" }}>
                                  <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama Pengembang</td>
                                  <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                                  <td style={{ padding: "4px 6px" }}>{""}</td>
                                </tr>
                                <tr style={{ border: "1px solid black" }}>
                                  <td style={{ padding: "4px 6px" }}>Nomor Rekening</td>
                                  <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                                  <td style={{ padding: "4px 6px" }}>{""}</td>
                                </tr>
                                <tr style={{ border: "1px solid black" }}>
                                  <td style={{ padding: "4px 6px" }}>Rekening Atas Nama</td>
                                  <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                                  <td style={{ padding: "4px 6px" }}>{""}</td>
                                </tr>
                                <tr style={{ border: "1px solid black" }}>
                                  <td style={{ padding: "4px 6px" }}>Pada Bank</td>
                                  <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                                  <td style={{ padding: "4px 6px" }}>Bank BTN Kantor Cabang/Kantor Cabang Pembantu/ Kantor Kas .....................................................</td>
                                </tr>
                              </tbody>
                            </table>
                          </li>
                          <li>
                            Memblokir, mendebet dan/atau memindahbukukan dana dari rekening simpanan milik Pemberi Kuasa di Bank BTN sebagaimana tersebut di atas untuk keperluan pembayaran:
                            <br />
                            <ol type="a" style={{ paddingLeft: "15px" }}>
                              <li>Biaya proses dan/atau prarealisasi kredit;</li>
                              <li>Angsuran kredit yang meliputi pokok, bunga, denda, dan biaya lainnya; dan</li>
                              <li>Biaya asuransi, pengikatan agunan, dan biaya lainnya yang timbul karena terjadinya penghentikan KPR Bersubsidi BTN dan/atau perubahan/konversi menjadi KPR Non-Subsidi.</li>
                            </ol>
                          </li>
                          <li>Pembayaran, pemindahbukuan, pemblokiran, dan/atau pendebetan dana sebagaimana dimaksud pada butir 1 s.d. butir 4 di atas dapat dilakukan oleh Bank BTN secara manual, otomatis dan/atau mekanisme transaksi yang berlaku di Bank BTN.</li>
                        </ol>
                        <p>Demikian Surat Kuasa ini dibuat dengan Hak Substitusi, dan tidak dapat dicabut kembali serta tidak akan berakhir karena sebab – sebab yang tercantum dalam Pasal 1813 Kitab Undang – Undang Hukum Perdata atau karena sebab apapun juga.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "80%",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  width: "50%",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                }}
                              >
                                PENERIMA KUASA
                                <br />
                                PT. BANK TABUNGAN NEGARA (PERSERO) Tbk.
                                <br />
                                KANTOR CABANG .................................
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  textAlign: "center",
                                }}
                              >
                                ......................, tanggal ................ 20...
                                <br />
                                <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                                <br /> <span style={{ fontWeight: "bold" }}>PEMBERI KUASA</span> <br /> <br />
                              </td>
                            </tr>

                            {/* Kotak Materai */}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "38px 12px 8px 12px",
                                  verticalAlign: "top",
                                }}
                              >
                                {/* Kosong untuk tanda tangan kiri */}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    border: "1px solid black",
                                    width: "140px",
                                    height: "80px",
                                    top: "-20px",
                                    left: "50%",
                                    padding: "10px",
                                    fontSize: "12px",
                                    textAlign: "center",
                                    position: "absolute",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "white",
                                  }}
                                >
                                  Meterai
                                  <br />
                                  Rp. 10.000,-
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {detailType === "stiker_plat_kpr" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        STIKER/PLAT KPR BERSUBSIDI BTN
                        <br />
                        YANG DILENGKAPI DENGAN PENANDA DIGITAL QUICK RESPONSE (QR) CODE
                      </div>

                      <div style={{ padding: "10px", display: "flex", justifyContent: "center" }}>
                        <img
                          src={pkn1}
                          alt=""
                          style={{
                            margin: "auto",
                            width: "70%",
                          }}
                        />
                      </div>
                      <div style={{ padding: "10px", display: "flex", justifyContent: "center" }}>
                        <table style={{ marginTop: "10px" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", fontWeight: "bold" }}>BARIS PERTAMA</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td>KPR BERSUBSIDI (HURUF IMPACT UKURAN 66)</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", fontWeight: "bold" }}>BARIS KEDUA</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td>PEMERINTAH REPUBLIK INDONESIA (HURUF IMPACT UKURAN 40)</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", fontWeight: "bold" }}>BARIS KETIGA</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td>LOGO BANK PENYALUR DANA FLPP</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", fontWeight: "bold" }}>UKURAN</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td>21 CM X 15 CM</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top", fontWeight: "bold" }}>WARNA DASAR</td>
                              <td style={{ width: "20px" }}>:</td>
                              <td>baris pertama dan kedua menggunakan warna R(91) G(178) B(72)</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div style={{ padding: "10px", display: "flex", justifyContent: "center" }}>
                        <img
                          src={pkn2}
                          alt=""
                          style={{
                            margin: "auto",
                            width: "40%",
                          }}
                        />
                      </div>
                      <div style={{ padding: "10px", display: "flex", justifyContent: "center" }}>
                        {" "}
                        <p>
                          Keterangan : <br />
                          Stiker/Plat KPR Bersubsidi BTN dipasang di bagian depan rumah penerima bantuan
                        </p>
                      </div>
                    </div>
                  )}
                  {detailType === "sbum2" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PERMOHONAN SUBSIDI BANTUAN UANG MUKA
                      </div>

                      <div style={{ padding: "10px" }}>
                        <p>
                          Kepada Yth: <br />
                          <span style={{ fontWeight: "bold" }}>Kepala Satuan Kerja Direktorat Jenderal Pembiayaan</span> <br />
                          <span style={{ fontWeight: "bold" }}>Infrastruktur Pekerjaan Umum dan Perumahan</span>
                          <br />
                          Kementerian Pekerjaan Umum dan Perumahan Rakyat
                          <br />
                          Jalan Raden Patah 1 No 1 Gedung B Lantai 3<br />
                          Kebayoran Baru, Jakarta Selatan 12110
                          <br />
                        </p>
                        <p>Perihal : Permohonan Subsidi Bantuan Uang Muka Perumahan </p>
                        <div style={{ marginBottom: "10px" }}>Saya yang bertanda tangan di bawah ini:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
                          <tbody style={{ border: "1px solid black" }}>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Tempat, Tanggal Lahir</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Pekerjaan</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>No. KTP</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Alamat</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.address ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={{ marginTop: "10px" }}>mengajukan permohonan Subsidi Bantuan Uang Muka perumahan untuk pembelian Rumah Sejahtera Tapak dengan keterangan sebagai berikut:</p>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
                          <tbody style={{ border: "1px solid black" }}>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama Pengembang</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Alamat Rumah yang Dibeli</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Harga Jual Rumah</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Besaran Uang Muka</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Bank Pelaksana</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{""}</td>
                            </tr>
                          </tbody>
                        </table>
                        <p style={{ marginTop: "10px" }}>Sebagai pertimbangan, bersama ini kami lampirkan dokumen fotokopi surat pengakuan kekurangan bayar uang muka pembelian Rumah Sejahtera Tapak yang disetujui oleh .................................*)</p>
                        <p>Demikian kami sampaikan, atas perhatiannya kami ucapkan terima kasih</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "350px",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "12px",
                                  textAlign: "center",
                                  position: "relative",
                                }}
                              >
                                ......................, tanggal ................ 20...
                                <br />
                                <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                                <br /> <span style={{ fontWeight: "bold" }}>PEMOHON.</span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  border: "1px solid black",
                                  padding: "60px 12px 20px 12px",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                {info.sls_appl?.name ?? "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <p>*) diisi nama direktur/atau yang mewakili pengembang </p>
                    </div>
                  )}
                  {detailType === "surat_kekurangan_uang_muka2" && sales !== undefined && sales !== null && (
                    <div className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        SURAT PENGAKUAN KEKURANGAN BAYAR UANG MUKA
                      </div>

                      <div style={{ padding: "10px" }}>
                        <div style={{ marginBottom: "10px" }}>Saya yang bertanda tangan di bawah ini:</div>
                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
                          <tbody style={{ border: "1px solid black" }}>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Tempat, Tanggal Lahir</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>
                                {info.sls_appl?.birth_place ?? ""} , {handleValidDate(info.sls_appl?.birthat) ?? ""}
                              </td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Pekerjaan</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>No. KTP</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div style={{ marginTop: "10px" }}>Dengan ini menyatakan bahwa saya telah melakukan pembayaran uang muka sebesar Rp.......................................................... (..............................................................) dan masih memiliki kekurangan bayar Uang Muka sebesar ..........................................................) untuk pembelian Rumah Sejahtera Tapak kepada:</div>

                        <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
                          <tbody style={{ border: "1px solid black" }}>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama</td>
                              <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.name ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Tempat, Tanggal Lahir</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>
                                {info.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(info.sls_appl?.birthat_spouse) ?? ""}
                              </td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>Pekerjaan</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.job_desc ?? "-"}</td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td style={{ padding: "4px 6px" }}>No. KTP</td>
                              <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                              <td style={{ padding: "4px 6px" }}>{info.sls_appl?.identity ?? "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <p style={{ marginTop: "20px" }}>Jika permohonan SBUM saya tidak disetujui, maka saya bersedia untuk membayar kekurangan uang muka pembelian rumah sejahtera tapak menggunakan dana sendiri.</p>
                        <p>Demikian kami sampaikan, atas perhatiannya kami ucapkan terima kasih.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "80%",
                            border: "1px solid black",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  width: "50%",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                }}
                              >
                                Menyetujui,
                                <br />
                                (DIREKTUR UTAMA)
                                <br />
                                <br />
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px 12px",
                                  verticalAlign: "top",
                                  textAlign: "center",
                                }}
                              >
                                ......................, tanggal ................ 20...
                                <br />
                                <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                                <br /> <span style={{ fontWeight: "bold" }}>PEMOHON</span> <br /> <br />
                              </td>
                            </tr>

                            {/* Kotak Materai */}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "38px 12px 8px 12px",
                                  verticalAlign: "top",
                                }}
                              >
                                {/* Kosong untuk tanda tangan kiri */}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    border: "1px solid black",
                                    width: "140px",
                                    height: "80px",
                                    top: "-20px",
                                    left: "50%",
                                    padding: "10px",
                                    fontSize: "12px",
                                    textAlign: "center",
                                    position: "absolute",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "white",
                                  }}
                                >
                                  Meterai
                                  <br />
                                  Rp. 10.000,-
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                Ttd dan Cap Perusahaan <br />
                                ( ..................................................... )
                                <br />
                                <span style={{ fontWeight: "bold" }}>ANGGA BUDI KUSUMA</span>
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "40px 12px 8px 12px",
                                  verticalAlign: "bottom",
                                  textAlign: "center",
                                }}
                              >
                                ( ..................................................... )
                                <br />
                                {info.sls_appl?.name ?? "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalDetail(false);
                        }}
                      >
                        TUTUP
                      </button>
                      {detailType !== "detail" && (
                        <>
                          {detailType === "spr" && <ButtonPrintSPR innerRef={printRef} title={`SPR-${info.sales_customer?.name ?? ""}`} />}
                          {(detailType === "slp_pk" || detailType === "slp_pk_notaris") && <ButtonPrintSLP innerRef={printRef} title={`SLP-${info.sales_customer?.name ?? ""}`} />}
                          {(detailType === "spd_bangunan" || detailType === "spd_elektronik" || detailType === "spd_pbg" || detailType === "spd_pbt") && <ButtonPrintSPD innerRef={printRef} title={`SPD-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "verifikasi" && <ButtonPrint innerRef={printRef} title={`VERIFIKASI-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "form_wawancara" && <ButtonPrintWawancara innerRef={printRef} title={`WAWANCARA-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "bast" && <ButtonPrintBAST innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "surat_prasarana" && <ButtonPrintPrasarana innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "surat_pernyataan_data" && <ButtonPrintPenyerahanData innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "surat_kuasa_debet" && <ButtonPrintKuasaDebet innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "sbum" && <ButtonPrintSBUM innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "standing_instruction" && <ButtonPrintStandingIntruction innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "surat_kekurangan_uang_muka" && <ButtonPrintKekuranganUangMuka innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "kelompok_sasaran" && <ButtonPrintKelompokSasaran innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "pernyataan_verivikasi" && <ButtonPrintPernyataanVerifikasi innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "daftar_kpr_subsidi" && <ButtonPrintDaftarKPRSubsidi innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "flpp_ta" && <ButtonPrintFLPP innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "pernyataan_developer" && <ButtonPrintPeryataanDevelover innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "batasan_harga_jual_rumah" && <ButtonPrintBatasanHargaJualRumah innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "permohonan_kpr_subsidi" && <ButtonPrintPermohonanKPRSubsidi innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "penyerahan_spt_pph" && <ButtonPrintPenyerahanSPTPPH innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "bast_rumah_umum_tapak" && <ButtonPrintBASTRunahUmumTapak innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "bast_sarusun_umum" && <ButtonPrintBASTSarusunUmum innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "pernyataan_verivikasi_2" && <ButtonPrintPernyataanVerifikasi2 innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "permohonan_kpr_subsidi2" && <ButtonPrintPermohonanKPRSubsidi2 innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "surat_kuasa_bphtb" && <ButtonPrintSuratKuasaBPHTB innerRef={printRef} title={`SURAT-KUASA-BPHTB-${(info || sales)?.sls_appl?.name ?? ""}`} />}
                          {detailType === "surat_kuasa" && <ButtonPrintSuratKuasa innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "stiker_plat_kpr" && <ButtonPrintStikerPlatKPR innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "sbum2" && <ButtonPrintSBUM2 innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                          {detailType === "surat_kekurangan_uang_muka2" && <ButtonPrintKekuranganUangMuka2 innerRef={printRef} title={`BAST-${info.sales_customer?.name ?? ""}`} />}
                        </>
                      )}
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalHistory" isOpen={modalHistory} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleHistory}>
                    Riwayat Penjualan
                  </ModalHeader>
                  <ModalBody>
                    <div className="profile-timeline">
                      <div className="accordion accordion-flush" id="todayExample">
                        {info &&
                          info.sales_history &&
                          info.sales_history.map((item, i) => {
                            return (
                              <div key={i} className="accordion-item border-0">
                                <div className="accordion-header">
                                  <button className="accordion-button p-2 shadow-none" type="button" id="headingOne">
                                    <div className="d-flex">
                                      <div className="flex-shrink-0">
                                        {item?.sales_history_createdby && item?.sales_history_createdby?.image && item?.sales_history_createdby?.image?.path ? (
                                          <img src={`${api.MEDIA_URL}/media/${item?.sales_history_createdby?.image}-w-150`} alt="" className="rounded-circle avatar-xs" />
                                        ) : (
                                          <div className="flex-shrink-0 avatar-xs">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item?.sales_history_createdby?.name.charAt(0)}</div>
                                          </div>
                                        )}
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <h6 className="fs-14 mb-1">{item?.sales_history_createdby?.name}</h6>
                                        <p className="fw-normal text-muted mb-1">
                                          Memperbarui status penjualan menjadi <span className="fw-semibold text-info">{item.sales_history_status && item?.sales_history_status?.name}</span> dan progress KPR menjadi
                                          <span className="fw-semibold ms-2 text-success">{item.sales_history_status_deal && item.sales_history_status_deal.name}</span> dengan catatan:
                                        </p>
                                        <p className="fw-normal mb-1">{item.comment || "-"}</p>
                                        <small className="text-muted">
                                          <span className="text-dark">{handleValidDate(item.createdat)}</span> {moment.utc(item.createdat).local().fromNow()}
                                        </small>
                                      </div>
                                    </div>
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalHistory(false);
                        }}
                      >
                        Tutup
                      </button>
                    </div>
                  </div>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
                <ModalInputFile onSelect={handleSelectFileCustomer} loading={loading} modal={modalMediaCustomer} toggle={toggleMediaCustomer} />
                <ModalInputFile onSelect={handleSelectFileApplicationDoc} loading={loading} modal={modalMediaApplicationDoc} toggle={toggleMediaApplicationDoc} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        {detailType === "spr" && <PrintDocSPR innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {(detailType === "slp_pk" || detailType === "slp_pk_notaris") && <PrintDocSLP innerRef={printRef} item={info} type={detailType} />}
        {(detailType === "spd_bangunan" || detailType === "spd_elektronik" || detailType === "spd_pbg" || detailType === "spd_pbt") && <PrintDocSPD innerRef={printRef} item={info} type={detailType} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "verifikasi" && <PrintDoc innerRef={printRef} item={info} />}
        {detailType === "receipt" && <PrintDocReceipt innerRef={printRef} code={receiptCode} amount={receiptAmount} date={receiptDate} note={receiptNote} name={receiptName} branchCode={branchCode} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "form_wawancara" && <PrintDocWawancara innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "bast" && <PrintDocBAST innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "surat_prasarana" && <PrintDocPrasarana innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "surat_pernyataan_data" && <PrintDocPenyerahanData innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "surat_kuasa_debet" && <PrintDocKuasaDebet innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "sbum" && <PrintDocSBUM innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "standing_instruction" && <PrintDocStandingIntruction innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "surat_kekurangan_uang_muka" && <PrintDocKekuranganUangMuka innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "kelompok_sasaran" && <PrintDocKelompokSasaran innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "pernyataan_verivikasi" && <PrintDocPernyataanVerifikasi innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "daftar_kpr_subsidi" && <PrintDocDaftarKPRSubsidi innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "flpp_ta" && <PrintDocFLPP innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "pernyataan_developer" && <PrintDocPeryataanDevelover innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "batasan_harga_jual_rumah" && <PrintDocBatasanHargaJualRumah innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "permohonan_kpr_subsidi" && <PrintDocPermohonanKPRSubsidi innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "penyerahan_spt_pph" && <PrintDocPenyerahanSPTPPH innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "bast_rumah_umum_tapak" && <PrintDocBASTRunahUmumTapak innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "bast_sarusun_umum" && <PrintDocBASTSarusunUmum innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "pernyataan_verivikasi_2" && <PrintDocPernyataanVerifikasi2 innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "permohonan_kpr_subsidi2" && <PrintDocPermohonanKPRSubsidi2 innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "surat_kuasa_bphtb" && <PrintDocSuratKuasaBPHTB innerRef={printRef} item={info || sales} preview={false} />}
        {detailType === "surat_kuasa" && <PrintDocSuratKuasa innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "stiker_plat_kpr" && <PrintDocStikerPlatKPR innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "sbum2" && <PrintDocSBUM2 innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
        {detailType === "surat_kekurangan_uang_muka2" && <PrintDocKekuranganUangMuka2 innerRef={printRef} item={info} companyName={companySelected?.label} companyValue={companySelected?.value} />}
      </Container>
      {(salesList || []).map((o, i) => {
        return (
          <div key={i} className="d-none">
            {(o.sales_trans || []).map((oo, idx) => {
              return (
                <p id={"sl" + oo.transaction_no} key={idx}>
                  <QRCodeSVG value={`https://pkg.pkdeveloper.id/qr/sl${oo.transaction_no}-${companySelected?.value}`} size={90} bgColor={"#ffffff"} fgColor={"#000000"} level={"L"} />
                </p>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
Sales.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Sales));
